import React, { useEffect, useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { Modal, Form } from "react-bootstrap";
import { BASE_URL, TESTING_URL, IMAGE_URL } from "../../../config/axios";
import { AddwithBlueCircle, AddwithWhiteCircle, Attachment, DeleteDustbin, DropdownArrowOption, UploadIcon, DownloadIcon, CloudUpload, Eye, Wallet, Office, Filter, CrosswithRedCircle, CrosswithGreyCircle, Arrow, CheckTick, WarnYellow, CrossRed, RunPayrollIcon, WarningIcon } from "../../AllSvg";
import { ButtonVariants, customSortByKey, formatCurrencyIndian, formatRoundoffComplete, getFileNameFromLink, handleAllError, handleErrorToast, ViewOtherFile, formatCurrency, CustomImageModal, ActionableAlert } from "../../CustomFunctions";
import { UpdatePencil, ImportantNotesIcon } from "../../AllSvg";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import * as XLSX from 'xlsx';
import usePermission from "../../../config/permissions";
import Loader from "../../Loader";
import { formatDate, formattedDate } from "../../Date";
import { monthNames } from "../../CustomUtilities";
// import { XCircle, CheckCircle, AlertCircle, SkipForward, Download } from 'lucide-react';
import { PAYRUN_OPERATION } from "../../constants/payrunOperations";
import UserDefaultLogo from "../UserDefaultLogo";
import { getResultCardStyle } from "../../../style/CustomFunctionForCss";


// Remove after testing

// const UploadSalaryDataBulk = ({ id, getPayrunlist }) => {
//     const [show, setShow] = useState(false);
//     const handleShow = () => setShow(true);


//     const [fileName, setFileName] = useState("");
//     const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
//     const [docErrors, setDocErrors] = useState({});
//     const [docInputState, setDocInputState] = useState({});

//     const [jsonData, setJsonData] = useState(null);


//     const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);


//     useEffect(() => {
//         getAllSalaryRelatedData();
//     }, []);

//     const getAllSalaryRelatedData = async (emp_code) => {
//         try {


//             const headings = await axios.get(`${BASE_URL}/wfm/salaryHeadingbysubcompany/${sessionStorage.getItem("company_id")}/`);
//             setSalaryStructureHeadings(headings.data);

//         } catch (err) {
//             console.error("Error fetching salary data", err);
//         }
//     };

//     const bulktableRef = useRef(null);
//     const handleDownload = () => {
//         const table = bulktableRef.current;
//         const wb = XLSX.utils.table_to_book(table, { sheet: "Salary Sheet" });
//         const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

//         const blob = new Blob([s2ab(wbout)], {
//             type: "application/vnd.ms-excel",
//         });
//         const url = window.URL.createObjectURL(blob);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = "Salary Sheet Format.xls";
//         a.click();
//         window.URL.revokeObjectURL(url);
//     };

//     const s2ab = (s) => {
//         const buf = new ArrayBuffer(s.length);
//         const view = new Uint8Array(buf);
//         for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
//         return buf;
//     };


//     const handleClose = () => {
//         setFileName("")
//         setExcelJson(null)
//         setDocErrors({})
//         setShow(false)
//     };

//     const handleFileUpload = (event) => {
//         const file = event.target.files[0];
//         console.log(file)
//         if (file) {
//             const reader = new FileReader();
//             reader.onload = (e) => {
//                 const data = new Uint8Array(e.target.result);

//                 const workbook = XLSX.read(data, { type: 'array' });

//                 console.log("workbook")
//                 console.log(workbook)

//                 const worksheet = workbook.Sheets['Salary Sheet'];

//                 const rawData = XLSX.utils.sheet_to_json(worksheet);
//                 console.log("rawData")
//                 console.log(rawData)
//                 // Transform rawData into the required format for uploading

//                 setJsonData(rawData);
//             };
//             reader.readAsArrayBuffer(file);
//             setFileName(file.name);
//         }
//     };

//     const [loading, setLoading] = useState(false); //loading logic
//     const handleSubmit = async () => {
//         setLoading(true); //loading logic
//         const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
//         if (!jsonData) {
//             alert("Please upload an Excel file first!");
//             return;
//         }
//         try {
//             const response = await axios.post(`${BASE_URL}/wfm/bulkcustomdeductionupload/`, jsonData);
//             toast.success('Salary uploaded successfully!');
//             await getPayrunlist()
//             handleClose()
//         } catch (error) {
//             console.error('Error uploading salary:', error);
//             toast.err('Error uploading Salary Structures.');
//         } finally {
//             setLoading(false); //loading logic
//             toast.dismiss(loadingToastId);
//         }
//     };

//     const [allEmployeeList, setAllEmployeeList] = useState([]);
//     const [buffer, setBuffering] = useState(true);

//     useEffect(() => {
//         getAllEmployeeData();
//     }, []);

//     let getAllEmployeeData = async () => {
//         setBuffering(true); //buffering logic
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/wfm/ourcompanyempdetailsactive/${sessionStorage.getItem("company_id")}/`
//             );

//             const sortedList = customSortByKey(res.data, "emp_code");

//             setAllEmployeeList(sortedList);
//             // setAllEmployeeList(res.data);
//         } catch (err) {
//             //toast Logic
//             handleErrorToast(err);

//         } finally {
//             setBuffering(false); //buffering logic
//         }
//     };


//     const [selectedIndex, setSelectedIndex] = useState(-1);

//     const handleClick = (index) => {
//         setSelectedIndex(index);
//     };

//     const tableRef = useRef(null);





//     return (
//         <>
//             <button
//                 title="Bulk Upload Salary Data"
//                 className="model-button font-weight500 model-button-print"
//                 onClick={handleShow}
//                 style={{ margin: "2px" }}
//             >
//                 <UploadIcon />
//             </button>

//             <Modal show={show} dialogClassName="ourcompany-model">
//                 <Modal.Header className="task-Tab-heading font-weight500    font-size-heading ">
//                     <Modal.Title>Upload Bulk Salary Data in Format:</Modal.Title>

//                     <button onClick={handleDownload} className="model-button-download model-button font-weight500" style={{ marginLeft: "35vw" }}>
//                         <DownloadIcon />
//                         {"  "} Format
//                     </button>
//                 </Modal.Header>
//                 <Modal.Body>


//                     <div className="table-css-white-background" style={{ display: "none" }}>
//                         <table
//                             ref={bulktableRef}
//                             id="my-table"
//                             style={{
//                                 borderColor: "#323232",
//                                 borderRadius: "5px",
//                                 padding: "0px 5px",
//                                 borderWidth: "1px",
//                                 // marginLeft: "10px",
//                                 // zoom: "70%",
//                             }}
//                         >
//                             <thead                            >
//                                 <tr>
//                                     <th className="summary-excel-tab br-5">emp_code</th>
//                                     <th className="summary-excel-tab br-5">name</th>
//                                     {salaryStructureHeadings.sort((a, b) => a.sorting_var - b.sorting_var).map((heading) => (
//                                         <React.Fragment key={heading.id}>
//                                             <th>{heading.title} fixed_amount</th>
//                                             <th>{heading.title} percentage</th>
//                                             <th>{heading.title} percentage_of</th>
//                                         </React.Fragment>
//                                     ))}
//                                 </tr>
//                             </thead>
//                             {
//                                 // buffer ? <div className="spinner"></div> :
//                                 <tbody>
//                                     {allEmployeeList
//                                         .sort((a, b) => a.emp_code - b.emp_code)
//                                         .map((data, index) => {
//                                             const inactivename = data.employee_status === "inactive" ? "#ff1212" : "black";
//                                             return (
//                                                 <>
//                                                     <tr
//                                                         style={{
//                                                             backgroundColor:
//                                                                 index === selectedIndex ? "yellow" : "white",
//                                                             color: inactivename,
//                                                         }}
//                                                         onClick={() => handleClick(index)}
//                                                     >
//                                                         <td className="summary-excel-tab br-5">{data.emp_code}</td>
//                                                         <td className="summary-excel-tab br-5">{data.name}</td>
//                                                     </tr>
//                                                 </>
//                                             );
//                                         })}
//                                 </tbody>
//                             }
//                         </table>

//                     </div>



//                     <div className="flex-column field-cont-div">
//                         <label htmlFor="document_file" className="form-labels font-weight500 font-size-heading">
//                             Upload File
//                         </label>
//                         <label
//                             htmlFor="document_file"
//                             className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
//                                 }`}
//                         >
//                             <div className={`align-center pdf-input  ${docErrors.document_file ? 'error' : ''}`}>
//                                 <Attachment />
//                             </div>
//                         </label>
//                         <input
//                             type="file"
//                             accept=".xlsx, .xls"
//                             onChange={handleFileUpload}
//                             id="document_file"
//                             name="document_file"
//                             className="file-inputs align-center"
//                             style={{ display: "none", position: "relative" }} />
//                         {fileName && <p className="file-name align-center">{fileName}</p>}
//                         <br />
//                         {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
//                     </div>

//                     <div className="button-models">
//                         <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
//                             Cancel
//                         </button>
//                         <button className="model-button-download model-button font-weight500" onClick={handleSubmit} disabled={loading}>
//                             <UploadIcon />
//                             {"  "} {loading ? "Uploading..." : "Upload"}
//                         </button>
//                     </div>
//                 </Modal.Body>
//             </Modal>
//             <ToastContainer position="top-center" autoClose={10000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         </>
//     );
// };

// // Multiple Employee Salary Update
// const UpdateSalaryDataBulk = ({ id, getPayrunlist }) => {
//     const [show, setShow] = useState(false);

//     const handleShow = () => {
//         // toast.warning("Please Select Subcompany First");
//         getAllSalaryRelatedData();
//         getAllEmployeeData();
//         setShow(true)
//     };
//     const handleClose = () => {
//         setFileName("")
//         setExcelJson(null)
//         setJsonData(null);
//         setDocInputState({});
//         setDocErrors({})
//         setShow(false)
//     };

//     const { SUB_COMPANIES } = usePermission();
//     const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));


//     const [fileName, setFileName] = useState("");
//     const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
//     const [docErrors, setDocErrors] = useState({});
//     const [docInputState, setDocInputState] = useState({});

//     const [jsonData, setJsonData] = useState(null);

//     const [allEmployeeList, setAllEmployeeList] = useState([]);
//     const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);

//     const [buffer1, setBuffering1] = useState(true);
//     const [buffer2, setBuffering2] = useState(true);


//     const getAllSalaryRelatedData = async (emp_code) => {
//         setBuffering1(true); //buffering logic
//         try {
//             const headings = await axios.get(`${BASE_URL}/wfm/salaryHeadingbysubcompany/${toggleCompany}/`);
//             setSalaryStructureHeadings(headings.data);

//         } catch (err) {
//             console.error("Error fetching salary data", err);
//         } finally {
//             setBuffering1(false); //buffering logic
//         }
//     };



//     let getAllEmployeeData = async () => {
//         setBuffering2(true); //buffering logic
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
//             );
//             const sortedList = customSortByKey(res.data, "emp_code");
//             setAllEmployeeList(sortedList);
//         } catch (err) {
//             handleErrorToast(err);
//             console.error("Error fetching Employee data", err);

//         } finally {
//             setBuffering2(false); //buffering logic
//         }
//     };


//     const bulktableRef = useRef(null);

//     const handleFileUploadToJson = (event) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         const reader = new FileReader();
//         reader.onload = (e) => {
//             try {
//                 const data = new Uint8Array(e.target.result);
//                 const workbook = XLSX.read(data, { type: 'array' });

//                 // Get the first sheet
//                 const sheetName = workbook.SheetNames[0];
//                 // const worksheet = workbook.Sheets[sheetName];
//                 const worksheet = workbook.Sheets['Salary Format'];

//                 // Convert to JSON with header row
//                 const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

//                 if (jsonData.length < 2) {
//                     toast.error("Excel file is empty or has no data");
//                     return;
//                 }

//                 // Extract headers (first row)
//                 const headers = jsonData[0];

//                 // Process data rows (skip header row)
//                 const processedData = jsonData.slice(1).map(row => {
//                     const rowData = {};
//                     headers.forEach((header, index) => {
//                         rowData[header] = row[index] !== undefined ? row[index] : null;
//                     });
//                     return rowData;
//                 });

//                 console.log("processedData")
//                 console.log(processedData)

//                 // Extract component names in original column order
//                 const componentNames = [];
//                 const seenComponents = new Set();

//                 headers.forEach(header => {
//                     if (header === 'emp_code' || header === 'name') return;

//                     // Extract base component name (remove suffix)
//                     const componentName = header.replace(/ (fixed_amount|percentage|percentage_of)$/, '');

//                     if (!seenComponents.has(componentName)) {
//                         seenComponents.add(componentName);
//                         componentNames.push(componentName);
//                     }
//                 });

//                 // Transform data for API
//                 const transformedData = processedData.map(row => {
//                     const employeeData = {
//                         emp_code: row.emp_code,
//                         name: row.name,
//                         salary_components: []
//                     };

//                     componentNames.forEach(component => {
//                         const fixedAmount = row[`${component} fixed_amount`];
//                         const percentage = row[`${component} percentage`];
//                         const percentageOf = row[`${component} percentage_of`];

//                         if (fixedAmount !== null || percentage !== null || percentageOf !== null) {
//                             employeeData.salary_components.push({
//                                 name: component,
//                                 fixed_amount: fixedAmount !== null ? Number(fixedAmount) : null,
//                                 percentage: percentage !== null ? Number(percentage) : null,
//                                 percentage_of: percentageOf
//                                     ? percentageOf.split(', ').map(item => ({ name: item.trim() }))
//                                     : []
//                             });
//                         }
//                     });

//                     return employeeData;
//                 });

//                 console.log("transformedData");
//                 console.log(transformedData);
//                 setJsonData({
//                     rawData: processedData, // Original Excel data
//                     transformedData, // Data formatted for API
//                     componentNames, // Components in original order
//                     headers // All headers for reference
//                 });

//                 setFileName(file.name);
//             } catch (error) {
//                 console.error("Error processing file:", error);
//                 toast.error("Error processing Excel file. Please check the format.");
//             }
//         };
//         reader.readAsArrayBuffer(file);
//     };

//     const handleFileUpload = (event) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         const reader = new FileReader();
//         reader.onload = (e) => {
//             try {
//                 const data = new Uint8Array(e.target.result);
//                 const workbook = XLSX.read(data, { type: 'array' });

//                 // Get the first sheet (default to first sheet if 'Salary Format' doesn't exist)
//                 const sheetName = workbook.SheetNames.includes('Salary Format')
//                     ? 'Salary Format'
//                     : workbook.SheetNames[0];
//                 const worksheet = workbook.Sheets[sheetName];

//                 // Convert to JSON with header row
//                 const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

//                 console.log("jsonData");
//                 console.log(jsonData);

//                 if (jsonData.length < 2) {
//                     toast.error("Excel file is empty or has no data");
//                     return;
//                 }

//                 // Extract headers (first row)
//                 const headers = jsonData[0];

//                 // Process data rows (skip header row)
//                 const transformedData = jsonData.slice(1).map(row => {
//                     const employeeData = {
//                         emp_code: row[headers.indexOf('emp_code')],
//                         name: row[headers.indexOf('name')]
//                     };

//                     // Add all other fields exactly as they appear in Excel
//                     headers.forEach(header => {
//                         if (header !== 'emp_code' && header !== 'name') {
//                             const value = row[headers.indexOf(header)];
//                             employeeData[header] = value !== undefined ? value : null;

//                             // Convert numbers from strings if needed
//                             if (typeof employeeData[header] === 'string' && !isNaN(employeeData[header])) {
//                                 employeeData[header] = parseFloat(employeeData[header]);
//                             }
//                         }
//                     });

//                     return employeeData;
//                 });

//                 console.log("transformedData");
//                 console.log(transformedData);

//                 const componentNames = [];
//                 const seenComponents = new Set();

//                 headers.forEach(header => {
//                     if (header === 'emp_code' || header === 'name') return;

//                     // Extract base component name (remove suffix)
//                     const componentName = header.replace(/ (fixed_amount|percentage|percentage_of)$/, '');

//                     if (!seenComponents.has(componentName)) {
//                         seenComponents.add(componentName);
//                         componentNames.push(componentName);
//                     }
//                 });

//                 setJsonData({
//                     rawData: jsonData, // Original Excel data including headers
//                     transformedData, // Data in flat format matching Excel structure
//                     componentNames, // Components in original order
//                     headers // All headers for reference
//                 });

//                 setFileName(file.name);
//             } catch (error) {
//                 console.error("Error processing file:", error);
//                 toast.error("Error processing Excel file. Please check the format.");
//             }
//         };
//         reader.readAsArrayBuffer(file);
//     };

//     const handleFileClear = () => {
//         setFileName("")
//         setExcelJson(null)
//         setJsonData(null);
//         setDocInputState({});
//         setDocErrors({})
//     };

//     const [loading, setLoading] = useState(false); //loading logic

//     const handleSubmit = async () => {
//         if (!jsonData?.transformedData) {
//             alert("Please upload an Excel file first!");
//             return;
//         }

//         if (jsonData) {
//             const cleanedData = jsonData.transformedData.map(row => {
//                 const cleanedRow = {};
//                 Object.keys(row).forEach(key => {
//                     if (row[key] !== null && row[key] !== undefined && row[key] !== '') {
//                         cleanedRow[key] = row[key];
//                     }
//                 });
//                 return cleanedRow;
//             });

//             console.log('Cleaned data---', cleanedData);

//             const loadingToastId = toast.loading("Loading: Please wait...");
//             setLoading(true);

//             try {
//                 const response = await axios.post(
//                     `${BASE_URL}/wfm/bulkcustomdeductionupdate/overwrite/test/`,
//                     cleanedData
//                 );

//                 if (response.status === 200 || response.status === 201) {
//                     toast.success('Salary uploaded successfully!');
//                     await getPayrunlist();
//                     handleClose();
//                 }
//             } catch (error) {
//                 console.error('Error uploading salary:', error);
//                 toast.error('Error uploading Salary Structures.');
//             } finally {
//                 setLoading(false);
//                 toast.dismiss(loadingToastId);
//             }
//         }
//     };

//     return (
//         <>
//             <button
//                 title="Bulk Upload Salary Data"
//                 className="model-button font-weight500 model-button-print"
//                 onClick={handleShow}
//                 style={{ margin: "2px" }}
//             >
//                 <CloudUpload />
//             </button>

//             <Modal show={show} dialogClassName="ourcompany-model">
//                 <Modal.Header className="task-Tab-heading font-weight500    font-size-heading ">
//                     <Modal.Title>Bulk Update Salary Data in Format:</Modal.Title>
//                     <div>
//                         <div className="flex-row">
//                             <DownloadSalaryBulkFormat />
//                         </div>
//                     </div>

//                 </Modal.Header>
//                 <Modal.Body>

//                     <div
//                         className="table-css-white-background"
//                         style={{ display: "none" }}
//                     >
//                         <table
//                             ref={bulktableRef}
//                             id="my-table"
//                             style={{
//                                 borderColor: "#323232",
//                                 borderRadius: "5px",
//                                 padding: "0px 5px",
//                                 borderWidth: "1px",
//                                 // marginLeft: "10px",
//                                 // zoom: "70%",
//                             }}
//                         >
//                             <thead                            >
//                                 <tr>
//                                     <th className="summary-excel-tab br-5">emp_code</th>
//                                     <th className="summary-excel-tab br-5">name</th>
//                                     {salaryStructureHeadings.sort((a, b) => a.sorting_var - b.sorting_var).map((heading) => (
//                                         <React.Fragment key={heading.id}>
//                                             <th>{heading.title} fixed_amount</th>
//                                             <th>{heading.title} percentage</th>
//                                             <th>{heading.title} percentage_of</th>
//                                         </React.Fragment>
//                                     ))}
//                                 </tr>
//                             </thead>
//                             {
//                                 // buffer ? <div className="spinner"></div> :
//                                 <tbody>
//                                     {allEmployeeList
//                                         .sort((a, b) => a.emp_code - b.emp_code)
//                                         .map((data, index) => {
//                                             const inactivename = data.employee_status === "inactive" ? "#ff1212" : "black";
//                                             return (
//                                                 <>
//                                                     <tr
//                                                         style={{
//                                                             color: inactivename,
//                                                         }}
//                                                     >
//                                                         <td className="summary-excel-tab br-5">{data.emp_code}</td>
//                                                         <td className="summary-excel-tab br-5">{data.name}</td>
//                                                     </tr>
//                                                 </>
//                                             );
//                                         })}
//                                 </tbody>
//                             }
//                         </table>
//                     </div>


//                     <div className="flex-column field-cont-div">
//                         <label htmlFor="document_file" className="form-labels font-weight500 font-size-heading">
//                             Upload File
//                         </label>
//                         <div className="flex-row">
//                             <div>

//                                 <label
//                                     htmlFor="document_file"
//                                     className={`align-center custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
//                                         }`}
//                                     style={{ cursor: 'pointer' }}
//                                 >
//                                     <div className={`align-center pdf-input  ${docErrors.document_file ? 'error' : ''}`}>
//                                         <Attachment />
//                                     </div>
//                                 </label>
//                                 <input
//                                     type="file"
//                                     accept=".xlsx, .xls"
//                                     onChange={handleFileUpload}
//                                     id="document_file"
//                                     name="document_file"
//                                     className="align-center"
//                                     style={{ display: "none", position: "relative" }} />
//                             </div>
//                             {fileName && <p className="file-name align-center">{fileName}</p>}
//                             {fileName && <div>
//                                 <button className="model-button" onClick={handleFileClear}>Clear</button>
//                             </div>}
//                         </div>
//                         <br />
//                         {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}

//                     </div>


//                     {jsonData && (
//                         <div>
//                             <h4>Salary Structure Data Preview</h4>
//                             <div className="scroll-container-table" style={{ maxHeight: '600px', overflowY: 'auto' }}>
//                                 <table className="scrollfix-table-css">
//                                     <thead>
//                                         <tr className="custom-table-head-tr">
//                                             <th rowSpan="2" className="sticky-header">Emp Code</th>
//                                             <th rowSpan="2" className="sticky-header">Name</th>

//                                             {/* Dynamic column groups */}
//                                             {jsonData.componentNames?.map(component => (
//                                                 <th colSpan="3" className="section-header" key={component}>
//                                                     {component}
//                                                 </th>
//                                             ))}
//                                         </tr>
//                                         <tr className="custom-table-head-tr">
//                                             {/* Subheaders */}
//                                             {jsonData.componentNames?.flatMap(component => [
//                                                 <th key={`${component}-fixed`} className="sub-header">Fixed</th>,
//                                                 <th key={`${component}-percent`} className="sub-header">%</th>,
//                                                 <th key={`${component}-of`} className="sub-header">Of</th>
//                                             ])}
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {jsonData.transformedData?.map((row, index) => (
//                                             <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white' }}>
//                                                 <td>{row.emp_code}</td>
//                                                 <td>{row.name}</td>

//                                                 {/* Dynamic data cells */}
//                                                 {jsonData.componentNames?.flatMap(component => [
//                                                     <td key={`${component}-fixed`} className="align-right">
//                                                         {row[`${component} fixed_amount`] || '-'}
//                                                     </td>,
//                                                     <td key={`${component}-percent`} className="align-center">
//                                                         {row[`${component} percentage`] || '-'}
//                                                     </td>,
//                                                     <td key={`${component}-of`} className="align-left">
//                                                         {row[`${component} percentage_of`] || '-'}
//                                                     </td>
//                                                 ])}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     )}

//                     <div className="button-models">
//                         <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
//                             Cancel
//                         </button>
//                         <button className="model-button-download model-button font-weight500" onClick={handleSubmit} disabled={loading}>
//                             {/* <UploadIcon /> */}
//                             <CloudUpload />
//                             {"  "} {loading ? "Updating..." : "Update"}
//                         </button>
//                     </div>
//                 </Modal.Body >
//                 <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//             </Modal >
//         </>
//     );

// };


// const DownloadSalaryBulkFormat = () => {
//     const [show, setShow] = useState(false);

//     const handleShow = () => {
//         // toast.warning("Please Select Subcompany First");
//         getAllSalaryRelatedData();
//         getAllEmployeeData();
//         setShow(true)
//     };
//     const handleClose = () => {
//         setShow(false)
//     };

//     const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
//     const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));


//     const [allEmployeeList, setAllEmployeeList] = useState([]);
//     const [salaryDeductionPolicies, setSalaryDeductionPolicies] = useState([]);
//     const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);
//     const [selectedPolicy, setSelectedPolicy] = useState("null");
//     const [selectedPolicyData, setSelectedPolicyData] = useState({});
//     const [selectedPolicyDeductions, setSelectedPolicyDeductions] = useState([]);

//     const [showEmpData, setShowEmpData] = useState(false);
//     const [buffer1, setBuffering1] = useState(true);
//     const [buffer2, setBuffering2] = useState(true);


//     useEffect(() => {
//         getAllSalaryRelatedData();
//         getAllEmployeeData();
//     }, [toggleCompany]);

//     const getAllSalaryRelatedData = async (emp_code) => {
//         setBuffering1(true); //buffering logic
//         try {
//             const headings = await axios.get(`${BASE_URL}/wfm/salaryHeadingbysubcompany/${toggleCompany}/`);
//             setSalaryStructureHeadings(headings.data);
//             const policies = await axios.get(`${BASE_URL}/wfm/salarypolicybysubcompany/${toggleCompany}/`);
//             setSalaryDeductionPolicies(policies.data);
//         } catch (err) {
//             console.error("Error fetching salary data", err);
//         } finally {
//             setBuffering1(false); //buffering logic
//         }
//     };



//     let getAllEmployeeData = async () => {
//         setBuffering2(true); //buffering logic
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
//             );
//             const sortedList = customSortByKey(res.data, "emp_code");
//             setAllEmployeeList(sortedList);
//         } catch (err) {
//             // handleErrorToast(err);
//             console.error("Error fetching Employee data", err);

//         } finally {
//             setBuffering2(false); //buffering logic
//         }
//     };

//     const handlePolicySelect = (e) => {
//         const { value } = e.target;
//         setSelectedPolicy(value);

//         if (value === "null") {
//             setSelectedPolicyDeductions([]);
//             return;
//         }

//         const selected = salaryDeductionPolicies.find(
//             (format) => String(format.id) === String(value)
//         );
//         setSelectedPolicyData(selected);

//         if (selected) {
//             const transformedDeductions = selected.custom_deductions?.map((deduction) => ({
//                 ...deduction,
//                 // percentage_of: deduction.percentage_of.map((item) => ({
//                 //     id: item.name, // switch from item.id to item.name
//                 //     name: item.name_title || item.name, // fallback to name if title is missing
//                 //     title: item.name_title, // fallback to name if title is missing
//                 // })),
//             }));
//             setSelectedPolicyDeductions(transformedDeductions);
//         }
//     };


//     const bulkformattableRef = useRef(null);
//     const s2ab = (s) => {
//         const buf = new ArrayBuffer(s.length);
//         const view = new Uint8Array(buf);
//         for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
//         return buf;
//     };
//     const handleDownload = () => {
//         const table = bulkformattableRef.current;
//         const wb = XLSX.utils.table_to_book(table, { sheet: "Salary Format" });
//         const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

//         const blob = new Blob([s2ab(wbout)], {
//             type: "application/vnd.ms-excel",
//         });
//         const url = window.URL.createObjectURL(blob);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = `Salary Format-${selectedPolicyData.policy_name}-${selectedPolicyData.sub_company_title}.xls`;
//         a.click();
//         window.URL.revokeObjectURL(url);
//     };




//     const [loading, setLoading] = useState(false); //loading logic
//     // console.log("selectedPolicyDeductions;", selectedPolicyDeductions)

//     const orderedSalaryStructureHeadings = (() => {
//         const matchingHeadings = [];
//         const nonMatchingHeadings = [];

//         salaryStructureHeadings.forEach((heading) => {
//             const match = selectedPolicyDeductions.find(d => d.name === heading.id);
//             if (match) {
//                 matchingHeadings.push({ ...heading, match_sort: match.sorting_var || 0 });
//             } else {
//                 nonMatchingHeadings.push(heading);
//             }
//         });

//         matchingHeadings.sort((a, b) => a.match_sort - b.match_sort);
//         nonMatchingHeadings.sort((a, b) => a.sorting_var - b.sorting_var);

//         return [...matchingHeadings, ...nonMatchingHeadings];
//     })();



//     return (
//         <>
//             <button
//                 title="Bulk Salary Format Download"
//                 className="model-button-download model-button font-weight500"
//                 onClick={handleShow}
//                 style={{ margin: "2px" }}
//             >
//                 <DownloadIcon />
//                 {"  "} Format
//             </button>



//             <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
//                 <Modal.Header closeButton className="task-Tab-heading font-weight500    font-size-heading ">
//                     <Modal.Title>Download Bulk Salary Data Format:</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>

//                     <div className="form-flex-wrap">
//                         {SUPER_ADMIN && <div>
//                             <label htmlFor="company" className="form-labels">
//                                 Select Company
//                             </label>
//                             <div className="table-searchh dropdown-container">
//                                 <Office />
//                                 <select
//                                     onChange={(e) => setToggleCompany(e.target.value)}
//                                     value={toggleCompany}
//                                     className="dropdown font-size-subheading"
//                                 >
//                                     <option value="null">Select SubCompany</option>
//                                     {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
//                                 </select>
//                             </div>
//                         </div>}

//                         <div>
//                             <label htmlFor="salary_policy" className="form-labels">
//                                 Select Salary Structure Format {selectedPolicyData !== "null" && <ViewSalaryPolicyFormatDeductions i={selectedPolicyData} />}
//                             </label>
//                             <div className="table-searchh dropdown-container">
//                                 {buffer1 ? <div className="spinner-vsmall"></div> : <Filter />}
//                                 <select
//                                     value={selectedPolicy}
//                                     onChange={handlePolicySelect}
//                                     className="dropdown font-size-subheading"

//                                 >
//                                     <option value="null">Select Statuary Deduction Policy</option>
//                                     {salaryDeductionPolicies?.map((i) => (
//                                         <option key={i.id} value={i.id}>{i.policy_name}</option>
//                                     ))}
//                                 </select>
//                             </div>
//                         </div>
//                         <div className="flex-row">
//                             <label className="form-labels">
//                                 With Employee {showEmpData ? "Shown" : "Hidden"} : {" "}
//                             </label>
//                             <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
//                             <div className="checkbox-toggle">
//                                 <input
//                                     type="checkbox"
//                                     id="toggle-employees"
//                                     name="show_emp_data"
//                                     checked={showEmpData}
//                                     onChange={() => setShowEmpData(!showEmpData)}
//                                 />
//                                 <label htmlFor="toggle-employees"></label>
//                             </div>
//                         </div>
//                     </div>


//                     {/* Downloading Format */}
//                     <h4>Preview Format Excel</h4>
//                     <div className="scroll-container-table" style={{ minHeight: '25vh', maxHeight: '50vh', overflowY: 'auto' }}>
//                         <table
//                             className="scrollfix-table-css"
//                             ref={bulkformattableRef}
//                             id="my-table"
//                             style={{
//                                 borderColor: "#323232",
//                                 borderRadius: "5px",
//                                 padding: "0px 5px",
//                                 borderWidth: "1px",
//                             }}
//                         >
//                             <thead>
//                                 <tr className="custom-table-head-tr">
//                                     <th className="summary-excel-tab br-5">emp_code</th>
//                                     <th className="summary-excel-tab br-5">name</th>
//                                     {
//                                         // salaryStructureHeadings.sort((a, b) => a.sorting_var - b.sorting_var)
//                                         orderedSalaryStructureHeadings
//                                             .map((heading) => (
//                                                 <React.Fragment key={heading.id}>
//                                                     <th className="summary-excel-tab br-5">{heading.title} fixed_amount</th>
//                                                     <th className="summary-excel-tab br-5">{heading.title} percentage</th>
//                                                     <th className="summary-excel-tab br-5">{heading.title} percentage_of</th>
//                                                 </React.Fragment>
//                                             ))}
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {showEmpData ? (
//                                     buffer2 ?
//                                         <div className="form-loader">
//                                             <div className="bar-loader"></div>
//                                         </div>
//                                         :
//                                         allEmployeeList
//                                             .sort((a, b) => a.emp_code - b.emp_code)
//                                             .map((data, index) => {
//                                                 const inactivename = data.employee_status === "inactive" ? "#ff1212" : "black";
//                                                 return (
//                                                     <tr style={{ color: inactivename }} key={index}>
//                                                         <td className="summary-excel-tab br-5">{data.emp_code}</td>
//                                                         <td className="summary-excel-tab br-5">{data.name}</td>
//                                                         {
//                                                             // salaryStructureHeadings.sort((a, b) => a.sorting_var - b.sorting_var)
//                                                             orderedSalaryStructureHeadings
//                                                                 .map((heading) => {
//                                                                     const matchingData = selectedPolicyDeductions.find(
//                                                                         (format) => format.name === heading.id
//                                                                     );
//                                                                     return (
//                                                                         <React.Fragment key={heading.id}>
//                                                                             <td className="summary-excel-tab br-5">
//                                                                                 {matchingData?.fixed_amount || ''}
//                                                                             </td>
//                                                                             <td className="summary-excel-tab br-5">
//                                                                                 {matchingData?.percentage || ''}
//                                                                             </td>
//                                                                             <td className="summary-excel-tab br-5">
//                                                                                 {matchingData?.percentage_of?.length > 0
//                                                                                     ? matchingData?.percentage_of.map(item => item.name_title).join(", ")
//                                                                                     : ''}
//                                                                             </td>
//                                                                         </React.Fragment>
//                                                                     )
//                                                                 })}
//                                                     </tr>
//                                                 );
//                                             })
//                                 ) : (
//                                     <tr>
//                                         <td className="summary-excel-tab br-5">[emp_code]</td>
//                                         <td className="summary-excel-tab br-5">[name]</td>
//                                         {
//                                             // salaryStructureHeadings.sort((a, b) => a.sorting_var - b.sorting_var)
//                                             orderedSalaryStructureHeadings
//                                                 .map((heading) => {
//                                                     const matchingData = selectedPolicyDeductions.find(
//                                                         (format) => format.name === heading.id
//                                                     );
//                                                     return (
//                                                         <React.Fragment key={heading.id}>
//                                                             <td className="summary-excel-tab br-5">
//                                                                 {matchingData?.fixed_amount || ''}
//                                                             </td>
//                                                             <td className="summary-excel-tab br-5">
//                                                                 {matchingData?.percentage || ''}
//                                                             </td>
//                                                             <td className="summary-excel-tab br-5">
//                                                                 {matchingData?.percentage_of?.length > 0
//                                                                     ? matchingData?.percentage_of.map(item => item.name_title).join(", ")
//                                                                     : ''}
//                                                             </td>
//                                                         </React.Fragment>
//                                                     )
//                                                 })}
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>




//                     <div className="button-models">
//                         <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
//                             Cancel
//                         </button>
//                         <button onClick={handleDownload} className="model-button-download model-button font-weight500" style={{ marginLeft: "35vw" }}>
//                             <DownloadIcon />
//                             {"  "} Format
//                         </button>
//                     </div>
//                 </Modal.Body>
//                 <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} draggable pauseOnHover />
//             </Modal>
//         </>
//     );
// };


// ==================================================

const BulkUpdateSalaryDataWithLog = ({ id, getPayrunlist }) => {

    const [show, setShow] = useState(false);
    const [showResults, setShowResults] = useState(false);
    const [apiResults, setApiResults] = useState(null);
    const [hasReadNotes, setHasReadNotes] = useState(false);
    const handleShow = () => {
        // getAllSalaryRelatedData();
        // getAllEmployeeData();
        setMaxWefPeriod(getCurrentMonthYear());
        setShow(true);
    };

    const handleClose = () => {
        setFileName("");
        setExcelJson(null);
        setJsonData(null);
        setDocInputState({});
        setDocErrors({});
        setData({
            wef_month: new Date().getMonth() + 1,
            wef_year: new Date().getFullYear(),
            change_reason: "Bulk salary update via Excel",
            partial: false,
            dry_run: false,
            updated_by: sessionStorage.getItem('emp_code'),
        });
        getPayrunlist()
        setShow(false);
    };

    const handleCloseResults = () => {
        setShowResults(false);
    };

    const handleComplete = () => {
        setShowResults(false);
        // Also close the main modal
        handleClose();
    };

    const handleRetry = () => {
        setShowResults(false);

        // Submit again with same values
        setTimeout(() => {
            handleSubmit();
        }, 500);
    };

    const handleActualBulkSubmit = () => {
        // Close results modal
        setShowResults(false);

        // Update data to non-dry-run mode
        setData(prev => ({
            ...prev,
            dry_run: false
        }));

        // Submit again
        setTimeout(() => {
            handleSubmit();
        }, 500);
    };




    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
    const [maxWefPeriod, setMaxWefPeriod] = useState('');

    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null);
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});


    const [jsonData, setJsonData] = useState(null);
    const [data, setData] = useState({
        wef_month: new Date().getMonth() + 1,
        wef_year: new Date().getFullYear(),
        change_reason: "Bulk salary update via Excel",
        partial: false,
        dry_run: false,
        updated_by: sessionStorage.getItem('emp_code'),
    });
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    // const [allEmployeeList, setAllEmployeeList] = useState([]);
    // const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);

    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);
    const [loading, setLoading] = useState(false);

    // Month names constant
    const MONTH_NAMES = [
        "",
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    const getCurrentMonthYear = () => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    };

    const bulktableRef = useRef(null);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });

                // Get the first sheet
                const sheetName = workbook.SheetNames.includes("Salary Format")
                    ? "Salary Format"
                    : workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];

                // Convert to JSON with header row
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                console.log("Excel raw data:", jsonData);

                if (jsonData.length < 2) {
                    toast.error("Excel file is empty or has no data");
                    return;
                }

                // Extract headers (first row)
                const headers = jsonData[0];

                // Process data rows (skip header row)
                const transformedData = jsonData.slice(1).map((row) => {
                    const employeeData = {};

                    headers.forEach((header, index) => {
                        let value = row[index];

                        // Handle empty cells
                        if (value === undefined || value === null || value === "") {
                            value = null;
                        }

                        // Convert numeric strings to numbers
                        if (typeof value === "string" && !isNaN(value) && value.trim() !== "") {
                            // Check if it's a percentage field
                            if (header.includes("percentage") && !header.includes("percentage_of")) {
                                value = parseFloat(value);
                            } else if (header.includes("fixed_amount")) {
                                value = parseFloat(value);
                            }
                        }

                        employeeData[header] = value;
                    });

                    return employeeData;
                });

                console.log("Transformed data:", transformedData);

                // Extract component names
                const componentNames = [];
                const seenComponents = new Set();

                headers.forEach((header) => {
                    if (header === "emp_code" || header === "name" || header === "wef_month" || header === "wef_year" || header === "change_reason") {
                        return;
                    }

                    // Extract base component name
                    const componentName = header.replace(/ (fixed_amount|percentage|percentage_of)$/, "");

                    if (!seenComponents.has(componentName)) {
                        seenComponents.add(componentName);
                        componentNames.push(componentName);
                    }
                });

                // Validate data
                const validationErrors = [];
                transformedData.forEach((row, index) => {
                    // Check required fields
                    if (!row.emp_code) {
                        validationErrors.push(`Row ${index + 2}: emp_code is missing`);
                    }

                    // Validate wef_month and wef_year if provided
                    if (row.wef_month !== undefined && row.wef_month !== null) {
                        const month = parseInt(row.wef_month);
                        if (isNaN(month) || month < 1 || month > 12) {
                            validationErrors.push(`Row ${index + 2}: Invalid wef_month (must be 1-12)`);
                        }
                    }

                    if (row.wef_year !== undefined && row.wef_year !== null) {
                        const year = parseInt(row.wef_year);
                        if (isNaN(year) || year < 2000 || year > 2100) {
                            validationErrors.push(`Row ${index + 2}: Invalid wef_year`);
                        }
                    }
                });

                if (validationErrors.length > 0) {
                    toast.error(`Validation errors found:\n${validationErrors.join("\n")}`);
                    return;
                }

                setJsonData({
                    rawData: jsonData,
                    transformedData,
                    componentNames,
                    headers,
                });

                setFileName(file.name);
                toast.success("File processed successfully");
            } catch (error) {
                console.error("Error processing file:", error);
                toast.error("Error processing Excel file. Please check the format.");
            }
        };
        reader.readAsArrayBuffer(file);
    };

    const handleFileClear = () => {
        setFileName("");
        setExcelJson(null);
        setJsonData(null);
        setDocInputState({});
        setDocErrors({});
        toast.info("File cleared");
    };

    // Add this validation function before handleSubmit
    const validateEffectivePeriod = (month, year) => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;

        const errors = {};

        if (!month || !year) {
            errors.effective_period = "Effective period is required";
        } else if (year > currentYear || (year === currentYear && month > currentMonth)) {
            errors.effective_period = "Effective period cannot be in the future";
        } else if (year < 2000 || year > 2100) {
            errors.effective_period = "Please select a valid year";
        } else if (month < 1 || month > 12) {
            errors.effective_period = "Please select a valid month";
        }

        return errors;
    };

    const handleSubmit = async () => {
        if (!jsonData?.transformedData) {
            toast.error("Please upload an Excel file first!");
            return;
        }

        // Validate global effective period
        const periodErrors = validateEffectivePeriod(data.wef_month, data.wef_year);
        if (Object.keys(periodErrors).length > 0) {
            setErrors(periodErrors);
            toast.error("Please fix the effective period errors before submitting");
            return;
        }
        if (!data.change_reason) {
            toast.error("Please provide a change reason");
            return;
        }

        // Transform data to the required format
        const processedData = jsonData.transformedData
            .filter(row => row.emp_code)
            .map(row => {
                const employeeData = {
                    emp_code: row.emp_code,
                    name: row.name,
                    wef_month: row.wef_month || data.wef_month,
                    wef_year: row.wef_year || data.wef_year,
                    change_reason: row.change_reason || data.change_reason,
                    updated_by: sessionStorage.getItem("emp_code"),
                    partial: row.partial !== undefined ? row.partial : data.partial,
                };

                // Add all salary components
                const components = jsonData.componentNames || [];
                components.forEach((component) => {
                    const fixedKey = `${component} fixed_amount`;
                    const percentKey = `${component} percentage`;
                    const percentOfKey = `${component} percentage_of`;

                    if (row[fixedKey] !== undefined && row[fixedKey] !== null) {
                        employeeData[fixedKey] = row[fixedKey];
                    }

                    if (row[percentKey] !== undefined && row[percentKey] !== null) {
                        employeeData[percentKey] = row[percentKey];
                    }

                    if (row[percentOfKey] !== undefined && row[percentOfKey] !== null) {
                        employeeData[percentOfKey] = row[percentOfKey];
                    }
                });

                return employeeData;
            });

        // Final validation
        if (processedData.length === 0) {
            toast.error("No valid employee data found in the file");
            return;
        }

        const loadingToastId = toast.loading(
            data.dry_run
                ? "Running validation (dry-run mode)..."
                : "Processing bulk salary update..."
        );

        setLoading(true);

        try {
            const requestData = {
                data: processedData,
                dry_run: data.dry_run,
                effective_month: data.wef_month,
                effective_year: data.wef_year,
                change_reason: data.change_reason,
                partial: data.partial,
                updated_by: data.updated_by
            };

            const response = await axios.post(
                `${BASE_URL}/wfm/customdeduction-bulkformultipleemployee-withhistorylog-dry/add-update/`,
                requestData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                const result = response.data;

                // Show success message
                toast.dismiss(loadingToastId);

                // Show results in modal
                setApiResults(result);
                setShowResults(true);

                // If dry run and no failures, offer option to proceed
                if (data.dry_run && result.summary?.failed_count === 0) {
                    toast.success("Dry-run validation completed successfully!", {
                        autoClose: 3000
                    });
                } else if (!data.dry_run) {
                    // Actual update completed
                    toast.success("Bulk update completed successfully!", {
                        autoClose: 3000
                    });
                    // Refresh data but don't close modal yet
                    await getPayrunlist();
                }
            }

            else if (response.status === 400) {
                // still opens result summmary to show respective data
            }
        } catch (error) {
            console.error("Error in bulk salary update:", error);
            toast.dismiss(loadingToastId);

            if (error.response) {
                const errorData = error.response.data;
                // Handle 400 and other error responses
                if (error.response.status === 400 || error.response.status >= 400) {
                    // Format the error response to match our results modal structure
                    const formattedResult = {
                        summary: errorData.summary || {
                            total_employees: errorData.total_employees || 0,
                            successful_count: errorData.successful_count || 0,
                            failed_count: errorData.failed_count || 0,
                            skipped_count: errorData.skipped_count || 0,
                            total_deductions_created: errorData.total_deductions_created || 0,
                            total_deductions_updated: errorData.total_deductions_updated || 0,
                            total_deductions_deleted: errorData.total_deductions_deleted || 0,
                            total_amount_impact: errorData.total_amount_impact || '0.00'
                        },
                        message: errorData.error || errorData.details || "Operation failed",
                        dry_run: errorData.dry_run || false,
                        failed: errorData.failed_details ? errorData.failed_details.map(detail => ({
                            emp_code: detail.emp_code,
                            status: "failed",
                            message: "Critical error occurred",
                            errors: Array.isArray(detail.errors) ? detail.errors : [detail.errors],
                            is_critical: detail.is_critical || false
                        })) : [],
                        successful: [],
                        skipped: []
                    };

                    // Show results in modal for error cases too
                    setApiResults(formattedResult);
                    setShowResults(true);

                    // Show error toast
                    const errorMessage = errorData.error || errorData.details || "Bulk update failed";
                    toast.error(errorMessage, { autoClose: 8000 });
                } else {
                    // For other error responses
                    let errorMessage = "Bulk update failed";
                    if (errorData.details) {
                        errorMessage += `: ${errorData.details}`;
                    } else if (errorData.error) {
                        errorMessage += `: ${errorData.error}`;
                    }
                    toast.error(errorMessage, { autoClose: 8000 });
                }
            } else if (error.request) {
                toast.error("Network error. Please check your connection.");
            } else {
                toast.error("Error processing request.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <button
                title="Bulk Upload Salary Data"
                className="model-button font-weight500 model-button-print"
                onClick={handleShow}
                style={{ margin: "2px" }}
            >
                <CloudUpload />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model" size="xl">
                <Modal.Header className="task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title>Bulk Salary Update</Modal.Title>
                    <div>
                        <div className="flex-row">
                            <DownloadSalaryBulkFormatWithSalary />
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {/* Global Parameters Section */}
                    <div className="form-column" style={{ marginBottom: "20px", padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
                        <div className="flex-row justify-between">
                            <h5 className="">
                                Overall Update Parameters
                            </h5>
                            <div style={{ marginTop: "5px", fontSize: "0.85rem", color: "#6c757d" }}>
                                Currently selected: {MONTH_NAMES[data.wef_month]} {data.wef_year}
                            </div>
                        </div>
                        {/* Effective Period (Month-Year Input) */}
                        <div className="flex-row">
                            <div className="flex-column">
                                <label htmlFor="effective_period" className="form-labels">
                                    Default Effective Period (WEF)<span className="required">*</span>
                                </label>
                                <input
                                    type="month"
                                    id="effective_period"
                                    name="effective_period"
                                    value={`${data.wef_year}-${data.wef_month.toString().padStart(2, '0')}`}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value) {
                                            const [year, month] = value.split('-');
                                            setData({
                                                ...data,
                                                wef_year: parseInt(year),
                                                wef_month: parseInt(month)
                                            });
                                            // Clear error when user changes the value
                                            if (errors.effective_period) {
                                                setErrors({ ...errors, effective_period: '' });
                                            }
                                        }
                                    }}
                                    className={`form-input w-auto  
                                    ${errors.effective_period ? "error" : inputState.effective_period ? "success" : ""}`
                                    }
                                    style={{ width: "100%" }}
                                    min={`${new Date().getFullYear() - 5}-01`}
                                    // max={`${new Date().getFullYear() + 1}-12`}
                                    max={`${new Date().getFullYear()}-${(new Date().getMonth() + 1).toString().padStart(2, '0')}`}
                                />
                                {errors.effective_period && (
                                    <span className="error-message font-size-text">{errors.effective_period}</span>
                                )}
                            </div>
                            <hr className="field-cont-hr" />
                            <div className="flex-column" style={{ flex: "2" }}>
                                <label htmlFor="change_reason" className="form-labels">
                                    Change Reason<span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="change_reason"
                                    value={data.change_reason}
                                    onChange={(e) => setData({ ...data, change_reason: e.target.value })}
                                    placeholder="e.g., Annual Increment, Promotion Adjustment"
                                    className="form-input w-auto "
                                    style={{ width: "100%" }}
                                    required
                                />
                            </div>
                        </div>

                        {SUPER_ADMIN &&
                            <div className="flex-row justify-between">
                                <div className="flex-row align-start">
                                    <div className="checkbox-toggle">
                                        <input
                                            type="checkbox"
                                            id="partial"
                                            checked={data.partial}
                                            onChange={(e) => setData({ ...data, partial: e.target.checked })}
                                        />
                                        <label htmlFor="partial"></label>
                                    </div>
                                    <hr className="field-cont-hr" />
                                    <label htmlFor="partial" className="form-labels" style={{ cursor: "pointer" }}>
                                        {data.partial
                                            ?
                                            'Partial Update (keep existing deductions not in upload file)'
                                            :
                                            'Complete Overwrite (delete deductions missing from upload file)'
                                        }
                                    </label>
                                </div>

                                <div className="flex-row align-end">
                                    <div className="checkbox-toggle">
                                        <input
                                            type="checkbox"
                                            id="dry_run"
                                            checked={data.dry_run}
                                            onChange={(e) => setData({ ...data, dry_run: e.target.checked })}
                                        />
                                        <label htmlFor="dry_run"></label>
                                    </div>
                                    <hr className="field-cont-hr" />
                                    <label htmlFor="dry_run" className="form-labels" style={{ cursor: "pointer" }}>
                                        Dry-run Mode (validate only, no database changes)
                                    </label>
                                </div>
                            </div>
                        }
                    </div>

                    {data.dry_run && (
                        // <div className="notice-badge color-badge-warning font-size-label" style={{ marginTop: "10px" }}>
                        //     <strong>⚠️ Dry-run Mode Active:</strong> No database changes will be made. You'll see a preview of what would change.
                        // </div>
                        <div style={getResultCardStyle({
                            background: "#fffcf0",
                            borderColor: "#fde68a",
                            leftBorderColor: "#fde68a",
                            borderRadius: "6px",
                            padding: "14px 16px",
                            marginTop: "16px",
                            textColor: "#1d1c1c",
                            fontSize: "13px",
                        })}>

                            <strong><WarningIcon /> Dry-run Mode Active:</strong> No database changes will be made. You'll see a preview of what would change.
                        </div>

                    )}

                    {/* File Upload Section */}
                    <div className="flex-column field-cont-div" style={{ marginBottom: "20px" }}>
                        <label htmlFor="document_file" className="form-labels font-weight500 font-size-heading">
                            Upload Excel File
                        </label>
                        <div className="flex-row align-center">
                            <div>
                                <label
                                    htmlFor="document_file"
                                    className={`align-center custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                                        }`}
                                    style={{ cursor: "pointer" }}
                                >
                                    <div className={`align-center pdf-input ${docErrors.document_file ? "error" : ""}`}>
                                        <Attachment />
                                        {/* <span style={{ marginLeft: "8px" }}>Choose File</span> */}
                                    </div>
                                </label>
                                <input
                                    type="file"
                                    accept=".xlsx, .xls"
                                    onChange={handleFileUpload}
                                    id="document_file"
                                    name="document_file"
                                    className="align-center"
                                    style={{ display: "none", }}
                                />
                            </div>
                            {fileName && (
                                <div className="flex-row gap-2 align-center">
                                    <span className="justify-center align-center font-weight-500 text-success-color">
                                        {fileName}
                                    </span>
                                    <button className="priority-button color-button-submit" onClick={handleFileClear} >
                                        Clear
                                    </button>
                                </div>
                            )}
                        </div>
                        {docErrors.document_file && (
                            <span className="file-name error-message font-size-text">
                                {docErrors.document_file}
                            </span>
                        )}

                    </div>

                    {/* Data Preview Section */}
                    {jsonData && (
                        <div style={{ marginTop: "30px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                                <h5>Salary Structure Data Preview</h5>
                                <span style={{ color: "#6c757d", fontSize: "0.9rem" }}>
                                    Showing {jsonData.transformedData?.length || 0} employees
                                </span>
                            </div>
                            <div className="scroll-container-table" style={{ maxHeight: "400px", overflowY: "auto", border: "1px solid #dee2e6" }}>
                                <table className="scrollfix-table-css" style={{ width: "100%" }}>
                                    <thead>
                                        <tr className="custom-table-head-tr">
                                            <th rowSpan="2" className="sticky-header" style={{ minWidth: "100px" }}>
                                                Emp Code
                                            </th>
                                            <th rowSpan="2" className="sticky-header" style={{ minWidth: "150px" }}>
                                                Name
                                            </th>
                                            <th rowSpan="2" className="sticky-header" style={{ minWidth: "80px" }}>
                                                WEF Month
                                            </th>
                                            <th rowSpan="2" className="sticky-header" style={{ minWidth: "80px" }}>
                                                WEF Year
                                            </th>
                                            <th rowSpan="2" className="sticky-header" style={{ minWidth: "80px" }}>
                                                Change Reason
                                            </th>


                                            {/* Dynamic column groups */}
                                            {jsonData.componentNames?.map((component) => (
                                                <th colSpan="3" className="section-header" key={component} style={{ textAlign: "center" }}>
                                                    {component}
                                                </th>
                                            ))}
                                        </tr>
                                        <tr className="custom-table-head-tr">
                                            {/* Subheaders */}
                                            {jsonData.componentNames?.flatMap((component) => [
                                                <th key={`${component}-fixed`} className="sub-header" style={{ textAlign: "right" }}>
                                                    Fixed
                                                </th>,
                                                <th key={`${component}-percent`} className="sub-header" style={{ textAlign: "center" }}>
                                                    %
                                                </th>,
                                                <th key={`${component}-of`} className="sub-header" style={{ textAlign: "left" }}>
                                                    Of
                                                </th>,
                                            ])}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {jsonData.transformedData
                                            // ?.slice(0, 50)
                                            ?.map((row, index) => (
                                                <tr
                                                    key={index}
                                                    style={{
                                                        backgroundColor: index % 2 === 0 ? "#f9f9f9" : "white",
                                                    }}
                                                >
                                                    <td style={{ fontWeight: "500" }}>{row.emp_code}</td>
                                                    <td>{row.name}</td>
                                                    <td style={{ textAlign: "center" }}>
                                                        {row.wef_month ? MONTH_NAMES[row.wef_month] : MONTH_NAMES[data.wef_month]}
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>{row.wef_year || data.wef_year}</td>
                                                    <td style={{ textAlign: "center" }}>{row.change_reason || data.change_reason}</td>

                                                    {/* Dynamic data cells */}
                                                    {jsonData.componentNames?.flatMap((component) => [
                                                        <td key={`${component}-fixed`} className="align-right" style={{ color: row[`${component} fixed_amount`] ? '#28a745' : '#f72b50' }}>
                                                            {row[`${component} fixed_amount`]
                                                                ? parseFloat(row[`${component} fixed_amount`]).toLocaleString("en-IN", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2,
                                                                })
                                                                : "-"}
                                                        </td>,
                                                        <td key={`${component}-percent`} className="align-center" style={{ color: row[`${component} percentage`] ? "#007bff" : "#f72b50" }}>
                                                            {row[`${component} percentage`]
                                                                ? `${parseFloat(row[`${component} percentage`])}%`
                                                                : "-"}
                                                        </td>,
                                                        <td key={`${component}-of`} className="align-left" style={{ color: row[`${component} percentage_of`] ? "#6c757d" : '#f72b50' }}>
                                                            {row[`${component} percentage_of`] || "-"}
                                                        </td>,
                                                    ])}
                                                </tr>
                                            ))}
                                        {/* {jsonData.transformedData?.length > 50 && (
                                            <tr>
                                                <td colSpan={4 + jsonData.componentNames?.length * 3} style={{ textAlign: "center", padding: "10px", color: "#6c757d" }}>
                                                    ... and {jsonData.transformedData.length - 50} more employees
                                                </td>
                                            </tr>
                                        )} */}
                                    </tbody>
                                </table>
                            </div>
                            {/* <div style={{ marginTop: "10px", fontSize: "0.85rem", color: "#6c757d" }}>
                                <p>
                                    <strong>Preview limited to first 50 rows.</strong> 
                                    All {jsonData.transformedData?.length || 0} rows will be processed.
                                </p>
                            </div> */}
                        </div>
                    )}

                    <br />

                    {/* <div>
                        <div className='notice-badge color-badge-warning font-size-subheading'>
                       
                            <strong><ImportantNotesIcon color={"#FFC107"} /> Important Notes:</strong><br />
                            1. Employee-specific wef_month, wef_year and change_reason will override "Overall Parameters" values.<br />
                            2. Leave empty to use global defaults.<br />
                            3. Effective period must be:<br />
                            &nbsp;&nbsp;&nbsp;• On or before current month<br />
                            &nbsp;&nbsp;&nbsp;• After employee's joining date<br />
                            &nbsp;&nbsp;&nbsp;• After any existing salary slip period<br />
                            &nbsp;&nbsp;&nbsp;• After the last salary PayRun of employee<br />
                            4. If validation fails for an employee, that employee will be skipped.
                            {data.dry_run && <><br />5. <strong>DRY-RUN MODE:</strong> No database changes will be made.</>}
                        </div>
                    </div> */}

                    {/* Action Buttons */}
                    {/* <div className="button-models" style={{ marginTop: "30px", paddingTop: "20px" }}> */}
                    {/* <div className="button-models">
                        <button
                            className="model-button-cancel model-button font-weight500"
                            onClick={handleClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            className={`model-button font-weight500 ${(loading || !jsonData || !hasReadNotes) ? "model-button-inactive" : "model-button-download"}`}
                            onClick={handleSubmit}
                            disabled={loading || !jsonData || !hasReadNotes}
                            style={{
                                cursor: loading ? "progress" : jsonData ? "pointer" : "not-allowed",
                                opacity: loading || !jsonData ? 0.7 : 1,
                            }}
                        >
                            {loading ? (
                                <div className="flex-row">
                                    <div className="spinner-vsmall"></div>
                                    Processing...
                                </div>
                            ) : (
                                <>
                                    <CloudUpload />
                                    {"  "}
                                    {data.dry_run ? "Validate" : data.partial ? "Update" : "Overwrite"}
                                </>
                            )}
                        </button>
                    </div> */}

                    {/*--------------------------------------------- Enhanced Important Notes */}
                    <ActionableAlert
                        title="CRITICAL: Bulk Update Rules"
                        icon={<WarningIcon />}
                        primaryColor="#b45309"
                        themeColor="#f59e0b"
                        bgColor="#fffcf0"
                        borderColor="#fde68a"
                        isChecked={hasReadNotes}
                        onCheckChange={setHasReadNotes}
                        checkboxLabel="I acknowledge the bulk update rules and wish to proceed."
                    >
                        <ul style={{ paddingLeft: '24px', margin: 0 }}>
                            <li>Employee-specific <code>wef_month</code>, <code>wef_year</code>, and <code>change_reason</code> will <strong>override</strong> the "Overall Parameters" values.</li>
                            <li>Leave those columns empty in the Excel file to use the global defaults.</li>
                            <li>The Effective period <strong style={{ color: '#dc2626' }}>must be</strong>:
                                <ul style={{ marginTop: '5px', paddingLeft: '20px', listStyleType: 'circle' }}>
                                    <li>On or before the current month.</li>
                                    <li>After the employee's joining date.</li>
                                    <li>After any existing salary slip period.</li>
                                    <li>After the last salary PayRun of employee</li>
                                </ul>
                            </li>
                            <li>If validation fails for an employee, that employee will be <strong>skipped</strong>.</li>
                            {data.dry_run && <li><strong style={{ color: '#2563eb' }}>DRY-RUN MODE:</strong> No database changes will be made.</li>}
                        </ul>
                    </ActionableAlert>

                    {/* Action Buttons */}
                    <div className="button-models">
                        <button
                            className="model-button-cancel model-button font-weight500"
                            onClick={handleClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            className={`model-button font-weight500 ${(loading || !jsonData || !hasReadNotes) ? "model-button-inactive" : "model-button-download"}`}
                            onClick={handleSubmit}
                            disabled={loading || !jsonData || !hasReadNotes}
                            style={{
                                cursor: (loading || !jsonData || !hasReadNotes) ? "not-allowed" : "pointer",
                                opacity: (loading || !jsonData || !hasReadNotes) ? 0.6 : 1,
                                transition: 'all 0.3s ease'
                            }}
                            title={!hasReadNotes ? "Please check the acknowledgement box above to proceed" : ""}
                        >
                            {loading ? (
                                <div className="flex-row">
                                    <div className="spinner-vsmall"></div>
                                    Processing...
                                </div>
                            ) : (
                                <>
                                    <CloudUpload />
                                    {"  "}
                                    {data.dry_run ? "Validate" : data.partial ? "Update" : "Overwrite"}
                                </>
                            )}
                        </button>
                    </div>
                </Modal.Body>
                <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} draggable pauseOnHover />
            </Modal >

            {/* <BulkUpdateSalaryAPIResultsModal
                show={showResults}
                handleClose={handleCloseResults}
                handleComplete={handleComplete}
                handleRetry={handleRetry}
                handleBulkUpload={handleActualBulkSubmit}
                results={apiResults}
                isDryRun={data.dry_run}
                fileName={fileName}
            /> */}
            <PayrunOperationResultModal
                show={showResults}
                handleClose={handleCloseResults}
                handleComplete={handleComplete}
                handleRetry={handleRetry}
                handleBulkUpload={handleActualBulkSubmit}
                results={apiResults}
                isDryRun={data.dry_run}
                fileName={fileName}
                operationType={PAYRUN_OPERATION.BULK_UPDATE}
            />
        </>
    );
};


const RunPayRollWithLog = ({ getPayrunlist, month, year, payroll_emp_check = true }) => {

    const [show, setShow] = useState(false);
    const [showResults, setShowResults] = useState(false);
    const [apiResults, setApiResults] = useState(null);
    const [buffer1, setBuffering1] = useState(false);
    const [buffer2, setBuffering2] = useState(false);
    const isConfirmedRef = useRef(false);
    const [hasReadNotes, setHasReadNotes] = useState(false);

    const resetModalState = () => {
        setFileName("");
        setExcelJson(null);
        setJsonData(null);
        setDocInputState({});
        setDocErrors({});
        setData({
            ignore_existing: true,
            dry_run: false,
            updated_by: sessionStorage.getItem("emp_code"),
            employees: [],
        });

        setSelectedEmployees([]);
        setShowEmployeeSelection(false);
        setActive("active");
        setToggleCompany(sessionStorage.getItem("company_id"));

    };

    const handleShow = () => {
        resetModalState();
        setMaxWefPeriod(getCurrentMonthYear());
        setShow(true);
    };

    const handleClose = () => {
        resetModalState();
        getPayrunlist()
        setShow(false);
    };

    const handleCloseResults = () => {
        setShowResults(false);
    };

    const handleComplete = () => {
        setShowResults(false);
        handleClose();
    };

    const handleRetry = () => {
        setShowResults(false);
        setTimeout(() => {
            handleSubmit();
        }, 500);
    };

    const { SUPER_ADMIN, PERMISSION_AUTHORITY, SUB_COMPANIES } = usePermission();
    const [maxWefPeriod, setMaxWefPeriod] = useState('');
    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null);
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});
    const [loading, setLoading] = useState(false);
    const [jsonData, setJsonData] = useState(null);
    const [empListForPayrun, setEmpListForPayrun] = useState([]);
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const [active, setActive] = useState('active');
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [showEmployeeSelection, setShowEmployeeSelection] = useState(false);

    const [data, setData] = useState({
        ignore_existing: true,
        dry_run: false,
        updated_by: sessionStorage.getItem('emp_code'),
        employees: []
    });

    const getCurrentMonthYear = () => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    };



    const getEmpListForPayrun = async () => {
        setBuffering2(true);
        try {
            const res = await axios.get(
                // `${BASE_URL}/wfm/employee-payrun-details/${toggleCompany}/${active}/${month}/${year}/`
                `${BASE_URL}/wfm/employee-payrun-details-v2/${toggleCompany}/${active}/${month}/${year}/`
            );
            const sortedList = customSortByKey(res.data.employees, "emp_code");
            setEmpListForPayrun(sortedList);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering2(false);
        }
    };


    const handleEmployeeSelect = (selected) => {
        if (!selected) {
            setSelectedEmployees([]);
            return;
        }

        const employees = selected
            .map(opt => opt.employee)
            .filter(Boolean);

        setSelectedEmployees(employees);
    };



    const confirmToast = (message, onYes) => {


        const toastId = "confirm-toast";


        if (toast.isActive(toastId)) return;

        toast.info(
            ({ closeToast }) => (
                <div style={{ textAlign: "center", padding: "8px 4px" }}>

                    <p style={{ marginBottom: "10px" }}>{message}</p>

                    <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                        <button
                            className="model-button model-button-cancel"
                            onClick={() => {
                                // closeToast();
                                toast.dismiss(toastId);
                            }}
                        >
                            No
                        </button>
                        <button
                            className="model-button model-button-leave"
                            onClick={() => {
                                // closeToast();
                                toast.dismiss(toastId);
                                onYes();
                            }}
                        >
                            Yes
                        </button>
                    </div>
                </div>
            ),
            {
                toastId,
                autoClose: false,
                closeOnClick: false,
                draggable: false,
                closeButton: false,
            }
        );
    };


    const proceedPayrun = async () => {
        try {
            const payload = {
                dry_run: data.dry_run,
                ignore_existing: data.ignore_existing,
                updated_by: data.updated_by,
                employees: selectedEmployees.map(emp => emp.emp_code)
            };

            const response = await axios.post(
                // `${BASE_URL}/wfm/optimized-payrun-withdryrun/${toggleCompany}/${active}/${month}/${year}/`,
                `${BASE_URL}/wfm/optimized-payrun-withdryrun-v2/${toggleCompany}/${active}/${month}/${year}/`,
                payload
            );

            if (response.status === 200 || response.status === 201 || response.status === 207) {
                const result = response.data;
                setApiResults(result);
                setShowResults(true);
                toast.success(result.message || "PAYRUN completed successfully!");
                await getPayrunlist();
            }
        } catch (error) {
            console.error("Error running PAYRUN:", error);

            let formattedResult = {
                failed: [],
                successful: [],
                skipped: [],
                message: "Error occurred while running PAYRUN",
                dry_run: data.dry_run,
                ignore_existing: data.ignore_existing,
            };

            if (error.response?.data) {
                const errData = error.response.data;
                formattedResult = {
                    ...formattedResult,
                    ...errData
                };
            }

            setApiResults(formattedResult);
            setShowResults(true);

            toast.error(formattedResult.message || "PAYRUN failed", { autoClose: 8000 });
        } finally {
            setLoading(false);
            isConfirmedRef.current = false;
        }
    }

    // const handleSubmit = async () => {
    //     if (loading) return;
    //     if (!selectedEmployees || selectedEmployees.length === 0) {
    //         toast.error("No employees selected for PAYRUN!");
    //         return;
    //     }

    //     const hasUnSavedTax = selectedEmployees.some(
    //         emp => emp.tds_status !== "Saved"
    //     );

    //     if (hasUnSavedTax && !isConfirmedRef.current) {
    //         confirmToast(
    //             "Some selected employees have TDS not saved for this month. Do you want to continue Payrun?",
    //             async () => {
    //                 isConfirmedRef.current = true;
    //                 setLoading(true);
    //                 await proceedPayrun();
    //             }
    //         );
    //         return;
    //     }
    //     setLoading(true);
    //     proceedPayrun();
    // };


    const lastPayrunMonthMap = React.useMemo(() => {
        const map = {};
        empListForPayrun.forEach(emp => {
            if (emp.emp_code && emp.last_payrun_month) {
                map[emp.emp_code] = emp.last_payrun_month;
            }
        });
        return map;
    }, [empListForPayrun]);


    const handleSubmit = async () => {
        if (loading) return;

        if (!selectedEmployees || selectedEmployees.length === 0) {
            toast.error("No employees selected for PAYRUN!");
            return;
        }

        // const invalidEmployees = selectedEmployees.filter(emp => {
        //     const empCode = emp.emp_code;
        //     const lastPayrunMonth = empListForPayrun?.[empCode];


        //     return lastPayrunMonth && lastPayrunMonth !== requestedMonth;
        // });
        const requestedMonth = `${year}-${String(month).padStart(2, "0")}`;

        const invalidEmployees = selectedEmployees.filter(emp => {
            const empCode = emp.emp_code;
            const lastPayrunMonth = lastPayrunMonthMap[empCode];


            return lastPayrunMonth && lastPayrunMonth !== requestedMonth;
        });


        if (invalidEmployees.length > 0) {
            toast.error(
                "Payrun update is allowed only for the latest processed month. Please select the last payrun month."
            );
            return;
        }


        const hasUnSavedTax = selectedEmployees.some(
            emp => emp.tds_status !== "Saved"
        );

        if (hasUnSavedTax && !isConfirmedRef.current) {
            confirmToast(
                "Some selected employees have TDS not saved for this month. Do you want to continue Payrun?",
                async () => {
                    isConfirmedRef.current = true;
                    setLoading(true);
                    await proceedPayrun();
                }
            );
            return;
        }

        setLoading(true);
        proceedPayrun();
    };

    const monthName = monthNames[month - 1];

    useEffect(() => {
        if (show) {
            getEmpListForPayrun();
        }
    }, [show, toggleCompany, active, month, year]);

    const toggleEmployee = (employee) => {
        setSelectedEmployees(prev =>
            prev.some(emp => emp.emp_code === employee.emp_code)
                ? prev.filter(emp => emp.emp_code !== employee.emp_code)
                : [...prev, employee]
        );
    };

    const toggleSelectAll = () => {
        const selectable = empListForPayrun.filter(
            emp => !data.ignore_existing || !emp.payrun_exist
        );

        setSelectedEmployees(prev =>
            prev.length === selectable.length ? [] : selectable
        );
    };


    useEffect(() => {
        const selectable = empListForPayrun.filter(
            emp => !data.ignore_existing || !emp.payrun_exist
        );

        setSelectedEmployees(selectable);
    }, [empListForPayrun, data.ignore_existing]);


    const employeeOptions = empListForPayrun.map(emp => ({
        value: emp.emp_code,
        label: `${emp.emp_code} - ${emp.name}`,
    }));



    const { updated_by, message } = apiResults || {};

    const restData = {
        updatedBy: updated_by || '',
        message: message || '',
    };


    const showMissingMonthsColumn = empListForPayrun.some(
        emp => emp.has_missing_months && emp.missing_months?.length > 0
    );

    // const selectableEmployees = empListForPayrun.filter(
    //     emp => data.ignore_existing || !emp.payrun_exist
    // );

    const selectableEmployees = empListForPayrun.filter(
        emp => !data.ignore_existing || !emp.payrun_exist
    );

    const isAllSelected =
        selectableEmployees.length > 0 &&
        selectedEmployees.length === selectableEmployees.length;


    const selectedCompanyName =
        SUB_COMPANIES.find(company => String(company.id) === String(toggleCompany))?.title || "";



    return (
        <>
            <button
                className="model-view-button model-add"
                title="Run Pay Roll"
                onClick={handleShow}
            >
                <RunPayrollIcon />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model" size="xl">
                <Modal.Header className="task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title> Run Pay Rolls for "{monthName}-{year}" {selectedCompanyName && `of "${selectedCompanyName}"`}</Modal.Title>
                    {/* <div className="flex-row">
                        <button
                            className="priority-button-small model-button-download"
                            // onClick={exportToCSV}
                            title="Export to CSV"
                        >
                            <DownloadIcon />{" "}
                            Export CSV
                        </button>
                    </div> */}
                </Modal.Header>
                <Modal.Body>

                    <div className="form-flex-wrap">
                        {SUPER_ADMIN ?
                            <div className="flex-column">
                                <label className="form-labels  font-weight500    font-size-subheading">
                                    Sub Company<span className="required">*</span>
                                </label>

                                <select
                                    id="sub_company"
                                    name="sub_company"
                                    style={{ marginBottom: "8px" }}
                                    value={toggleCompany}
                                    onChange={(e) => setToggleCompany(e.target.value)}
                                    className='form-input'
                                >
                                    <option value="">Select Company  </option>
                                    {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                </select>
                            </div>
                            : null
                        }
                        <div className="flex-column">
                            <label className="form-labels  font-weight500    font-size-subheading">
                                Status<span className="required">*</span>
                            </label>
                            <select
                                className='form-input'
                                type="text"
                                value={active}
                                onChange={(e) => {
                                    setActive(e.target.value)
                                }}
                            >
                                <option value="null">All</option>
                                <option value="active">Active</option>
                                <option value="inactive">In Active</option>
                            </select>

                        </div>

                    </div>
                    <div className="form-flex-wrap" style={{ backgroundColor: "#f8f9fa", borderRadius: "8px", marginBottom: "9px" }}>
                        <div className="form-column" style={{ padding: "15px" }}>
                            {/* Give HR option for seelecting employees hence removed SUPER_ADMIN condition */}
                            {PERMISSION_AUTHORITY &&
                                <div className="flex-row justify-between">
                                    <div className="flex-row align-end">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                id="employee_selection_toggle"
                                                checked={showEmployeeSelection}
                                                onChange={(e) => setShowEmployeeSelection(e.target.checked)}
                                            />
                                            <label htmlFor="employee_selection_toggle"></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label htmlFor="employee_selection_toggle" className="form-labels" style={{ cursor: "pointer" }}>
                                            Enable Employee Selection
                                        </label>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="form-column" style={{ padding: "15px" }}>

                            <div className="flex-row justify-between">
                                <div className="flex-row align-end">
                                    <div className="checkbox-toggle">
                                        <input
                                            type="checkbox"
                                            id="ignore_existing"
                                            checked={data.ignore_existing}
                                            onChange={(e) => setData({ ...data, ignore_existing: e.target.checked })}
                                        />
                                        <label htmlFor="ignore_existing"></label>
                                    </div>
                                    <hr className="field-cont-hr" />
                                    <label htmlFor="ignore_existing" className="form-labels" style={{ cursor: "pointer" }}>
                                        Existing Payruns {data.ignore_existing ? '(Ignore)' : '(Update)'}
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div className="form-column" style={{ padding: "15px" }}>
                            {SUPER_ADMIN &&
                                <div className="flex-row justify-between">
                                    <div className="flex-row align-end">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                id="dry_run"
                                                checked={data.dry_run}
                                                onChange={(e) => setData({ ...data, dry_run: e.target.checked })}
                                            />
                                            <label htmlFor="dry_run"></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label htmlFor="dry_run" className="form-labels" style={{ cursor: "pointer" }}>
                                            Dry-run Mode (validate only, no database changes)
                                        </label>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    {showEmployeeSelection && (
                        <>
                            {/* ---------------------------------------------------employees dropdown */}
                            <div className="flex-column" style={{ cursor: 'not-allowed' }}>
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Select Employees<span className="required">*</span>

                                </label>
                                {buffer2 ? (
                                    <div className="form-loader">
                                        <div className="bar-loader"></div>
                                    </div>
                                ) : (
                                    <Select
                                        options={employeeOptions}
                                        isMulti
                                        value={employeeOptions.filter(opt =>
                                            selectedEmployees.some(emp => emp.emp_code === opt.value)
                                        )}
                                        isDisabled={true}
                                        // onChange={handleEmployeeSelect}
                                        onChange={() => { }}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '98%',
                                                minHeight: '50px',
                                                borderRadius: '10px',
                                                border: '1px solid #e3e3e3',
                                                margin: '10px 0px 20px 0px',
                                                color: '#4a4a4a',
                                                backgroundColor: '#f7f8fa',
                                                padding: '0px 10px',
                                            }),
                                            placeholder: (provided) => ({ ...provided, color: '#4a4a4a' }),
                                            menu: (provided) => ({ ...provided, borderRadius: '10px', marginTop: '0' }),
                                            input: (provided) => ({ ...provided, color: '#4a4a4a' }),
                                            singleValue: (provided) => ({ ...provided, color: '#4a4a4a' }),
                                        }}
                                    />
                                )}

                                {/* <div className="form-note">
                            <small>Employee selection is automatically populated based on your filter conditions.</small>
                           </div> */}
                            </div>

                            <div className="table-container scroll-container-table" style={{ marginBottom: '20px' }}>
                                <table className="table-css" style={{ overflow: 'auto' }}>
                                    <thead className="table-heading">
                                        <tr className="custom-table-head-tr scroll-fix-table-heading">
                                            <th
                                                className="table-heading align-center">
                                                <label className="checkbox-click" style={{ height: '16px' }}>
                                                    <input
                                                        type="checkbox"

                                                        // checked={
                                                        //     selectedEmployees.length === empListForPayrun.length &&
                                                        //     empListForPayrun.length > 0
                                                        // }
                                                        checked={
                                                            selectableEmployees.length > 0 &&
                                                            selectedEmployees.length === selectableEmployees.length
                                                        }
                                                        disabled={selectableEmployees.length === 0}
                                                        onChange={toggleSelectAll}

                                                    />

                                                    <div className="checkmark-medium"></div>
                                                </label>
                                            </th>
                                            <th className="table-heading align-center">Employee</th>
                                            <th className="table-heading align-center">Employee Status</th>
                                            {showMissingMonthsColumn && <th className="table-heading align-center">Remark</th>}
                                            <th className="table-heading align-center">TDS Status</th>
                                            <th className="table-heading align-center">Payrun Status</th>
                                        </tr>
                                    </thead>

                                    <tbody className="align-center">
                                        {empListForPayrun.map(emp => {
                                            const isSelected = selectedEmployees.some(
                                                e => e.emp_code === emp.emp_code
                                            );
                                            const isDisabled = (data.ignore_existing && emp.payrun_exist === true) || emp.missing_months.length > 0;


                                            return (
                                                <tr key={emp.emp_code}
                                                    // className={`custom-table-head-td ${isSelected ? "row-selected" : ""}`}
                                                    // onClick={() => toggleEmployee(emp)}
                                                    className={`custom-table-head-td
                                                    ${isSelected ? "row-selected" : ""} 
                                                    ${isDisabled ? "row-disabled" : ""}
                                                    `}
                                                    onClick={() => {
                                                        if (!isDisabled) toggleEmployee(emp);
                                                    }}
                                                    title={
                                                        isDisabled
                                                            ? "Payrun already exists for this employee."
                                                            : ""
                                                    }
                                                    style={{ cursor: isDisabled ? "help" : "pointer" }}
                                                >
                                                    <td className="align-center">
                                                        {!isDisabled && (
                                                            <label className="checkbox-click"
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    // checked={selectedEmployees.some(
                                                                    //     e => e.emp_code === emp.emp_code
                                                                    // )}
                                                                    checked={isSelected}
                                                                    onChange={() => toggleEmployee(emp)}
                                                                    className="form-checkbox-nm"
                                                                />
                                                                <div className="checkmark-medium"></div>
                                                            </label>
                                                        )}
                                                    </td>
                                                    <td className="align-center">
                                                        <div className="employee-name">
                                                            {emp.emp_code} - {emp.name}
                                                        </div>
                                                    </td>
                                                    <td className={`text-capitalize align-center ${emp.employee_status === "active" ? 'text-success-color' : 'text-danger-color'} `}
                                                    >{emp.employee_status}
                                                    </td>
                                                    {showMissingMonthsColumn && (
                                                        <td className="align-center">
                                                            <div className="font-size-text mt-1 text-secondary-color">
                                                                {emp?.missing_months.length > 0 ?
                                                                    <><strong>Payslip Missing Months:</strong> {emp.missing_months.join(', ')} </>
                                                                    // : <strong>Payrun already done</strong>    //add remarks later    //incomplete
                                                                    : '-'
                                                                }
                                                            </div>
                                                        </td>
                                                    )}
                                                    <td className="align-center"> <span className={`status-badge ${emp.tds_status === "Saved" ? "color-badge-success" : "color-badge-warning"}   `} style={{ fontWeight: '500', fontSize: '11px', display: 'block', width: 'max-content' }}>{emp.tds_status === "Saved" ? "Saved" : "Not Saved"}</span></td>
                                                    <td className="align-center"> <span className={`status-badge ${emp.payrun_status === "Saved" ? "color-badge-success" : "color-badge-warning"}   `} style={{ fontWeight: '500', fontSize: '11px', display: 'block', width: 'max-content' }}>{emp.payrun_status === "Saved" ? "Saved" : "Not Saved"}</span></td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>


                                </table>
                            </div>
                        </>
                    )}

                    {/*--------------------------------------------- important notes */}
                    {/* <div className='notice-badge color-badge-warning font-size-subheading mt-2'>
                        <strong><ImportantNotesIcon color={"#FFC107"} /> Important Notes:</strong><br />
                        1. Once the salary slip is generated and run, It will be permanently saved.<br />
                        2. If you run the process again for the same employee, the existing salary slip will be updated only if it is allowed.<br />
                        3. If a salary slip is already saved for a specific employee and month,
                        salary changes for that employee will <strong>not</strong> be allowed for that month.<br />

                        4. Please review all salary details carefully before running, as changes may
                        be restricted after execution.

                        {data.dry_run && <><br />5. <strong>DRY-RUN MODE:</strong> No database changes will be made.</>}
                    </div> */}


                    {/* ----------------------------------------------action button */}
                    {/* <div className="button-models">
                        <button
                            className="model-button model-button-cancel font-weight500"
                            onClick={handleClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={`model-button font-weight500 font-size-heading ${hasReadNotes ? 'model-button-leave' : 'model-button-inactive'}`}
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? "Running..." : "Run"}
                        </button>
                    </div> */}

                    {/*--------------------------------------------- Enhanced Important Notes */}
                    <ActionableAlert
                        title="CRITICAL: Read Before Proceeding"
                        icon={<WarningIcon />}
                        primaryColor="#b45309"
                        themeColor="#f59e0b"
                        bgColor="#fffcf0"
                        borderColor="#fde68a"
                        isChecked={hasReadNotes}
                        onCheckChange={setHasReadNotes}
                        checkboxLabel="I have read and understood the consequences of running this payroll."
                    >
                        {/* Just pass your standard UL/LI elements as children */}
                        <ul style={{ paddingLeft: '24px', margin: 0 }}>
                            <li>Once the salary slip is generated and run, it will be <strong style={{ color: '#dc2626' }}>permanently saved</strong>.</li>
                            <li>If you run the process again for the same employee, the existing salary slip will be updated <strong>only if it is allowed</strong>.</li>
                            <li>If a salary slip is already saved for a specific employee and month, salary changes for that employee will <strong>not</strong> be allowed for that month.</li>
                            <li>Please review all salary details carefully before running, as changes may be restricted after execution.</li>
                            {data.dry_run && <li><strong style={{ color: '#2563eb' }}>DRY-RUN MODE:</strong> No database changes will be made.</li>}
                        </ul>
                    </ActionableAlert>

                    {/* ----------------------------------------------action button */}
                    <div className="button-models">
                        <button
                            className="model-button model-button-cancel font-weight500"
                            onClick={handleClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={`model-button font-weight500 font-size-heading ${hasReadNotes ? 'model-button-leave' : 'model-button-inactive'}`}
                            onClick={handleSubmit}
                            disabled={loading || !hasReadNotes}
                            style={{
                                cursor: (!hasReadNotes || loading) ? "not-allowed" : "pointer",
                                opacity: (!hasReadNotes || loading) ? 0.6 : 1,
                                transition: 'all 0.3s ease'
                            }}
                            title={!hasReadNotes ? "Please check the acknowledgement box above to proceed" : ""}
                        >
                            {loading ? "Running..." : "Run Payroll"}
                        </button>
                    </div>

                </Modal.Body>
                <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} draggable pauseOnHover />
            </Modal >
            <PayrunOperationResultModal
                show={showResults}
                handleClose={handleCloseResults}
                handleComplete={handleComplete}
                handleRetry={handleRetry}
                results={apiResults?.results}
                restData={restData}
                isDryRun={data.dry_run}
                operationType={PAYRUN_OPERATION.PAYRUN}
            />


        </>
    );
};


const DownloadSalaryBulkFormatWithSalary = () => {
    const [show, setShow] = useState(false);

    const handleShow = () => {
        getAllSalaryRelatedData();
        getAllEmployeeData();
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
    };

    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));

    const [allEmployeeList, setAllEmployeeList] = useState([]);
    const [salaryDeductionPolicies, setSalaryDeductionPolicies] = useState([]);
    const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);
    const [selectedPolicy, setSelectedPolicy] = useState("null");
    const [selectedPolicyData, setSelectedPolicyData] = useState({});
    const [selectedPolicyDeductions, setSelectedPolicyDeductions] = useState([]);

    const [showEmpData, setShowEmpData] = useState(false);
    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);

    const MONTH_NAMES = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    useEffect(() => {
        if (show) {
            getAllSalaryRelatedData();
            getAllEmployeeData();
        }
    }, [toggleCompany]);

    const getAllSalaryRelatedData = async () => {
        setBuffering1(true);
        try {
            const headings = await axios.get(`${BASE_URL}/wfm/salaryHeadingbysubcompany/${toggleCompany}/`);
            setSalaryStructureHeadings(headings.data);
            const policies = await axios.get(`${BASE_URL}/wfm/salarypolicybysubcompany/${toggleCompany}/`);
            setSalaryDeductionPolicies(policies.data);
        } catch (err) {
            console.error("Error fetching salary data", err);
            toast.error("Error fetching salary data");
        } finally {
            setBuffering1(false);
        }
    };

    const getAllEmployeeData = async () => {
        setBuffering2(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`);
            const sortedList = customSortByKey(res.data, "emp_code");
            setAllEmployeeList(sortedList);
        } catch (err) {
            console.error("Error fetching Employee data", err);
            toast.error("Error fetching employee data");
        } finally {
            setBuffering2(false);
        }
    };

    const handlePolicySelect = (e) => {
        const { value } = e.target;
        setSelectedPolicy(value);

        if (value === "null") {
            setSelectedPolicyDeductions([]);
            return;
        }

        const selected = salaryDeductionPolicies.find((format) => String(format.id) === String(value));
        setSelectedPolicyData(selected);

        if (selected) {
            const transformedDeductions = selected.custom_deductions?.map((deduction) => ({
                ...deduction,
            }));
            setSelectedPolicyDeductions(transformedDeductions);
        }
    };

    const bulkformattableRef = useRef(null);

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleDownload = () => {
        if (!bulkformattableRef.current) {
            toast.error("No data available to download");
            return;
        }

        try {
            const table = bulkformattableRef.current;
            const wb = XLSX.utils.table_to_book(table, { sheet: "Salary Format" });
            const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

            const blob = new Blob([s2ab(wbout)], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `Salary_Format_${selectedPolicyData.policy_name || "template"}_${new Date().toISOString().split("T")[0]}.xlsx`;
            a.click();
            window.URL.revokeObjectURL(url);
            toast.success("Template downloaded successfully");
        } catch (error) {
            console.error("Error downloading template:", error);
            toast.error("Error downloading template");
        }
    };

    const orderedSalaryStructureHeadings = (() => {
        const matchingHeadings = [];
        const nonMatchingHeadings = [];

        salaryStructureHeadings.forEach((heading) => {
            const match = selectedPolicyDeductions.find((d) => d.name === heading.id);
            if (match) {
                matchingHeadings.push({ ...heading, match_sort: match.sorting_var || 0 });
            } else {
                nonMatchingHeadings.push(heading);
            }
        });

        matchingHeadings.sort((a, b) => a.match_sort - b.match_sort);
        nonMatchingHeadings.sort((a, b) => a.sorting_var - b.sorting_var);

        return [...matchingHeadings, ...nonMatchingHeadings];
    })();

    return (
        <>
            <button
                title="Bulk Salary Format Download"
                className="model-button-download minor-button font-weight500"
                onClick={handleShow}
                style={{ margin: "2px" }}
            >
                <DownloadIcon />
                {"  "} Format
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model" size="xl">
                <Modal.Header closeButton className="task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title>Download Bulk Salary Data Format</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="form-flex-wrap">
                        {SUPER_ADMIN && <div>
                            <label htmlFor="company" className="form-labels">
                                Select Company
                            </label>
                            <div className="table-searchh dropdown-container">
                                <Office />
                                <select
                                    onChange={(e) => setToggleCompany(e.target.value)}
                                    value={toggleCompany}
                                    className="dropdown font-size-subheading"
                                >
                                    <option value="null">Select SubCompany</option>
                                    {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                </select>
                            </div>
                        </div>}

                        <div>
                            <label htmlFor="salary_policy" className="form-labels">
                                Select Salary Structure Format {(selectedPolicy !== "null") && <ViewSalaryPolicyFormatDeductions i={selectedPolicyData} buttonDisplayIcon={'BlueEye'} />}
                            </label>
                            <div className="table-searchh dropdown-container">
                                {buffer1 ? <div className="spinner-vsmall"></div> : <Filter />}
                                <select
                                    value={selectedPolicy}
                                    onChange={handlePolicySelect}
                                    className="dropdown font-size-subheading"

                                >
                                    <option value="null">Select Statuary Deduction Policy</option>
                                    {salaryDeductionPolicies?.map((i) => (
                                        <option key={i.id} value={i.id}>{i.policy_name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="flex-row">
                            <label className="form-labels">
                                {showEmpData ? "With" : "Without"} Employee Data: {" "}
                            </label>
                            <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                            <div className="checkbox-toggle">
                                <input
                                    type="checkbox"
                                    id="toggle-employees"
                                    name="show_emp_data"
                                    checked={showEmpData}
                                    onChange={() => setShowEmpData(!showEmpData)}
                                />
                                <label htmlFor="toggle-employees"></label>
                            </div>
                        </div>
                    </div>

                    {/* Downloading Format */}
                    <h5>Preview Excel Format</h5>
                    <div className="scroll-container-table" style={{ maxHeight: "50vh", overflowY: "auto", border: "1px solid #dee2e6" }}>
                        <table
                            className="scrollfix-table-css"
                            ref={bulkformattableRef}
                            style={{
                                borderColor: "#323232",
                                borderRadius: "5px",
                                padding: "0px 5px",
                                borderWidth: "1px",
                            }}
                        >
                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="summary-excel-tab br-5">emp_code</th>
                                    <th className="summary-excel-tab br-5">name</th>
                                    <th className="summary-excel-tab br-5">wef_month</th>
                                    <th className="summary-excel-tab br-5">wef_year</th>
                                    <th className="summary-excel-tab br-5">change_reason</th>
                                    {orderedSalaryStructureHeadings.map((heading) => (
                                        <React.Fragment key={heading.id}>
                                            <th className="summary-excel-tab br-5">{heading.title} fixed_amount</th>
                                            <th className="summary-excel-tab br-5">{heading.title} percentage</th>
                                            <th className="summary-excel-tab br-5">{heading.title} percentage_of</th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {showEmpData ? (
                                    buffer2 ? (
                                        <tr>
                                            <td colSpan={4 + orderedSalaryStructureHeadings.length * 3} style={{ textAlign: "center", padding: "20px" }}>
                                                <div className="spinner"></div>
                                                Loading employee data...
                                            </td>
                                        </tr>
                                    ) : allEmployeeList.length > 0 ? (
                                        allEmployeeList
                                            .sort((a, b) => a.emp_code.localeCompare(b.emp_code))
                                            // .slice(0, 20)
                                            .map((data, index) => {
                                                const inactivename = data.employee_status === "inactive" ? "#ff1212" : "black";
                                                return (
                                                    <tr style={{ color: inactivename }} key={index}>
                                                        <td className="summary-excel-tab br-5">{data.emp_code}</td>
                                                        <td className="summary-excel-tab br-5">{data.name}</td>
                                                        <td className="summary-excel-tab br-5">{data.wef_month || new Date().getMonth() + 1}</td>
                                                        <td className="summary-excel-tab br-5">{data.wef_year || new Date().getFullYear()}</td>
                                                        <td className="summary-excel-tab br-5">{data.change_reason || '-'}</td>
                                                        {orderedSalaryStructureHeadings.map((heading) => {
                                                            const matchingData = selectedPolicyDeductions.find(
                                                                (format) => format.name === heading.id
                                                            );
                                                            return (
                                                                <React.Fragment key={heading.id}>
                                                                    <td className="summary-excel-tab br-5">
                                                                        {matchingData?.fixed_amount || ""}
                                                                    </td>
                                                                    <td className="summary-excel-tab br-5">
                                                                        {matchingData?.percentage || ""}
                                                                    </td>
                                                                    <td className="summary-excel-tab br-5">
                                                                        {matchingData?.percentage_of?.length > 0
                                                                            ? matchingData?.percentage_of.map((item) => item.name_title).join(", ")
                                                                            : ""}
                                                                    </td>
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </tr>
                                                );
                                            })
                                    ) : (
                                        <tr>
                                            <td colSpan={4 + orderedSalaryStructureHeadings.length * 3} style={{ textAlign: "center", padding: "20px", color: "#6c757d" }}>
                                                No employee data available
                                            </td>
                                        </tr>
                                    )
                                ) : (
                                    <tr>
                                        <td className="summary-excel-tab br-5">[emp_code]</td>
                                        <td className="summary-excel-tab br-5">[name]</td>
                                        <td className="summary-excel-tab br-5">[wef_month]</td>
                                        <td className="summary-excel-tab br-5">[wef_year]</td>
                                        <td className="summary-excel-tab br-5">[change_reason]</td>
                                        {orderedSalaryStructureHeadings.map((heading) => {
                                            const matchingData = selectedPolicyDeductions.find(
                                                (format) => format.name === heading.id
                                            );
                                            return (
                                                <React.Fragment key={heading.id}>
                                                    <td className="summary-excel-tab br-5">
                                                        {matchingData?.fixed_amount || ""}
                                                    </td>
                                                    <td className="summary-excel-tab br-5">
                                                        {matchingData?.percentage || ""}
                                                    </td>
                                                    <td className="summary-excel-tab br-5">
                                                        {matchingData?.percentage_of?.length > 0
                                                            ? matchingData?.percentage_of.map((item) => item.name_title).join(", ")
                                                            : ""}
                                                    </td>
                                                </React.Fragment>
                                            );
                                        })}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="button-models" style={{ marginTop: "20px" }}>
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button onClick={handleDownload} className="model-button-download model-button font-weight500">
                            <DownloadIcon />
                            {"  "} Download Template
                        </button>
                    </div>
                </Modal.Body>
                <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} draggable pauseOnHover />
            </Modal>
        </>
    );
};


const BulkUpdateSalaryAPIResultsModal = ({
    show,
    handleClose,
    handleComplete,
    handleRetry,
    handleBulkUpload,
    results,
    isDryRun,
    fileName
}) => {
    const [activeTab, setActiveTab] = useState('summary');
    const [expandedRows, setExpandedRows] = useState({});

    const toggleRowExpand = (empCode) => {
        setExpandedRows(prev => ({
            ...prev,
            [empCode]: !prev[empCode]
        }));
    };

    // Calculate statistics
    const getStats = () => {
        if (!results) return null;


        // Check if this is an error response format
        const isErrorResponse = results.error || results.details;
        if (isErrorResponse) {
            // Handle error response format
            const summary = results.summary || {};
            return {
                total: summary.total_employees || 0,
                successful: summary.successful_count || 0,
                failed: summary.failed_count || 0,
                skipped: summary.skipped_count || 0,
                created: summary.total_deductions_created || 0,
                updated: summary.total_deductions_updated || 0,
                deleted: summary.total_deductions_deleted || 0,
                total_amount_impact: summary.total_amount_impact || '0.00',
                isError: true,
                errorMessage: results.error || results.details
            };
        } else {
            const summary = results.summary || {};
            return {
                total: summary.total_employees || 0,
                successful: summary.successful_count || 0,
                failed: summary.failed_count || 0,
                skipped: summary.skipped_count || 0,
                created: summary.total_deductions_created || 0,
                updated: summary.total_deductions_updated || 0,
                deleted: summary.total_deductions_deleted || 0,
                // amountImpact: summary.total_amount_impact || '0.00'
            };
        }
    };

    const stats = getStats();


    const exportToCSV = () => {
        if (!results) return;

        const csvData = [];

        const isErrorResponse = results.error || results.details;

        // Add header
        if (isErrorResponse) {
            csvData.push(['Bulk Salary Update - Error Report']);
        } else {
            csvData.push([`Bulk Salary Update - ${isDryRun ? 'Dry Run Validation' : 'Update'} Results`]);
        }

        // Add summary
        csvData.push(['Bulk Salary Update Results']);
        csvData.push(['Mode:', isDryRun ? 'Dry Run (Validation Only)' : 'Actual Update']);
        csvData.push(['File:', fileName || 'N/A']);
        csvData.push(['Timestamp:', new Date().toLocaleString()]);
        csvData.push([]);

        // Add error details if present
        if (isErrorResponse) {
            csvData.push(['Error Summary']);
            csvData.push(['Error:', results.error || 'Unknown error']);
            csvData.push(['Details:', results.details || 'No details available']);
            csvData.push([]);
        }

        // Add statistics
        csvData.push(['Summary Statistics']);
        csvData.push(['Total Employees', stats?.total]);
        csvData.push(['Successful', stats?.successful]);
        csvData.push(['Failed', stats?.failed]);
        csvData.push(['Skipped', stats?.skipped]);
        csvData.push(['Deductions Created', stats?.created]);
        csvData.push(['Deductions Updated', stats?.updated]);
        csvData.push(['Deductions Deleted', stats?.deleted]);
        // csvData.push(['Total Amount Impact', `₹${formatCurrency(stats?.amountImpact)}`]);
        csvData.push([]);

        // Add successful employees
        if (results.successful?.length > 0) {
            csvData.push(['Successful Employees']);
            csvData.push(['Index', 'Employee Code', 'Status', 'Message', 'Created', 'Updated', 'Deleted', 'Unchanged', 'Total Amount']);

            results.successful.forEach(emp => {
                csvData.push([
                    emp.index + 1,
                    emp.emp_code,
                    emp.status,
                    emp.message,
                    emp.created_count || 0,
                    emp.updated_count || 0,
                    emp.deleted_count || 0,
                    emp.unchanged_count || 0,
                    `₹${formatCurrency(emp.total_amount)}`
                ]);
            });
            csvData.push([]);
        }

        // Add failed employees from error response format
        if (results.failed_details?.length > 0) {
            csvData.push(['Failed Employees (Critical Errors)']);
            csvData.push(['Employee Code', 'Error Messages', 'Critical']);

            results.failed_details.forEach(emp => {
                const errors = Array.isArray(emp.errors) ? emp.errors.join('; ') : emp.errors;
                csvData.push([
                    emp.emp_code,
                    errors,
                    emp.is_critical ? 'YES' : 'NO'
                ]);
            });
            csvData.push([]);
        }
        // Add failed employees from success response format
        else if (results.failed?.length > 0) {
            csvData.push(['Failed Employees']);
            csvData.push(['Index', 'Employee Code', 'Status', 'Error Messages']);

            results.failed.forEach(emp => {
                const errors = Array.isArray(emp.errors) ? emp.errors.join('; ') : emp.message;
                csvData.push([
                    emp.index + 1,
                    emp.emp_code,
                    emp.status,
                    errors
                ]);
            });
            csvData.push([]);
        }

        // Add skipped employees
        if (results.skipped?.length > 0) {
            csvData.push(['Skipped Employees']);
            csvData.push(['Index', 'Employee Code', 'Status', 'Reason']);

            results.skipped.forEach(emp => {
                csvData.push([
                    emp.index + 1,
                    emp.emp_code,
                    emp.status,
                    emp.message
                ]);
            });
        }

        // Convert to CSV string
        const csvString = csvData.map(row =>
            row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(',')
        ).join('\n');

        // Create and download file
        const blob = new Blob([csvString], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `bulk-salary-update-results-${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };

    // Check if this is an error response
    const isErrorResponse = results?.error || results?.details;

    return (
        <Modal
            show={show}
            onHide={handleClose}
            dialogClassName="three-fourth-modal"
        >
            <Modal.Header className="font-weight500 font-size-heading">
                <Modal.Title>
                    {isErrorResponse ? 'Update Failed' : (isDryRun ? 'Dry Run Results' : 'Bulk Update Results')}
                </Modal.Title>
                <div className="flex-row">
                    <button
                        className="priority-button-small model-button-download"
                        onClick={exportToCSV}
                        title="Export to CSV"
                    >
                        <DownloadIcon />{" "}
                        Export CSV
                    </button>
                </div>
            </Modal.Header>

            <Modal.Body>
                {/* Show error banner for error responses */}
                {isErrorResponse && (
                    <div className="notice-badge color-tab-red mb-3">
                        <strong>❌ Transaction Failed:</strong> {results.error || 'Unknown error'}
                        <br />
                        <strong>Details:</strong> {results.details || 'No additional details'}
                        <br />
                        <strong>Mode:</strong> {results.dry_run ? 'Dry Run (Validation)' : 'Actual Update'}
                    </div>
                )}
                <div className="field-cont justify-between">
                    {/* Summary Cards */}
                    <div className="flex-row gap-3">
                        <div className="color-card color-card-success">
                            <div className="priority-button color-tab-green">
                                <CheckTick />
                            </div>
                            <hr className="field-cont-hr" />
                            <div className="flex-column align-start">
                                <div className="font-weight600 font-size-heading">{stats?.successful}</div>
                                <div className="font-size-label text-secondary-color">Successful</div>
                            </div>
                        </div>

                        <div className="color-card color-card-danger">
                            <div className="priority-button color-tab-red">
                                <CrossRed />
                            </div>
                            <hr className="field-cont-hr" />
                            <div className="flex-column align-start">
                                <div className="font-weight600 font-size-heading">{stats?.failed}</div>
                                <div className="font-size-label text-secondary-color">Failed</div>
                            </div>
                        </div>

                        <div className="color-card color-card-warning">
                            <div className="priority-button color-tab-yellow">
                                <WarnYellow />
                            </div>
                            <hr className="field-cont-hr" />
                            <div className="flex-column align-start">
                                <div className="font-weight600 font-size-heading">{stats?.skipped}</div>
                                <div className="font-size-label text-secondary-color">Skipped</div>
                            </div>
                        </div>

                        {/* <div className="color-card color-card-info">
                            <div className="priority-button color-tab-blue">
                                ₹
                            </div>
                            <div className="flex-column align-start">
                                <div className="font-weight600 font-size-heading">₹{formatCurrency(stats?.amountImpact||0)}</div>
                                <div className="font-size-label text-secondary-color">Amount Impact</div>
                            </div>
                        </div> */}
                    </div>
                    <hr className="field-cont-hr" />

                    {/* Deduction Changes Summary */}
                    <div className="flex-row gap-3">
                        <div className="priority-button text-center color-button-success">
                            <div className="font-size-label text-uppercase">Created</div>
                            <div className="font-size-heading font-weight600">{stats?.created || 0}</div>
                        </div>

                        <div className="priority-button text-center color-button-warning">
                            <div className="font-size-label text-uppercase">Updated</div>
                            <div className="font-size-heading font-weight600">{stats?.updated || 0}</div>
                        </div>

                        <div className="priority-button text-center color-button-danger">
                            <div className="font-size-label text-uppercase">Deleted</div>
                            <div className="font-size-heading font-weight600">{stats?.deleted || 0}</div>
                        </div>
                    </div>
                </div>

                {/* Tabs for Detailed View */}
                <div className="bloc-tabss wfm-margin">
                    <button
                        className={`dashboardcomponent-tabs  ${activeTab === 'summary' ? 'dashboardcomponent-active-tabs' : ''}`}
                        onClick={() => setActiveTab('summary')}
                    >
                        Summary ({stats?.total})
                    </button>
                    {!isErrorResponse && results?.successful?.length > 0 && (
                        <button
                            className={`dashboardcomponent-tabs ${activeTab === 'successful' ? 'dashboardcomponent-active-tabs' : ''}`}
                            onClick={() => setActiveTab('successful')}
                        >
                            Successful ({results.successful.length})
                        </button>
                    )}
                    {(results?.failed?.length > 0 || results?.failed_details?.length > 0) && (
                        <button
                            className={`dashboardcomponent-tabs  ${activeTab === 'failed' ? 'dashboardcomponent-active-tabs' : ''}`}
                            onClick={() => setActiveTab('failed')}
                        >
                            Failed ({results.failed.length})
                        </button>
                    )}
                    {!isErrorResponse && results?.skipped?.length > 0 && (
                        <button
                            className={`dashboardcomponent-tabs  ${activeTab === 'skipped' ? 'dashboardcomponent-active-tabs' : ''}`}
                            onClick={() => setActiveTab('skipped')}
                        >
                            Skipped ({results.skipped.length})
                        </button>
                    )}
                </div>

                {/* Tab Content */}
                <div className="scrollfix-container" style={{ maxHeight: '400px' }}>
                    {activeTab === 'summary' && (
                        <div className="summary-details">
                            {!isErrorResponse && (<div className="notice-badge color-tab-teal mb-2">
                                <strong>Mode:</strong> {isDryRun ? 'Dry Run (Validation Only)' : 'Actual Update'}
                                <br />
                                <strong>File:</strong> {fileName || 'N/A'}
                                <br />
                                <strong>Message:</strong> {results?.message || 'Processing completed'}
                            </div>)}
                            {stats?.failed > 0 && (
                                <div className="notice-badge color-tab-red mb-2">
                                    <strong>Attention:</strong> {stats?.failed} employee(s) failed to process.
                                    Please check the "Failed" tab for details.
                                </div>
                            )}

                            {!isErrorResponse && stats?.skipped > 0 && (
                                <div className="notice-badge color-tab-yellow mb-2">
                                    <strong>Note:</strong> {stats?.skipped} employee(s) were skipped.
                                    Please check the "Skipped" tab for details.
                                </div>
                            )}
                        </div>
                    )}

                    {/* {activeTab === 'successful' && !isErrorResponse && (
                        <div className="scroll-container-table">
                            {results.successful.map((emp, idx) => (
                                <div key={idx} className="result-card color-card-success">
                                    <div
                                        className="result-card-header flex-row justify-between"
                                        onClick={() => toggleRowExpand(emp.emp_code)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="flex-row justify-start">
                                            <div className="employee-code">
                                                <CheckTick />
                                                {emp.emp_code}
                                            </div>
                                            <div className="employee-status text-uppercase">{emp.status}</div>
                                            <div className="font-size-text">{emp.message}</div>
                                        </div>
                                        <div className="flex-row ">
                                            <div className="employee-actions justify-end">
                                                <span className="badge color-badge-green">
                                                    +{emp.created_count || 0}
                                                </span>
                                                <span className="badge color-badge-yellow">
                                                    ~{emp.updated_count || 0}
                                                </span>
                                                <span className="badge color-badge-red">
                                                    -{emp.deleted_count || 0}
                                                </span>
                                                <span className="badge color-badge-blue">
                                                    ₹{formatCurrency(emp.total_amount || 0)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {expandedRows[emp.emp_code] && (
                                        <div className="result-card-details">
                                            <div className="grid grid-cols-2 gap-2 mb-2">
                                                <div><strong>Created:</strong> {emp.created_count}</div>
                                                <div><strong>Updated:</strong> {emp.updated_count}</div>
                                                <div><strong>Deleted:</strong> {emp.deleted_count}</div>
                                                <div><strong>Unchanged:</strong> {emp.unchanged_count}</div>
                                            </div>

                                            {emp.changes_preview && emp.changes_preview.length > 0 && (
                                                <div className="font-sixe-text">
                                                    <strong>Changes Preview:</strong>
                                                    <ul>
                                                        {emp.changes_preview.map((change, idx) => (
                                                            <li key={idx}>{change}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )} */}

                    {activeTab === 'successful' && !isErrorResponse && (
                        <div className="scroll-container-table">
                            {results.successful.map((emp, idx) => (
                                <div key={idx} className="result-card color-card-success">
                                    <div
                                        className="result-card-header flex-row justify-between"
                                        onClick={() => toggleRowExpand(emp.emp_code)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="flex-row justify-start align-center">
                                            <div className="employee-code flex-row align-center gap-1">
                                                <CheckTick />
                                                <strong>{emp.emp_code}</strong>
                                                <div className="text-uppercase badge color-badge-green">
                                                    {emp.status}
                                                </div>
                                            </div>
                                            <div className="font-size-text ml-2">{emp.message}</div>
                                        </div>
                                        <div className="flex-row align-center">
                                            <div className="employee-actions flex-row gap-1">
                                                {emp.created_count > 0 && (
                                                    <span className="badge color-badge-green" title="Created">
                                                        +{emp.created_count}
                                                    </span>
                                                )}
                                                {emp.updated_count > 0 && (
                                                    <span className="badge color-badge-yellow" title="Updated">
                                                        ~{emp.updated_count}
                                                    </span>
                                                )}
                                                {emp.deleted_count > 0 && (
                                                    <span className="badge color-badge-red" title="Deleted">
                                                        -{emp.deleted_count}
                                                    </span>
                                                )}
                                                {/* <span className="badge color-badge-blue" title="Total Amount">
                                                    ₹{formatCurrency(emp.total_amount || 0)}
                                                </span> */}
                                                {emp.dry_run && (
                                                    <span className="badge color-badge-info" title="Dry Run">
                                                        TEST
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {expandedRows[emp.emp_code] && (
                                        <div className="result-card-details pt-2">
                                            {/* Summary Statistics */}
                                            <div className="flex-row justify-evenly">
                                                <div className="flex-column">
                                                    <div className="font-size-label text-secondary-color">Created</div>
                                                    <div className="text-center font-weight600">{emp.created_count}</div>
                                                </div>
                                                <div className="flex-column">
                                                    <div className="font-size-label text-secondary-color">Updated</div>
                                                    <div className="text-center font-weight600">{emp.updated_count}</div>
                                                </div>
                                                <div className="flex-column">
                                                    <div className="font-size-label text-secondary-color">Deleted</div>
                                                    <div className="text-center font-weight600">{emp.deleted_count}</div>
                                                </div>
                                                <div className="flex-column">
                                                    <div className="font-size-label text-secondary-color">Unchanged</div>
                                                    <div className="text-center font-weight600">{emp.unchanged_count}</div>
                                                </div>
                                            </div>

                                            {/* Changes Preview */}
                                            {emp.changes_preview && emp.changes_preview.length > 0 && (
                                                <div className="mb-3">
                                                    <div className="font-weight500 font-size-subheading mb-1">
                                                        Changes {emp.dry_run ? 'Preview' : 'Applied'}
                                                    </div>
                                                    <div className="changes-list">
                                                        {emp.changes_preview.map((change, changeIdx) => (
                                                            <div key={changeIdx} className="change-item mb-1">
                                                                <div className="flex-row align-start justify-between">
                                                                    <div className="flex-column">
                                                                        <div className="font-weight500">
                                                                            {change.deduction}
                                                                        </div>
                                                                        {change.changes && (
                                                                            <div className="font-size-text ml-2">
                                                                                {change.changes.map((chg, idx) => (
                                                                                    <div key={idx}>• {chg}</div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                        {change.details && (
                                                                            <div className="font-size-text ml-2">
                                                                                <div>• Fixed Amount: {change.details.fixed_amount || 'None'}</div>
                                                                                {change.details.percentage && (
                                                                                    <div>• Percentage: {change.details.percentage}%</div>
                                                                                )}
                                                                                {change.details.percentage_of && change.details.percentage_of.length > 0 && (
                                                                                    <div>• Percent of: {change.details.percentage_of.join(', ')}</div>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                        {change.current_value && (
                                                                            <div className="font-size-text ml-2">
                                                                                <div>• Current: {change.current_value.fixed_amount || change.current_value.percentage}%</div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <span className={`badge ${change.type === 'CREATE' ? 'color-badge-green' :
                                                                        change.type === 'UPDATE' ? 'color-badge-yellow' :
                                                                            'color-badge-red'
                                                                        }`}>
                                                                        {change.type}
                                                                    </span>

                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {/* Current vs Proposed Comparison */}
                                            {emp.current_deductions?.length > 0 && (
                                                <div className="mb-3">
                                                    <div className="font-weight500 font-size-subheading mb-1">
                                                        Salary Structure Comparison
                                                    </div>
                                                    <div className="comparison-table scroll-container-table" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                        <table className="scrollfix-table-css" style={{ width: '100%', fontSize: '0.85rem' }}>
                                                            <thead>
                                                                <tr className="custom-table-head-tr">
                                                                    <th style={{ width: '30%' }}>Component</th>
                                                                    <th style={{ width: '20%' }}>Type</th>
                                                                    <th style={{ width: '20%' }}>Current</th>
                                                                    <th style={{ width: '20%' }}>Proposed</th>
                                                                    <th style={{ width: '10%' }}>Change</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {emp.current_deductions.map((current, idx) => {

                                                                    const proposed = emp.proposed_deductions?.find(p =>
                                                                        p.name_title === current.name_title || p.id === current.id
                                                                    );

                                                                    const isCreated = !current.id && proposed;
                                                                    const isDeleted = current.id && !proposed;

                                                                    // Fix: Compare numeric values instead of string values
                                                                    const compareValues = (val1, val2) => {
                                                                        const num1 = val1 ? parseFloat(val1) : null;
                                                                        const num2 = val2 ? parseFloat(val2) : null;

                                                                        if (num1 === null && num2 === null) return true;
                                                                        if (num1 === null || num2 === null) return false;

                                                                        return num1 === num2;
                                                                    };

                                                                    // Fix: Compare percentage_of arrays properly
                                                                    const comparePercentageOf = (arr1, arr2) => {
                                                                        const normalize = (arr) => {
                                                                            if (!arr) return [];
                                                                            return arr.map(item => {
                                                                                if (typeof item === 'string') return item;
                                                                                if (typeof item === 'object' && item.name_title) return item.name_title;
                                                                                return String(item);
                                                                            }).sort();
                                                                        };

                                                                        return JSON.stringify(normalize(arr1)) === JSON.stringify(normalize(arr2));
                                                                    };

                                                                    const isUpdated = proposed && (
                                                                        !compareValues(current.fixed_amount, proposed.fixed_amount) ||
                                                                        !compareValues(current.percentage, proposed.percentage) ||
                                                                        !comparePercentageOf(current.percentage_of, proposed.percentage_of)
                                                                    );

                                                                    return (
                                                                        <tr key={idx} className={
                                                                            isCreated ? 'color-bg-success-light' :
                                                                                isDeleted ? 'color-bg-danger-light' :
                                                                                    isUpdated ? 'color-bg-warning-light' : ''
                                                                        }>
                                                                            <td>
                                                                                <div className="flex-row justify-between">
                                                                                    {current.name_title}
                                                                                    {/* {isCreated && <span className="status-badge color-badge-green mr-1">+</span>}
                                                                                    {isDeleted && <span className="status-badge color-badge-red mr-1">-</span>}
                                                                                    {isUpdated && <span className="status-badge color-badge-yellow mr-1">~</span>} */}
                                                                                </div>
                                                                            </td>
                                                                            <td>{current.name_type}</td>
                                                                            <td>
                                                                                {current.fixed_amount ? (
                                                                                    <div>₹{formatCurrency(current.fixed_amount)}</div>
                                                                                ) : current.percentage ? (
                                                                                    <div>{current.percentage}% of<br />
                                                                                        {current.percentage_of.join(', ')}
                                                                                        {/* {current.percentage_of?.map(item => item.name_title).join(', ')} */}
                                                                                    </div>
                                                                                ) : '-'}
                                                                            </td>
                                                                            <td>
                                                                                {proposed ? (
                                                                                    proposed.fixed_amount ? (
                                                                                        <div>₹{formatCurrency(proposed.fixed_amount)}</div>
                                                                                    ) : proposed.percentage ? (
                                                                                        <div>
                                                                                            {proposed.percentage}% of<br />
                                                                                            {current.percentage_of.join(', ')}
                                                                                            {/* {proposed.percentage_of?.map(item => item.name_title).join(', ')} */}
                                                                                        </div>
                                                                                    ) : '-'
                                                                                ) : '-'}
                                                                            </td>
                                                                            <td>
                                                                                {isCreated && (
                                                                                    <span className="badge color-badge-green">New</span>
                                                                                )}
                                                                                {isDeleted && (
                                                                                    <span className="badge color-badge-red">Removed</span>
                                                                                )}
                                                                                {isUpdated && (
                                                                                    <span className="badge color-badge-yellow">Changed</span>
                                                                                )}
                                                                                {!isCreated && !isDeleted && !isUpdated && (
                                                                                    <span className="badge color-badge-gray">Same</span>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}

                                                                {/* Show newly created deductions that aren't in current_deductions */}
                                                                {emp.proposed_deductions?.filter(p =>
                                                                    !emp.current_deductions.some(c =>
                                                                        c.name_title === p.name_title || c.id === p.id
                                                                    )
                                                                ).map((proposed, idx) => (
                                                                    <tr key={`new-${idx}`} className="color-bg-success-light">
                                                                        <td>
                                                                            <div className="flex-row align-center">
                                                                                <span className="color-badge-green mr-1">+</span>
                                                                                {proposed.name_title}
                                                                            </div>
                                                                        </td>
                                                                        <td>{proposed.name_type}</td>
                                                                        <td>-</td>
                                                                        <td>
                                                                            {proposed.fixed_amount ? (
                                                                                <div>₹{formatCurrency(proposed.fixed_amount)}</div>
                                                                            ) : proposed.percentage ? (
                                                                                <div>{proposed.percentage}%</div>
                                                                            ) : '-'}
                                                                        </td>
                                                                        <td>
                                                                            <span className="badge color-badge-green">New</span>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Additional Info */}
                                            <div className="additional-info">
                                                {emp.earliest_allowed_period && (
                                                    <div className="flex-row align-center mb-1">
                                                        <span className="font-weight500 mr-2">Earliest Allowed:</span>
                                                        <span className="badge color-badge-emerald">
                                                            {emp.earliest_allowed_period}
                                                        </span>
                                                    </div>
                                                )}
                                                {/* {emp.salary_log_id && emp.salary_log_id !== 'SIMULATED_IN_DRY_RUN' && (
                                                    <div className="flex-row align-center mb-1">
                                                        <span className="font-weight500 mr-2">Log ID:</span>
                                                        <span className="font-size-text text-secondary-color">
                                                            {emp.salary_log_id.substring(0, 8)}...
                                                        </span>
                                                    </div>
                                                )} */}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}

                    {activeTab === 'failed' && (
                        <div className="scroll-container-table">
                            {/* Display failed employees from error response */}
                            {isErrorResponse && results.failed_details?.map((emp, idx) => (
                                <div key={idx} className="result-card color-card-danger">
                                    <div className="result-card-header">
                                        <div className="employee-code">
                                            <CrossRed />
                                            {emp.emp_code}
                                        </div>
                                        <div className="employee-status text-uppercase">CRITICAL ERROR</div>
                                        <div className="employee-actions">
                                            <span className="badge color-badge-red">
                                                {emp.is_critical ? 'CRITICAL' : 'ERROR'}
                                            </span>
                                        </div>
                                    </div>

                                    {emp.errors && (
                                        <div className="result-card-details">
                                            <strong>Error Details:</strong>
                                            <ul className="">
                                                {(Array.isArray(emp.errors) ? emp.errors : [emp.errors]).map((error, errIdx) => (
                                                    <li key={errIdx} className="font-size-text error-message-input">
                                                        {error}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            ))}

                            {/* Display failed employees from success response */}
                            {!isErrorResponse && results.failed.map((emp, idx) => (
                                <div key={idx} className="result-card color-card-danger">
                                    <div className="result-card-header">
                                        <div className="employee-code">
                                            <CrossRed />
                                            {emp.emp_code}
                                        </div>
                                        <div className="employee-status text-uppercase">{emp.status}</div>
                                        <div className="font-size-text">
                                            {emp.message || emp.errors?.[0] || 'Unknown error'}
                                        </div>
                                    </div>

                                    {emp.errors && emp.errors.length > 0 && (
                                        <div className="result-card-details">
                                            <strong>Error Details:</strong>
                                            <ul className="">
                                                {emp.errors.map((error, errIdx) => (
                                                    <li key={errIdx} className="font-size-text error-message-input">{error}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}

                    {activeTab === 'skipped' && !isErrorResponse && (
                        <div className="scroll-container-table">
                            {results.skipped.map((emp, idx) => (
                                <div key={idx} className="result-card color-card-warning">
                                    <div className="result-card-header">
                                        <div className="employee-code">
                                            {/* <Arrow size={16} className="mr-2" /> */}
                                            <WarnYellow />
                                            {emp.emp_code}
                                        </div>
                                        <div className="employee-status text-uppercase">{emp.status}</div>
                                        <div className="font-size-text">{emp.message}</div>
                                        <div className="employee-actions ">
                                            <span className=" justify-center status-badge color-badge-emerald">
                                                Earliest: {emp.earliest_allowed_period}
                                            </span>
                                        </div>
                                    </div>

                                    {emp.errors && emp.errors.length > 0 && (
                                        <div className="result-card-details">
                                            <strong>Validation Errors:</strong>
                                            <ul className="">
                                                {emp.errors.map((error, errIdx) => (
                                                    <li key={errIdx} className="font-size-text error-message-input">{error}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Action Buttons */}
                <div className="button-models">
                    {/* <button
                        className="model-button-cancel model-button font-weight500"
                        onClick={handleClose}
                    >
                        Close
                    </button> */}
                    <button
                        className="model-button-cancel model-button font-weight500"
                        onClick={handleComplete}
                    >
                        Done
                    </button>

                    {!isErrorResponse && isDryRun && stats?.failed === 0 && (
                        <button
                            className="model-button-download model-button font-weight500"
                            onClick={handleRetry}
                        >
                            Retry
                        </button>
                    )}

                    {/* Only show Bulk Upload button for dry run with no errors */}
                    {/* {!isErrorResponse && isDryRun && stats?.failed === 0 && (
                        <button
                            className="model-button-download model-button font-weight500"
                            onClick={handleBulkUpload}
                        >
                            Proceed with Actual Update
                        </button>
                    )} */}
                </div>
            </Modal.Body>
        </Modal>
    );
};

//component for Payrun Operation Result Modal 
const PayrunOperationResultModal = ({
    show,
    handleClose,
    handleComplete,
    handleRetry,
    handleBulkUpload,
    results,
    isDryRun,
    fileName,
    operationType,
    restData
}) => {

    const isPayrun = operationType === PAYRUN_OPERATION.PAYRUN;
    const isBulkUpdate = operationType === PAYRUN_OPERATION.BULK_UPDATE;
    const [activeTab, setActiveTab] = useState('summary');
    const [expandedRows, setExpandedRows] = useState({});

    const toggleRowExpand = (empCode) => {
        setExpandedRows(prev => ({
            ...prev,
            [empCode]: !prev[empCode]
        }));
    };



    const getStats = () => {
        if (!results) return null;

        const summary = results.summary || {};
        const isErrorResponse = Boolean(results.error || results.details);

        // Base stats (common for all)
        const baseStats = {
            total: summary.total_employees || 0,
            successful: summary.successful_count || 0,
            failed: summary.failed_count || 0,
            skipped: summary.skipped_count || 0
        };

        // PAYRUN stats
        const payrunStats = {
            created: summary.created_slips || 0,
            updated: summary.updated_slips || 0,
            deleted: 0
        };

        // BULK UPDATE stats
        const bulkUpdateStats = {
            created: summary.total_deductions_created || 0,
            updated: summary.total_deductions_updated || 0,
            deleted: summary.total_deductions_deleted || 0
        };


        const operationStats = isPayrun ? payrunStats : bulkUpdateStats;


        return {
            ...baseStats,
            ...operationStats,
            total_amount_impact: summary.total_amount_impact || summary.total_amount || '0.00',
            isError: isErrorResponse,
            errorMessage: isErrorResponse
                ? results.error || results.details
                : null
        };
    };


    const stats = getStats();


    const exportBulkupdateToCSV = () => {
        if (!results) return;

        const csvData = [];

        const isErrorResponse = results.error || results.details;

        // Add header
        if (isErrorResponse) {
            csvData.push(['Bulk Salary Update - Error Report']);
        } else {
            csvData.push([`Bulk Salary Update - ${isDryRun ? 'Dry Run Validation' : 'Update'} Results`]);
        }

        // Add summary
        csvData.push(['Bulk Salary Update Results']);
        csvData.push(['Mode:', isDryRun ? 'Dry Run (Validation Only)' : 'Actual Update']);
        csvData.push(['File:', fileName || 'N/A']);
        csvData.push(['Timestamp:', new Date().toLocaleString()]);
        csvData.push([]);

        // Add error details if present
        if (isErrorResponse) {
            csvData.push(['Error Summary']);
            csvData.push(['Error:', results.error || 'Unknown error']);
            csvData.push(['Details:', results.details || 'No details available']);
            csvData.push([]);
        }

        // Add statistics
        csvData.push(['Summary Statistics']);
        csvData.push(['Total Employees', stats?.total]);
        csvData.push(['Successful', stats?.successful]);
        csvData.push(['Failed', stats?.failed]);
        csvData.push(['Skipped', stats?.skipped]);
        csvData.push(['Deductions Created', stats?.created]);
        csvData.push(['Deductions Updated', stats?.updated]);
        csvData.push(['Deductions Deleted', stats?.deleted]);
        // csvData.push(['Total Amount Impact', `₹${formatCurrency(stats?.amountImpact)}`]);
        csvData.push([]);

        // Add successful employees
        if (results.successful?.length > 0) {
            csvData.push(['Successful Employees']);
            csvData.push(['Index', 'Employee Code', 'Status', 'Message', 'Created', 'Updated', 'Deleted', 'Unchanged', 'Total Amount']);

            results.successful.forEach(emp => {
                csvData.push([
                    emp.index + 1,
                    emp.emp_code,
                    emp.status,
                    emp.message,
                    emp.created_count || 0,
                    emp.updated_count || 0,
                    emp.deleted_count || 0,
                    emp.unchanged_count || 0,
                    `₹${formatCurrency(emp.total_amount)}`
                ]);
            });
            csvData.push([]);
        }

        // Add failed employees from error response format
        if (results.failed_details?.length > 0) {
            csvData.push(['Failed Employees (Critical Errors)']);
            csvData.push(['Employee Code', 'Error Messages', 'Critical']);

            results.failed_details.forEach(emp => {
                const errors = Array.isArray(emp.errors) ? emp.errors.join('; ') : emp.errors;
                csvData.push([
                    emp.emp_code,
                    errors,
                    emp.is_critical ? 'YES' : 'NO'
                ]);
            });
            csvData.push([]);
        }
        // Add failed employees from success response format
        else if (results.failed?.length > 0) {
            csvData.push(['Failed Employees']);
            csvData.push(['Index', 'Employee Code', 'Status', 'Error Messages']);

            results.failed.forEach(emp => {
                const errors = Array.isArray(emp.errors) ? emp.errors.join('; ') : emp.message;
                csvData.push([
                    emp.index + 1,
                    emp.emp_code,
                    emp.status,
                    errors
                ]);
            });
            csvData.push([]);
        }

        // Add skipped employees
        if (results.skipped?.length > 0) {
            csvData.push(['Skipped Employees']);
            csvData.push(['Index', 'Employee Code', 'Status', 'Reason']);

            results.skipped.forEach(emp => {
                csvData.push([
                    emp.index + 1,
                    emp.emp_code,
                    emp.status,
                    emp.message
                ]);
            });
        }

        // Convert to CSV string
        const csvString = csvData.map(row =>
            row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(',')
        ).join('\n');

        // Create and download file
        const blob = new Blob([csvString], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `bulk-salary-update-results-${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };

    const exportPayrunToCSV = () => {
        if (!results) return;

        const csvData = [];

        // Header
        csvData.push(['PAYRUN Execution Report']);
        csvData.push([]);

        // Summary info
        csvData.push(['Mode', results.dry_run ? 'Dry Run (Validation)' : 'Actual Payrun']);
        csvData.push(['Ignore Existing mode', results.ignore_existing_mode ? 'Enabled' : 'Not Enabled']);
        csvData.push(['Executed By', restData.updatedBy || 'N/A']);
        csvData.push(['Timestamp', new Date().toLocaleString()]);
        csvData.push([]);

        // Overall message
        csvData.push(['Message']);
        csvData.push([restData?.message || 'PAYRUN executed']);
        csvData.push([]);

        // Summary statistics
        csvData.push(['Summary Statistics']);
        csvData.push(['Successful', results.successful?.length || 0]);
        csvData.push(['Failed', results.failed?.length || 0]);
        csvData.push([]);

        // Successful employees
        if (results.successful?.length > 0) {
            csvData.push(['Successful Employees']);
            csvData.push(['Index', 'Employee Code', 'Status', 'Message']);

            results.successful.forEach((emp, idx) => {
                csvData.push([
                    idx + 1,
                    emp.emp_code,
                    emp.status || 'SUCCESS',
                    emp.message || 'Salary slip processed'
                ]);
            });
            csvData.push([]);
        }

        // Failed employees
        if (results.failed?.length > 0) {
            csvData.push(['Failed Employees']);
            csvData.push([
                'Index',
                'Employee Code',
                'Status',
                'Errors',
                'Missing Months',
                'Critical'
            ]);

            results.failed.forEach((emp, idx) => {
                csvData.push([
                    idx + 1,
                    emp.emp_code,
                    emp.status || 'FAILED',
                    Array.isArray(emp.errors)
                        ? emp.errors.join('; ')
                        : emp.message || 'Unknown error',
                    emp.missing_months?.join(', ') || '-',
                    emp.is_critical ? 'YES' : 'NO'
                ]);
            });
            csvData.push([]);
        }



        // Convert to CSV
        const csvString = csvData
            .map(row =>
                row.map(cell =>
                    `"${String(cell ?? '').replace(/"/g, '""')}"`
                ).join(',')
            )
            .join('\n');

        // Download
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = `payrun-results-${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };


    // Check if this is an error response
    const isErrorResponse = results?.error || results?.details;

    const successfulCount = results?.successful?.length || 0;
    const failedCount =
        results?.failed_details?.length ||
        results?.failed?.length ||
        0;
    const skippedCount = results?.skipped?.length || 0;


    return (
        <Modal
            show={show}
            onHide={handleClose}
            dialogClassName="three-fourth-modal"
        >
            <Modal.Header className="font-weight500 font-size-heading">
                <Modal.Title>
                    {isPayrun
                        ? 'Payrun Results'
                        : isDryRun
                            ? 'Bulk Update - Dry Run Results'
                            : 'Bulk Update Results'}
                </Modal.Title>

                {/* <div className="flex-row">
                    <button
                        className="priority-button-small model-button-download"
                        onClick={exportToCSV}
                        title="Export to CSV"
                    >
                        <DownloadIcon />{" "}
                        Export CSV
                    </button>
                </div> */}
                <div className="flex-row">
                    <button
                        className="priority-button-small model-button-download"
                        title="Export to CSV"
                        onClick={() => {
                            if (isPayrun) {
                                exportPayrunToCSV();
                            } else {
                                exportBulkupdateToCSV();
                            }
                        }}>
                        <DownloadIcon />{" "}
                        Export CSV
                    </button>
                </div>

            </Modal.Header>

            <Modal.Body>
                {/* Show error banner for error responses */}
                {isErrorResponse && (
                    <div className="notice-badge color-tab-red mb-3">
                        <strong>
                            ❌ {isPayrun ? 'Payrun Failed:' : 'Bulk Salary Update Failed:'}
                        </strong>{' '}
                        {results.error || 'Unknown error'}

                        <br />
                        <strong>Details:</strong>{' '}
                        {results.details || 'No additional details available'}


                        {isBulkUpdate && (
                            <>
                                <br />
                                <strong>Mode:</strong>{' '}
                                {results.dry_run ? 'Dry Run (Validation)' : 'Actual Update'}
                            </>
                        )}
                    </div>
                )}

                <div className="field-cont justify-between">
                    {/* Summary Cards */}
                    <div className="flex-row gap-3">
                        <div className="color-card color-card-success">
                            <div className="priority-button color-tab-green">
                                <CheckTick />
                            </div>
                            <hr className="field-cont-hr" />
                            <div className="flex-column align-start">
                                <div className="font-weight600 font-size-heading">{stats?.successful}</div>
                                <div className="font-size-label text-secondary-color">Successful</div>
                            </div>
                        </div>

                        <div className="color-card color-card-danger">
                            <div className="priority-button color-tab-red">
                                <CrossRed />
                            </div>
                            <hr className="field-cont-hr" />
                            <div className="flex-column align-start">
                                <div className="font-weight600 font-size-heading">{stats?.failed}</div>
                                <div className="font-size-label text-secondary-color">Failed</div>
                            </div>
                        </div>

                        <div className="color-card color-card-warning">
                            <div className="priority-button color-tab-yellow">
                                <WarnYellow />
                            </div>
                            <hr className="field-cont-hr" />
                            <div className="flex-column align-start">
                                <div className="font-weight600 font-size-heading">{stats?.skipped}</div>
                                <div className="font-size-label text-secondary-color">Skipped</div>
                            </div>
                        </div>
                    </div>
                    {/* <hr className="field-cont-hr" /> */}

                    {/* Operation Summary */}
                    <div className="flex-row gap-3">
                        <div className="priority-button text-center color-button-success">
                            <div className="font-size-label text-uppercase">
                                {isPayrun ? 'Slips Created' : 'Created'}
                            </div>
                            <div className="font-size-heading font-weight600">{stats?.created || 0}</div>
                        </div>

                        <div className="priority-button text-center color-button-warning">
                            <div className="font-size-label text-uppercase">
                                {isPayrun ? 'Slips Updated' : 'Updated'}
                            </div>
                            <div className="font-size-heading font-weight600">{stats?.updated || 0}</div>
                        </div>

                        {!isPayrun && (
                            <div className="priority-button text-center color-button-danger">
                                <div className="font-size-label text-uppercase">Deleted</div>
                                <div className="font-size-heading font-weight600">
                                    {stats?.deleted || 0}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Tabs for Detailed View */}
                <div className="bloc-tabss wfm-margin">
                    <button
                        className={`dashboardcomponent-tabs  ${activeTab === 'summary' ? 'dashboardcomponent-active-tabs' : ''}`}
                        onClick={() => setActiveTab('summary')}
                    >
                        Summary ({stats?.total || 0})
                    </button>
                    {successfulCount > 0 && (
                        <button
                            className={`dashboardcomponent-tabs ${activeTab === 'successful' ? 'dashboardcomponent-active-tabs' : ''
                                }`}
                            onClick={() => setActiveTab('successful')}
                        >
                            Successful ({successfulCount})
                        </button>
                    )}
                    {failedCount > 0 && (
                        <button
                            className={`dashboardcomponent-tabs ${activeTab === 'failed' ? 'dashboardcomponent-active-tabs' : ''
                                }`}
                            onClick={() => setActiveTab('failed')}
                        >
                            Failed ({failedCount})
                        </button>
                    )}

                    {skippedCount > 0 && (
                        <button
                            className={`dashboardcomponent-tabs ${activeTab === 'skipped' ? 'dashboardcomponent-active-tabs' : ''
                                }`}
                            onClick={() => setActiveTab('skipped')}
                        >
                            Skipped ({skippedCount})
                        </button>
                    )}
                </div>


                {/* Tab Content */}
                <div className="scrollfix-container" style={{ maxHeight: '400px' }}>
                    {activeTab === 'summary' && (
                        <div className="summary-details">
                            {!isErrorResponse && (<div className="notice-badge color-tab-teal mb-2">
                                <strong>Mode:</strong> {isDryRun ? 'Dry Run (Validation Only)' : 'Actual Update'}
                                <br />
                                {!isPayrun && fileName && (
                                    <>
                                        <strong>File:</strong> {fileName}
                                        <br />
                                    </>
                                )}

                                {(results?.ignore_existing_mode || results?.partial_mode) && (
                                    <div>
                                        <strong>{results?.ignore_existing_mode ? 'Ignore Existing Mode:' : 'Partial Mode:'}</strong> Enabled
                                    </div>
                                )}

                                {(results?.updated_by || restData?.updatedBy) && (
                                    <div>
                                        <strong>Updated By:</strong> {results.updated_by || restData?.updatedBy}
                                    </div>
                                )}


                                <strong>Message:</strong> {results?.message || restData?.message || 'Processing completed'}
                            </div>)}
                            {stats?.failed > 0 && (
                                <div className="notice-badge color-tab-red mb-2">
                                    <strong>Attention:</strong> {stats?.failed} employee(s) failed to process.
                                    Please check the "Failed" tab for details.
                                </div>
                            )}

                            {!isErrorResponse && stats?.skipped > 0 && (
                                <div className="notice-badge color-tab-yellow mb-2">
                                    <strong>Note:</strong> {stats?.skipped} employee(s) were skipped.
                                    Please check the <strong>Skipped</strong> tab for details.
                                </div>
                            )}
                        </div>
                    )}


                    {activeTab === 'successful' && !isErrorResponse && results?.successful?.length > 0 && (
                        <div className="scroll-container-table">
                            {results.successful.map((emp, idx) => (
                                <div key={idx} className="result-card color-card-success">
                                    <div
                                        className="result-card-header flex-row justify-between"
                                        onClick={() => toggleRowExpand(emp.emp_code)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="flex-row justify-start align-center">
                                            <div className="employee-code flex-row align-center gap-1">
                                                <CheckTick />
                                                <strong>{emp.emp_code}</strong>
                                                {emp.name && isPayrun && (
                                                    <span className="font-size-text text-secondary-color ml-2">
                                                        ({emp.name})
                                                    </span>
                                                )}
                                                <div className="text-uppercase badge color-badge-green">
                                                    {emp.status}
                                                </div>
                                                {isPayrun && emp.total_amount && (
                                                    <span className="font-size-text text-secondary-color ml-3">
                                                        Salary: ₹{parseFloat(emp.total_amount).toLocaleString('en-IN')}
                                                    </span>
                                                )}

                                                {isPayrun && emp.action && (
                                                    <span className={`badge ${emp.action === 'created' ? 'color-badge-green' : 'color-badge-yellow'} ml-2`}>
                                                        {emp.action === 'created' ? 'Created' : 'Updated'}
                                                    </span>
                                                )}

                                            </div>
                                            <div className="font-size-text ml-2">{emp.message}</div>
                                        </div>

                                        {/* ACTION BADGES */}
                                        <div className="employee-actions flex-row gap-1">
                                            {/* BULK UPDATE COUNTS */}
                                            {isBulkUpdate && emp.created_count > 0 && (
                                                <span className="badge color-badge-green">+{emp.created_count}</span>
                                            )}
                                            {isBulkUpdate && emp.updated_count > 0 && (
                                                <span className="badge color-badge-yellow">~{emp.updated_count}</span>
                                            )}
                                            {isBulkUpdate && emp.deleted_count > 0 && (
                                                <span className="badge color-badge-red">-{emp.deleted_count}</span>
                                            )}

                                            {/* PAYRUN COUNTS */}
                                            {/* {isPayrun && emp.created_slips > 0 && (
                                                <span className="badge color-badge-green">
                                                    Slips +{emp.created_slips}
                                                </span>
                                            )}
                                            {isPayrun && emp.updated_slips > 0 && (
                                                <span className="badge color-badge-yellow">
                                                    Slips ~{emp.updated_slips}
                                                </span>
                                            )} */}

                                            {/* {emp.dry_run && (
                                                <span className="badge color-badge-info" title="Dry Run">TEST</span>
                                            )} */}
                                        </div>
                                    </div>

                                    {expandedRows[emp.emp_code] && (
                                        <div className="result-card-details pt-2">

                                            {/* SUMMARY STATS */}
                                            <div className="flex-row justify-evenly">
                                                <div className="flex-column">
                                                    <div className="font-size-label">Created</div>
                                                    <div className="font-weight600">
                                                        {isPayrun ? emp.created_slips || 0 : emp.created_count || 0}
                                                    </div>
                                                </div>

                                                <div className="flex-column">
                                                    <div className="font-size-label">Updated</div>
                                                    <div className="font-weight600">
                                                        {isPayrun ? emp.updated_slips || 0 : emp.updated_count || 0}
                                                    </div>
                                                </div>

                                                {isBulkUpdate && (
                                                    <>
                                                        <div className="flex-column">
                                                            <div className="font-size-label text-secondary-color">Deleted</div>
                                                            <div className="text-center font-weight600">
                                                                {emp.deleted_count || 0}
                                                            </div>
                                                        </div>

                                                        <div className="flex-column">
                                                            <div className="font-size-label text-secondary-color">Unchanged</div>
                                                            <div className="text-center font-weight600">
                                                                {emp.unchanged_count || 0}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>

                                            {/* BULK UPDATE ONLY (Changes Preview)  */}
                                            {isBulkUpdate && emp.changes_preview?.length > 0 && (
                                                <div className="mb-3">
                                                    <div className="font-weight500 font-size-subheading mb-1">
                                                        Changes {emp.dry_run ? 'Preview' : 'Applied'}
                                                    </div>
                                                    <div className="changes-list">
                                                        {emp.changes_preview.map((change, changeIdx) => (
                                                            <div key={changeIdx} className="change-item mb-1">
                                                                <div className="flex-row align-start justify-between">
                                                                    <div className="flex-column">
                                                                        <div className="font-weight500">
                                                                            {change.deduction}
                                                                        </div>
                                                                        {change.changes && (
                                                                            <div className="font-size-text ml-2">
                                                                                {change.changes.map((chg, idx) => (
                                                                                    <div key={idx}>• {chg}</div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                        {change.details && (
                                                                            <div className="font-size-text ml-2">
                                                                                <div>• Fixed Amount: {change.details.fixed_amount || 'None'}</div>
                                                                                {change.details.percentage && (
                                                                                    <div>• Percentage: {change.details.percentage}%</div>
                                                                                )}
                                                                                {change.details.percentage_of && change.details.percentage_of.length > 0 && (
                                                                                    <div>• Percent of: {change.details.percentage_of.join(', ')}</div>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                        {change.current_value && (
                                                                            <div className="font-size-text ml-2">
                                                                                <div>• Current: {change.current_value.fixed_amount || change.current_value.percentage}%</div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <span className={`badge ${change.type === 'CREATE' ? 'color-badge-green' :
                                                                        change.type === 'UPDATE' ? 'color-badge-yellow' :
                                                                            'color-badge-red'
                                                                        }`}>
                                                                        {change.type}
                                                                    </span>

                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                </div>
                                            )}

                                            {isBulkUpdate && emp.current_deductions?.length > 0 && (
                                                <div className="mb-3">
                                                    <div className="font-weight500 font-size-subheading mb-1">
                                                        Salary Structure Comparison
                                                    </div>
                                                    <div className="comparison-table scroll-container-table" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                        <table className="scrollfix-table-css" style={{ width: '100%', fontSize: '0.85rem' }}>
                                                            <thead>
                                                                <tr className="custom-table-head-tr">
                                                                    <th style={{ width: '30%' }}>Component</th>
                                                                    <th style={{ width: '20%' }}>Type</th>
                                                                    <th style={{ width: '20%' }}>Current</th>
                                                                    <th style={{ width: '20%' }}>Proposed</th>
                                                                    <th style={{ width: '10%' }}>Change</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {emp.current_deductions.map((current, idx) => {

                                                                    const proposed = emp.proposed_deductions?.find(p =>
                                                                        p.name_title === current.name_title || p.id === current.id
                                                                    );

                                                                    const isCreated = !current.id && proposed;
                                                                    const isDeleted = current.id && !proposed;

                                                                    // Fix: Compare numeric values instead of string values
                                                                    const compareValues = (val1, val2) => {
                                                                        const num1 = val1 ? parseFloat(val1) : null;
                                                                        const num2 = val2 ? parseFloat(val2) : null;

                                                                        if (num1 === null && num2 === null) return true;
                                                                        if (num1 === null || num2 === null) return false;

                                                                        return num1 === num2;
                                                                    };

                                                                    // Fix: Compare percentage_of arrays properly
                                                                    const comparePercentageOf = (arr1, arr2) => {
                                                                        const normalize = (arr) => {
                                                                            if (!arr) return [];
                                                                            return arr.map(item => {
                                                                                if (typeof item === 'string') return item;
                                                                                if (typeof item === 'object' && item.name_title) return item.name_title;
                                                                                return String(item);
                                                                            }).sort();
                                                                        };

                                                                        return JSON.stringify(normalize(arr1)) === JSON.stringify(normalize(arr2));
                                                                    };

                                                                    const isUpdated = proposed && (
                                                                        !compareValues(current.fixed_amount, proposed.fixed_amount) ||
                                                                        !compareValues(current.percentage, proposed.percentage) ||
                                                                        !comparePercentageOf(current.percentage_of, proposed.percentage_of)
                                                                    );

                                                                    return (
                                                                        <tr key={idx} className={
                                                                            isCreated ? 'color-bg-success-light' :
                                                                                isDeleted ? 'color-bg-danger-light' :
                                                                                    isUpdated ? 'color-bg-warning-light' : ''
                                                                        }>
                                                                            <td>
                                                                                <div className="flex-row justify-between">
                                                                                    {current.name_title}
                                                                                </div>
                                                                            </td>
                                                                            <td>{current.name_type}</td>
                                                                            <td>
                                                                                {current.fixed_amount ? (
                                                                                    <div>₹{formatCurrency(current.fixed_amount)}</div>
                                                                                ) : current.percentage ? (
                                                                                    <div>{current.percentage}% of<br />
                                                                                        {current.percentage_of.join(', ')}

                                                                                    </div>
                                                                                ) : '-'}
                                                                            </td>
                                                                            <td>
                                                                                {proposed ? (
                                                                                    proposed.fixed_amount ? (
                                                                                        <div>₹{formatCurrency(proposed.fixed_amount)}</div>
                                                                                    ) : proposed.percentage ? (
                                                                                        <div>
                                                                                            {proposed.percentage}% of<br />
                                                                                            {current.percentage_of.join(', ')}

                                                                                        </div>
                                                                                    ) : '-'
                                                                                ) : '-'}
                                                                            </td>
                                                                            <td>
                                                                                {isCreated && (
                                                                                    <span className="badge color-badge-green">New</span>
                                                                                )}
                                                                                {isDeleted && (
                                                                                    <span className="badge color-badge-red">Removed</span>
                                                                                )}
                                                                                {isUpdated && (
                                                                                    <span className="badge color-badge-yellow">Changed</span>
                                                                                )}
                                                                                {!isCreated && !isDeleted && !isUpdated && (
                                                                                    <span className="badge color-badge-gray">Same</span>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}

                                                                {/* Show newly created deductions that aren't in current_deductions */}
                                                                {emp.proposed_deductions?.filter(p =>
                                                                    !emp.current_deductions.some(c =>
                                                                        c.name_title === p.name_title || c.id === p.id
                                                                    )
                                                                ).map((proposed, idx) => (
                                                                    <tr key={`new-${idx}`} className="color-bg-success-light">
                                                                        <td>
                                                                            <div className="flex-row align-center">
                                                                                <span className="color-badge-green mr-1">+</span>
                                                                                {proposed.name_title}
                                                                            </div>
                                                                        </td>
                                                                        <td>{proposed.name_type}</td>
                                                                        <td>-</td>
                                                                        <td>
                                                                            {proposed.fixed_amount ? (
                                                                                <div>₹{formatCurrency(proposed.fixed_amount)}</div>
                                                                            ) : proposed.percentage ? (
                                                                                <div>{proposed.percentage}%</div>
                                                                            ) : '-'}
                                                                        </td>
                                                                        <td>
                                                                            <span className="badge color-badge-green">New</span>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            )}

                                            {/*  PAYRUN ONLY Changes Preview */}
                                            {isPayrun && (
                                                <div className="additional-info mt-2">
                                                    {/* {emp.salary_log_id && (
                                                        <div className="flex-row mb-1">
                                                            <span className="font-weight500 mr-2">Salary Log:</span>
                                                            <span className="badge color-badge-blue">
                                                                {emp.salary_log_id.substring(0, 8)}…
                                                            </span>
                                                        </div>
                                                    )}

                                                    {emp.earliest_allowed_period && (
                                                        <div className="flex-row mb-1">
                                                            <span className="font-weight500 mr-2">Earliest Allowed:</span>
                                                            <span className="badge color-badge-emerald">
                                                                {emp.earliest_allowed_period}
                                                            </span>
                                                        </div>
                                                    )} */}

                                                    {isPayrun && emp.salary_data.calculation_metadata.updated_by && (
                                                        <div className="flex-row mb-1 items-center">
                                                            <span className="font-weight500 mr-2">Processed By:</span>
                                                            <>
                                                                <CustomImageModal customStyle>
                                                                    {emp.salary_data.calculation_metadata.updated_by_profilepic ? (
                                                                        <img
                                                                            src={`${`${IMAGE_URL}${emp.salary_data.calculation_metadata.updated_by_profilepic}`}`}
                                                                            alt={emp.salary_data.calculation_metadata.updated_by_name} className="profile-img"
                                                                        />
                                                                    ) : (
                                                                        <UserDefaultLogo user={{ name: emp.salary_data.calculation_metadata.updated_by_name, profilepic: emp.salary_data.calculation_metadata.updated_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                                    )}
                                                                </CustomImageModal>
                                                                <p>{emp.salary_data.calculation_metadata.updated_by}-{emp.salary_data.calculation_metadata.updated_by_name}</p>

                                                            </>
                                                            {/* 
                                                            <span>{emp.salary_data.calculation_metadata.updated_by}{emp.salary_data.calculation_metadata.updated_by_name}</span>
                                                            {emp.salary_data.calculation_metadata.updated_at && (
                                                                <span className="text-secondary-color ml-2">
                                                                    ({new Date(emp.salary_data.calculation_metadata.updated_at).toLocaleString()})
                                                                </span>
                                                            )} */}
                                                        </div>
                                                    )}

                                                </div>
                                            )}

                                            {isBulkUpdate && (
                                                <div className="additional-info">
                                                    {emp.earliest_allowed_period && (
                                                        <div className="flex-row align-center mb-1">
                                                            <span className="font-weight500 mr-2">Earliest Allowed:</span>
                                                            <span className="badge color-badge-emerald">
                                                                {emp.earliest_allowed_period}
                                                            </span>
                                                        </div>
                                                    )}

                                                </div>
                                            )}

                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}


                    {activeTab === 'failed' && (
                        <div className="scroll-container-table">

                            {/* BULK UPDATE – error response */}
                            {isBulkUpdate && isErrorResponse && results.failed_details?.map((emp, idx) => (
                                <div key={idx} className="result-card color-card-danger">
                                    <div className="result-card-header">
                                        <div className="employee-code">
                                            <CrossRed />
                                            {emp.emp_code}
                                        </div>
                                        <div className="employee-status text-uppercase">CRITICAL ERROR</div>
                                        <div className="employee-actions">
                                            <span className="badge color-badge-red">
                                                {emp.is_critical ? 'CRITICAL' : 'ERROR'}
                                            </span>
                                        </div>
                                    </div>

                                    {emp.errors && (
                                        <div className="result-card-details">
                                            <strong>Error Details:</strong>
                                            <ul>
                                                {(Array.isArray(emp.errors) ? emp.errors : [emp.errors]).map((error, errIdx) => (
                                                    <li key={errIdx} className="font-size-text error-message-input">
                                                        {error}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            ))}

                            {/* PAYRUN + BULK UPDATE – normal failed list */}
                            {results?.failed?.map((emp, idx) => (
                                <div key={idx} className="result-card color-card-danger">
                                    <div className="result-card-header">
                                        <div className="employee-code">
                                            <CrossRed />
                                            {emp.emp_code}
                                        </div>
                                        <div className="employee-status text-uppercase">
                                            {emp.status || 'FAILED'}
                                        </div>
                                        {emp.is_critical && (
                                            <div className="employee-status">
                                                <span className="badge color-badge-red">
                                                    {emp.is_critical ? 'CRITICAL' : 'ERROR'}
                                                </span>
                                            </div>
                                        )}

                                        <div className="font-size-text">
                                            {emp.message || emp.errors?.[0] || 'Unknown error'}
                                        </div>
                                        {emp.missing_months && emp.missing_months.length > 0 && (
                                            <div className="font-size-text mt-1 text-secondary-color">
                                                <strong>Missing Months:</strong> {emp.missing_months.join(', ')}
                                            </div>
                                        )}

                                    </div>

                                    {emp.errors?.length > 0 && (
                                        <div className="result-card-details">
                                            <strong>Error Details:</strong>
                                            <ul>
                                                {emp.errors.map((error, errIdx) => (
                                                    <li key={errIdx} className="font-size-text error-message-input">
                                                        {error}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            ))}

                        </div>
                    )}


                    {activeTab === 'skipped' && results?.skipped?.length > 0 && (
                        <div className="scroll-container-table">
                            {results.skipped.map((emp, idx) => (
                                <div key={idx} className="result-card color-card-warning">
                                    <div className="result-card-header">
                                        <div className="employee-code">
                                            <WarnYellow />
                                            {emp.emp_code}
                                        </div>
                                        <div className="employee-status text-uppercase">
                                            {emp.status}
                                        </div>
                                        <div className="font-size-text">
                                            {emp.message}
                                        </div>
                                        <div className="employee-actions">
                                            <span className="status-badge color-badge-emerald">
                                                Earliest: {emp.earliest_allowed_period}
                                            </span>
                                        </div>
                                    </div>

                                    {emp.errors?.length > 0 && (
                                        <div className="result-card-details">
                                            <strong>Validation Errors:</strong>
                                            <ul>
                                                {emp.errors.map((error, errIdx) => (
                                                    <li key={errIdx} className="font-size-text error-message-input">
                                                        {error}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}


                </div>

                {/* Action Buttons */}
                <div className="button-models">

                    <button
                        className="model-button-cancel model-button font-weight500"
                        onClick={handleComplete}
                    >
                        Done
                    </button>

                    {!isErrorResponse && isDryRun && stats?.failed === 0 && (
                        <button
                            className="model-button-download model-button font-weight500"
                            onClick={handleRetry}
                        >
                            Retry
                        </button>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

const BulkApiResultSummaryModal = ({
    show,
    handleClose,
    handleComplete,
    handleRetry,
    results,
    isDryRun,
    fileName,
    operationType,
    restData
}) => {

    const isPayrun = operationType === PAYRUN_OPERATION.PAYRUN;
    const isBulkUpdate = operationType === PAYRUN_OPERATION.BULK_UPDATE;
    const [activeTab, setActiveTab] = useState('summary');
    const [expandedRows, setExpandedRows] = useState({});

    const toggleRowExpand = (empCode) => {
        setExpandedRows(prev => ({
            ...prev,
            [empCode]: !prev[empCode]
        }));
    };



    const getStats = () => {
        if (!results) return null;

        const summary = results.summary || {};
        const isErrorResponse = Boolean(results.error || results.details);

        // Base stats (common for all)
        const baseStats = {
            total: summary.total_employees || 0,
            successful: summary.successful_count || 0,
            failed: summary.failed_count || 0,
            skipped: summary.skipped_count || 0
        };

        // PAYRUN stats
        const payrunStats = {
            created: summary.created_slips || 0,
            updated: summary.updated_slips || 0,
            deleted: 0
        };

        // BULK UPDATE stats
        const bulkUpdateStats = {
            created: summary.total_deductions_created || 0,
            updated: summary.total_deductions_updated || 0,
            deleted: summary.total_deductions_deleted || 0
        };


        const operationStats = isPayrun ? payrunStats : bulkUpdateStats;


        return {
            ...baseStats,
            ...operationStats,
            total_amount_impact: summary.total_amount_impact || summary.total_amount || '0.00',
            isError: isErrorResponse,
            errorMessage: isErrorResponse
                ? results.error || results.details
                : null
        };
    };


    const stats = getStats();


    const exportBulkupdateToCSV = () => {
        if (!results) return;

        const csvData = [];

        const isErrorResponse = results.error || results.details;

        // Add header
        if (isErrorResponse) {
            csvData.push(['Bulk Salary Update - Error Report']);
        } else {
            csvData.push([`Bulk Salary Update - ${isDryRun ? 'Dry Run Validation' : 'Update'} Results`]);
        }

        // Add summary
        csvData.push(['Bulk Salary Update Results']);
        csvData.push(['Mode:', isDryRun ? 'Dry Run (Validation Only)' : 'Actual Update']);
        csvData.push(['File:', fileName || 'N/A']);
        csvData.push(['Timestamp:', new Date().toLocaleString()]);
        csvData.push([]);

        // Add error details if present
        if (isErrorResponse) {
            csvData.push(['Error Summary']);
            csvData.push(['Error:', results.error || 'Unknown error']);
            csvData.push(['Details:', results.details || 'No details available']);
            csvData.push([]);
        }

        // Add statistics
        csvData.push(['Summary Statistics']);
        csvData.push(['Total Employees', stats?.total]);
        csvData.push(['Successful', stats?.successful]);
        csvData.push(['Failed', stats?.failed]);
        csvData.push(['Skipped', stats?.skipped]);
        csvData.push(['Deductions Created', stats?.created]);
        csvData.push(['Deductions Updated', stats?.updated]);
        csvData.push(['Deductions Deleted', stats?.deleted]);
        // csvData.push(['Total Amount Impact', `₹${formatCurrency(stats?.amountImpact)}`]);
        csvData.push([]);

        // Add successful employees
        if (results.successful?.length > 0) {
            csvData.push(['Successful Employees']);
            csvData.push(['Index', 'Employee Code', 'Status', 'Message', 'Created', 'Updated', 'Deleted', 'Unchanged', 'Total Amount']);

            results.successful.forEach(emp => {
                csvData.push([
                    emp.index + 1,
                    emp.emp_code,
                    emp.status,
                    emp.message,
                    emp.created_count || 0,
                    emp.updated_count || 0,
                    emp.deleted_count || 0,
                    emp.unchanged_count || 0,
                    `₹${formatCurrency(emp.total_amount)}`
                ]);
            });
            csvData.push([]);
        }

        // Add failed employees from error response format
        if (results.failed_details?.length > 0) {
            csvData.push(['Failed Employees (Critical Errors)']);
            csvData.push(['Employee Code', 'Error Messages', 'Critical']);

            results.failed_details.forEach(emp => {
                const errors = Array.isArray(emp.errors) ? emp.errors.join('; ') : emp.errors;
                csvData.push([
                    emp.emp_code,
                    errors,
                    emp.is_critical ? 'YES' : 'NO'
                ]);
            });
            csvData.push([]);
        }
        // Add failed employees from success response format
        else if (results.failed?.length > 0) {
            csvData.push(['Failed Employees']);
            csvData.push(['Index', 'Employee Code', 'Status', 'Error Messages']);

            results.failed.forEach(emp => {
                const errors = Array.isArray(emp.errors) ? emp.errors.join('; ') : emp.message;
                csvData.push([
                    emp.index + 1,
                    emp.emp_code,
                    emp.status,
                    errors
                ]);
            });
            csvData.push([]);
        }

        // Add skipped employees
        if (results.skipped?.length > 0) {
            csvData.push(['Skipped Employees']);
            csvData.push(['Index', 'Employee Code', 'Status', 'Reason']);

            results.skipped.forEach(emp => {
                csvData.push([
                    emp.index + 1,
                    emp.emp_code,
                    emp.status,
                    emp.message
                ]);
            });
        }

        // Convert to CSV string
        const csvString = csvData.map(row =>
            row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(',')
        ).join('\n');

        // Create and download file
        const blob = new Blob([csvString], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `bulk-salary-update-results-${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };

    const exportPayrunToCSV = () => {
        if (!results) return;

        const csvData = [];

        // Header
        csvData.push(['PAYRUN Execution Report']);
        csvData.push([]);

        // Summary info
        csvData.push(['Mode', results.dry_run ? 'Dry Run (Validation)' : 'Actual Payrun']);
        csvData.push(['Ignore Existing mode', results.ignore_existing_mode ? 'Enabled' : 'Not Enabled']);
        csvData.push(['Executed By', restData.updatedBy || 'N/A']);
        csvData.push(['Timestamp', new Date().toLocaleString()]);
        csvData.push([]);

        // Overall message
        csvData.push(['Message']);
        csvData.push([restData?.message || 'PAYRUN executed']);
        csvData.push([]);

        // Summary statistics
        csvData.push(['Summary Statistics']);
        csvData.push(['Successful', results.successful?.length || 0]);
        csvData.push(['Failed', results.failed?.length || 0]);
        csvData.push([]);

        // Successful employees
        if (results.successful?.length > 0) {
            csvData.push(['Successful Employees']);
            csvData.push(['Index', 'Employee Code', 'Status', 'Message']);

            results.successful.forEach((emp, idx) => {
                csvData.push([
                    idx + 1,
                    emp.emp_code,
                    emp.status || 'SUCCESS',
                    emp.message || 'Salary slip processed'
                ]);
            });
            csvData.push([]);
        }

        // Failed employees
        if (results.failed?.length > 0) {
            csvData.push(['Failed Employees']);
            csvData.push([
                'Index',
                'Employee Code',
                'Status',
                'Errors',
                'Missing Months',
                'Critical'
            ]);

            results.failed.forEach((emp, idx) => {
                csvData.push([
                    idx + 1,
                    emp.emp_code,
                    emp.status || 'FAILED',
                    Array.isArray(emp.errors)
                        ? emp.errors.join('; ')
                        : emp.message || 'Unknown error',
                    emp.missing_months?.join(', ') || '-',
                    emp.is_critical ? 'YES' : 'NO'
                ]);
            });
            csvData.push([]);
        }



        // Convert to CSV
        const csvString = csvData
            .map(row =>
                row.map(cell =>
                    `"${String(cell ?? '').replace(/"/g, '""')}"`
                ).join(',')
            )
            .join('\n');

        // Download
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = `payrun-results-${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };


    // Check if this is an error response
    const isErrorResponse = results?.error || results?.details;

    const successfulCount = results?.successful?.length || 0;
    const failedCount =
        results?.failed_details?.length ||
        results?.failed?.length ||
        0;
    const skippedCount = results?.skipped?.length || 0;


    return (
        <Modal
            show={show}
            onHide={handleClose}
            dialogClassName="three-fourth-modal"
        >
            <Modal.Header className="font-weight500 font-size-heading">
                <Modal.Title>
                    {isPayrun
                        ? 'Payrun Results'
                        : isDryRun
                            ? 'Bulk Update - Dry Run Results'
                            : 'Bulk Update Results'}
                </Modal.Title>

                {/* <div className="flex-row">
                    <button
                        className="priority-button-small model-button-download"
                        onClick={exportToCSV}
                        title="Export to CSV"
                    >
                        <DownloadIcon />{" "}
                        Export CSV
                    </button>
                </div> */}
                <div className="flex-row">
                    <button
                        className="priority-button-small model-button-download"
                        title="Export to CSV"
                        onClick={() => {
                            if (isPayrun) {
                                exportPayrunToCSV();
                            } else {
                                exportBulkupdateToCSV();
                            }
                        }}>
                        <DownloadIcon />{" "}
                        Export CSV
                    </button>
                </div>

            </Modal.Header>

            <Modal.Body>
                {/* Show error banner for error responses */}
                {isErrorResponse && (
                    <div className="notice-badge color-tab-red mb-3">
                        <strong>
                            ❌ {isPayrun ? 'Payrun Failed:' : 'Bulk Salary Update Failed:'}
                        </strong>{' '}
                        {results.error || 'Unknown error'}

                        <br />
                        <strong>Details:</strong>{' '}
                        {results.details || 'No additional details available'}


                        {isBulkUpdate && (
                            <>
                                <br />
                                <strong>Mode:</strong>{' '}
                                {results.dry_run ? 'Dry Run (Validation)' : 'Actual Update'}
                            </>
                        )}
                    </div>
                )}

                <div className="field-cont justify-between">
                    {/* Summary Cards */}
                    <div className="flex-row gap-3">
                        <div className="color-card color-card-success">
                            <div className="priority-button color-tab-green">
                                <CheckTick />
                            </div>
                            <hr className="field-cont-hr" />
                            <div className="flex-column align-start">
                                <div className="font-weight600 font-size-heading">{stats?.successful}</div>
                                <div className="font-size-label text-secondary-color">Successful</div>
                            </div>
                        </div>

                        <div className="color-card color-card-danger">
                            <div className="priority-button color-tab-red">
                                <CrossRed />
                            </div>
                            <hr className="field-cont-hr" />
                            <div className="flex-column align-start">
                                <div className="font-weight600 font-size-heading">{stats?.failed}</div>
                                <div className="font-size-label text-secondary-color">Failed</div>
                            </div>
                        </div>

                        <div className="color-card color-card-warning">
                            <div className="priority-button color-tab-yellow">
                                <WarnYellow />
                            </div>
                            <hr className="field-cont-hr" />
                            <div className="flex-column align-start">
                                <div className="font-weight600 font-size-heading">{stats?.skipped}</div>
                                <div className="font-size-label text-secondary-color">Skipped</div>
                            </div>
                        </div>
                    </div>
                    {/* <hr className="field-cont-hr" /> */}

                    {/* Operation Summary */}
                    <div className="flex-row gap-3">
                        <div className="priority-button text-center color-button-success">
                            <div className="font-size-label text-uppercase">
                                {isPayrun ? 'Slips Created' : 'Created'}
                            </div>
                            <div className="font-size-heading font-weight600">{stats?.created || 0}</div>
                        </div>

                        <div className="priority-button text-center color-button-warning">
                            <div className="font-size-label text-uppercase">
                                {isPayrun ? 'Slips Updated' : 'Updated'}
                            </div>
                            <div className="font-size-heading font-weight600">{stats?.updated || 0}</div>
                        </div>

                        {!isPayrun && (
                            <div className="priority-button text-center color-button-danger">
                                <div className="font-size-label text-uppercase">Deleted</div>
                                <div className="font-size-heading font-weight600">
                                    {stats?.deleted || 0}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Tabs for Detailed View */}
                <div className="bloc-tabss wfm-margin">
                    <button
                        className={`dashboardcomponent-tabs  ${activeTab === 'summary' ? 'dashboardcomponent-active-tabs' : ''}`}
                        onClick={() => setActiveTab('summary')}
                    >
                        Summary ({stats?.total || 0})
                    </button>
                    {successfulCount > 0 && (
                        <button
                            className={`dashboardcomponent-tabs ${activeTab === 'successful' ? 'dashboardcomponent-active-tabs' : ''
                                }`}
                            onClick={() => setActiveTab('successful')}
                        >
                            Successful ({successfulCount})
                        </button>
                    )}
                    {failedCount > 0 && (
                        <button
                            className={`dashboardcomponent-tabs ${activeTab === 'failed' ? 'dashboardcomponent-active-tabs' : ''
                                }`}
                            onClick={() => setActiveTab('failed')}
                        >
                            Failed ({failedCount})
                        </button>
                    )}

                    {skippedCount > 0 && (
                        <button
                            className={`dashboardcomponent-tabs ${activeTab === 'skipped' ? 'dashboardcomponent-active-tabs' : ''
                                }`}
                            onClick={() => setActiveTab('skipped')}
                        >
                            Skipped ({skippedCount})
                        </button>
                    )}
                </div>


                {/* Tab Content */}
                <div className="scrollfix-container" style={{ maxHeight: '400px' }}>
                    {activeTab === 'summary' && (
                        <div className="summary-details">
                            {!isErrorResponse && (<div className="notice-badge color-tab-teal mb-2">
                                <strong>Mode:</strong> {isDryRun ? 'Dry Run (Validation Only)' : 'Actual Update'}
                                <br />
                                {!isPayrun && fileName && (
                                    <>
                                        <strong>File:</strong> {fileName}
                                        <br />
                                    </>
                                )}

                                {(results?.ignore_existing_mode || results?.partial_mode) && (
                                    <div>
                                        <strong>{results?.ignore_existing_mode ? 'Ignore Existing Mode:' : 'Partial Mode:'}</strong> Enabled
                                    </div>
                                )}

                                {(results?.updated_by || restData?.updatedBy) && (
                                    <div>
                                        <strong>Updated By:</strong> {results.updated_by || restData?.updatedBy}
                                    </div>
                                )}


                                <strong>Message:</strong> {results?.message || restData?.message || 'Processing completed'}
                            </div>)}
                            {stats?.failed > 0 && (
                                <div className="notice-badge color-tab-red mb-2">
                                    <strong>Attention:</strong> {stats?.failed} employee(s) failed to process.
                                    Please check the "Failed" tab for details.
                                </div>
                            )}

                            {!isErrorResponse && stats?.skipped > 0 && (
                                <div className="notice-badge color-tab-yellow mb-2">
                                    <strong>Note:</strong> {stats?.skipped} employee(s) were skipped.
                                    Please check the <strong>Skipped</strong> tab for details.
                                </div>
                            )}
                        </div>
                    )}


                    {activeTab === 'successful' && !isErrorResponse && results?.successful?.length > 0 && (
                        <div className="scroll-container-table">
                            {results.successful.map((emp, idx) => (
                                <div key={idx} className="result-card color-card-success">
                                    <div
                                        className="result-card-header flex-row justify-between"
                                        onClick={() => toggleRowExpand(emp.emp_code)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="flex-row justify-start align-center">
                                            <div className="employee-code flex-row align-center gap-1">
                                                <CheckTick />
                                                <strong>{emp.emp_code}</strong>
                                                {emp.name && isPayrun && (
                                                    <span className="font-size-text text-secondary-color ml-2">
                                                        ({emp.name})
                                                    </span>
                                                )}
                                                <div className="text-uppercase badge color-badge-green">
                                                    {emp.status}
                                                </div>
                                                {isPayrun && emp.total_amount && (
                                                    <span className="font-size-text text-secondary-color ml-3">
                                                        Salary: ₹{parseFloat(emp.total_amount).toLocaleString('en-IN')}
                                                    </span>
                                                )}

                                                {isPayrun && emp.action && (
                                                    <span className={`badge ${emp.action === 'created' ? 'color-badge-green' : 'color-badge-yellow'} ml-2`}>
                                                        {emp.action === 'created' ? 'Created' : 'Updated'}
                                                    </span>
                                                )}

                                            </div>
                                            <div className="font-size-text ml-2">{emp.message}</div>
                                        </div>

                                        {/* ACTION BADGES */}
                                        <div className="employee-actions flex-row gap-1">
                                            {/* BULK UPDATE COUNTS */}
                                            {isBulkUpdate && emp.created_count > 0 && (
                                                <span className="badge color-badge-green">+{emp.created_count}</span>
                                            )}
                                            {isBulkUpdate && emp.updated_count > 0 && (
                                                <span className="badge color-badge-yellow">~{emp.updated_count}</span>
                                            )}
                                            {isBulkUpdate && emp.deleted_count > 0 && (
                                                <span className="badge color-badge-red">-{emp.deleted_count}</span>
                                            )}

                                            {/* PAYRUN COUNTS */}
                                            {/* {isPayrun && emp.created_slips > 0 && (
                                                <span className="badge color-badge-green">
                                                    Slips +{emp.created_slips}
                                                </span>
                                            )}
                                            {isPayrun && emp.updated_slips > 0 && (
                                                <span className="badge color-badge-yellow">
                                                    Slips ~{emp.updated_slips}
                                                </span>
                                            )} */}

                                            {/* {emp.dry_run && (
                                                <span className="badge color-badge-info" title="Dry Run">TEST</span>
                                            )} */}
                                        </div>
                                    </div>

                                    {expandedRows[emp.emp_code] && (
                                        <div className="result-card-details pt-2">

                                            {/* SUMMARY STATS */}
                                            <div className="flex-row justify-evenly">
                                                <div className="flex-column">
                                                    <div className="font-size-label">Created</div>
                                                    <div className="font-weight600">
                                                        {isPayrun ? emp.created_slips || 0 : emp.created_count || 0}
                                                    </div>
                                                </div>

                                                <div className="flex-column">
                                                    <div className="font-size-label">Updated</div>
                                                    <div className="font-weight600">
                                                        {isPayrun ? emp.updated_slips || 0 : emp.updated_count || 0}
                                                    </div>
                                                </div>

                                                {isBulkUpdate && (
                                                    <>
                                                        <div className="flex-column">
                                                            <div className="font-size-label text-secondary-color">Deleted</div>
                                                            <div className="text-center font-weight600">
                                                                {emp.deleted_count || 0}
                                                            </div>
                                                        </div>

                                                        <div className="flex-column">
                                                            <div className="font-size-label text-secondary-color">Unchanged</div>
                                                            <div className="text-center font-weight600">
                                                                {emp.unchanged_count || 0}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>

                                            {/* BULK UPDATE ONLY (Changes Preview)  */}
                                            {isBulkUpdate && emp.changes_preview?.length > 0 && (
                                                <div className="mb-3">
                                                    <div className="font-weight500 font-size-subheading mb-1">
                                                        Changes {emp.dry_run ? 'Preview' : 'Applied'}
                                                    </div>
                                                    <div className="changes-list">
                                                        {emp.changes_preview.map((change, changeIdx) => (
                                                            <div key={changeIdx} className="change-item mb-1">
                                                                <div className="flex-row align-start justify-between">
                                                                    <div className="flex-column">
                                                                        <div className="font-weight500">
                                                                            {change.deduction}
                                                                        </div>
                                                                        {change.changes && (
                                                                            <div className="font-size-text ml-2">
                                                                                {change.changes.map((chg, idx) => (
                                                                                    <div key={idx}>• {chg}</div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                        {change.details && (
                                                                            <div className="font-size-text ml-2">
                                                                                <div>• Fixed Amount: {change.details.fixed_amount || 'None'}</div>
                                                                                {change.details.percentage && (
                                                                                    <div>• Percentage: {change.details.percentage}%</div>
                                                                                )}
                                                                                {change.details.percentage_of && change.details.percentage_of.length > 0 && (
                                                                                    <div>• Percent of: {change.details.percentage_of.join(', ')}</div>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                        {change.current_value && (
                                                                            <div className="font-size-text ml-2">
                                                                                <div>• Current: {change.current_value.fixed_amount || change.current_value.percentage}%</div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <span className={`badge ${change.type === 'CREATE' ? 'color-badge-green' :
                                                                        change.type === 'UPDATE' ? 'color-badge-yellow' :
                                                                            'color-badge-red'
                                                                        }`}>
                                                                        {change.type}
                                                                    </span>

                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                </div>
                                            )}

                                            {isBulkUpdate && emp.current_deductions?.length > 0 && (
                                                <div className="mb-3">
                                                    <div className="font-weight500 font-size-subheading mb-1">
                                                        Salary Structure Comparison
                                                    </div>
                                                    <div className="comparison-table scroll-container-table" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                        <table className="scrollfix-table-css" style={{ width: '100%', fontSize: '0.85rem' }}>
                                                            <thead>
                                                                <tr className="custom-table-head-tr">
                                                                    <th style={{ width: '30%' }}>Component</th>
                                                                    <th style={{ width: '20%' }}>Type</th>
                                                                    <th style={{ width: '20%' }}>Current</th>
                                                                    <th style={{ width: '20%' }}>Proposed</th>
                                                                    <th style={{ width: '10%' }}>Change</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {emp.current_deductions.map((current, idx) => {

                                                                    const proposed = emp.proposed_deductions?.find(p =>
                                                                        p.name_title === current.name_title || p.id === current.id
                                                                    );

                                                                    const isCreated = !current.id && proposed;
                                                                    const isDeleted = current.id && !proposed;

                                                                    // Fix: Compare numeric values instead of string values
                                                                    const compareValues = (val1, val2) => {
                                                                        const num1 = val1 ? parseFloat(val1) : null;
                                                                        const num2 = val2 ? parseFloat(val2) : null;

                                                                        if (num1 === null && num2 === null) return true;
                                                                        if (num1 === null || num2 === null) return false;

                                                                        return num1 === num2;
                                                                    };

                                                                    // Fix: Compare percentage_of arrays properly
                                                                    const comparePercentageOf = (arr1, arr2) => {
                                                                        const normalize = (arr) => {
                                                                            if (!arr) return [];
                                                                            return arr.map(item => {
                                                                                if (typeof item === 'string') return item;
                                                                                if (typeof item === 'object' && item.name_title) return item.name_title;
                                                                                return String(item);
                                                                            }).sort();
                                                                        };

                                                                        return JSON.stringify(normalize(arr1)) === JSON.stringify(normalize(arr2));
                                                                    };

                                                                    const isUpdated = proposed && (
                                                                        !compareValues(current.fixed_amount, proposed.fixed_amount) ||
                                                                        !compareValues(current.percentage, proposed.percentage) ||
                                                                        !comparePercentageOf(current.percentage_of, proposed.percentage_of)
                                                                    );

                                                                    return (
                                                                        <tr key={idx} className={
                                                                            isCreated ? 'color-bg-success-light' :
                                                                                isDeleted ? 'color-bg-danger-light' :
                                                                                    isUpdated ? 'color-bg-warning-light' : ''
                                                                        }>
                                                                            <td>
                                                                                <div className="flex-row justify-between">
                                                                                    {current.name_title}
                                                                                </div>
                                                                            </td>
                                                                            <td>{current.name_type}</td>
                                                                            <td>
                                                                                {current.fixed_amount ? (
                                                                                    <div>₹{formatCurrency(current.fixed_amount)}</div>
                                                                                ) : current.percentage ? (
                                                                                    <div>{current.percentage}% of<br />
                                                                                        {current.percentage_of.join(', ')}

                                                                                    </div>
                                                                                ) : '-'}
                                                                            </td>
                                                                            <td>
                                                                                {proposed ? (
                                                                                    proposed.fixed_amount ? (
                                                                                        <div>₹{formatCurrency(proposed.fixed_amount)}</div>
                                                                                    ) : proposed.percentage ? (
                                                                                        <div>
                                                                                            {proposed.percentage}% of<br />
                                                                                            {current.percentage_of.join(', ')}

                                                                                        </div>
                                                                                    ) : '-'
                                                                                ) : '-'}
                                                                            </td>
                                                                            <td>
                                                                                {isCreated && (
                                                                                    <span className="badge color-badge-green">New</span>
                                                                                )}
                                                                                {isDeleted && (
                                                                                    <span className="badge color-badge-red">Removed</span>
                                                                                )}
                                                                                {isUpdated && (
                                                                                    <span className="badge color-badge-yellow">Changed</span>
                                                                                )}
                                                                                {!isCreated && !isDeleted && !isUpdated && (
                                                                                    <span className="badge color-badge-gray">Same</span>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}

                                                                {/* Show newly created deductions that aren't in current_deductions */}
                                                                {emp.proposed_deductions?.filter(p =>
                                                                    !emp.current_deductions.some(c =>
                                                                        c.name_title === p.name_title || c.id === p.id
                                                                    )
                                                                ).map((proposed, idx) => (
                                                                    <tr key={`new-${idx}`} className="color-bg-success-light">
                                                                        <td>
                                                                            <div className="flex-row align-center">
                                                                                <span className="color-badge-green mr-1">+</span>
                                                                                {proposed.name_title}
                                                                            </div>
                                                                        </td>
                                                                        <td>{proposed.name_type}</td>
                                                                        <td>-</td>
                                                                        <td>
                                                                            {proposed.fixed_amount ? (
                                                                                <div>₹{formatCurrency(proposed.fixed_amount)}</div>
                                                                            ) : proposed.percentage ? (
                                                                                <div>{proposed.percentage}%</div>
                                                                            ) : '-'}
                                                                        </td>
                                                                        <td>
                                                                            <span className="badge color-badge-green">New</span>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            )}

                                            {/*  PAYRUN ONLY Changes Preview */}
                                            {isPayrun && (
                                                <div className="additional-info mt-2">
                                                    {/* {emp.salary_log_id && (
                                                        <div className="flex-row mb-1">
                                                            <span className="font-weight500 mr-2">Salary Log:</span>
                                                            <span className="badge color-badge-blue">
                                                                {emp.salary_log_id.substring(0, 8)}…
                                                            </span>
                                                        </div>
                                                    )}

                                                    {emp.earliest_allowed_period && (
                                                        <div className="flex-row mb-1">
                                                            <span className="font-weight500 mr-2">Earliest Allowed:</span>
                                                            <span className="badge color-badge-emerald">
                                                                {emp.earliest_allowed_period}
                                                            </span>
                                                        </div>
                                                    )} */}

                                                    {isPayrun && emp.salary_data.calculation_metadata.updated_by && (
                                                        <div className="flex-row mb-1 items-center">
                                                            <span className="font-weight500 mr-2">Processed By:</span>
                                                            <>
                                                                <CustomImageModal customStyle>
                                                                    {emp.salary_data.calculation_metadata.updated_by_profilepic ? (
                                                                        <img
                                                                            src={`${`${IMAGE_URL}${emp.salary_data.calculation_metadata.updated_by_profilepic}`}`}
                                                                            alt={emp.salary_data.calculation_metadata.updated_by_name} className="profile-img"
                                                                        />
                                                                    ) : (
                                                                        <UserDefaultLogo user={{ name: emp.salary_data.calculation_metadata.updated_by_name, profilepic: emp.salary_data.calculation_metadata.updated_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                                    )}
                                                                </CustomImageModal>
                                                                <p>{emp.salary_data.calculation_metadata.updated_by}-{emp.salary_data.calculation_metadata.updated_by_name}</p>

                                                            </>
                                                            {/* 
                                                            <span>{emp.salary_data.calculation_metadata.updated_by}{emp.salary_data.calculation_metadata.updated_by_name}</span>
                                                            {emp.salary_data.calculation_metadata.updated_at && (
                                                                <span className="text-secondary-color ml-2">
                                                                    ({new Date(emp.salary_data.calculation_metadata.updated_at).toLocaleString()})
                                                                </span>
                                                            )} */}
                                                        </div>
                                                    )}

                                                </div>
                                            )}

                                            {isBulkUpdate && (
                                                <div className="additional-info">
                                                    {emp.earliest_allowed_period && (
                                                        <div className="flex-row align-center mb-1">
                                                            <span className="font-weight500 mr-2">Earliest Allowed:</span>
                                                            <span className="badge color-badge-emerald">
                                                                {emp.earliest_allowed_period}
                                                            </span>
                                                        </div>
                                                    )}

                                                </div>
                                            )}

                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}


                    {activeTab === 'failed' && (
                        <div className="scroll-container-table">

                            {/* BULK UPDATE – error response */}
                            {isBulkUpdate && isErrorResponse && results.failed_details?.map((emp, idx) => (
                                <div key={idx} className="result-card color-card-danger">
                                    <div className="result-card-header">
                                        <div className="employee-code">
                                            <CrossRed />
                                            {emp.emp_code}
                                        </div>
                                        <div className="employee-status text-uppercase">CRITICAL ERROR</div>
                                        <div className="employee-actions">
                                            <span className="badge color-badge-red">
                                                {emp.is_critical ? 'CRITICAL' : 'ERROR'}
                                            </span>
                                        </div>
                                    </div>

                                    {emp.errors && (
                                        <div className="result-card-details">
                                            <strong>Error Details:</strong>
                                            <ul>
                                                {(Array.isArray(emp.errors) ? emp.errors : [emp.errors]).map((error, errIdx) => (
                                                    <li key={errIdx} className="font-size-text error-message-input">
                                                        {error}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            ))}

                            {/* PAYRUN + BULK UPDATE – normal failed list */}
                            {results?.failed?.map((emp, idx) => (
                                <div key={idx} className="result-card color-card-danger">
                                    <div className="result-card-header">
                                        <div className="employee-code">
                                            <CrossRed />
                                            {emp.emp_code}
                                        </div>
                                        <div className="employee-status text-uppercase">
                                            {emp.status || 'FAILED'}
                                        </div>
                                        {emp.is_critical && (
                                            <div className="employee-status">
                                                <span className="badge color-badge-red">
                                                    {emp.is_critical ? 'CRITICAL' : 'ERROR'}
                                                </span>
                                            </div>
                                        )}

                                        <div className="font-size-text">
                                            {emp.message || emp.errors?.[0] || 'Unknown error'}
                                        </div>
                                        {emp.missing_months && emp.missing_months.length > 0 && (
                                            <div className="font-size-text mt-1 text-secondary-color">
                                                <strong>Missing Months:</strong> {emp.missing_months.join(', ')}
                                            </div>
                                        )}

                                    </div>

                                    {emp.errors?.length > 0 && (
                                        <div className="result-card-details">
                                            <strong>Error Details:</strong>
                                            <ul>
                                                {emp.errors.map((error, errIdx) => (
                                                    <li key={errIdx} className="font-size-text error-message-input">
                                                        {error}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            ))}

                        </div>
                    )}


                    {activeTab === 'skipped' && results?.skipped?.length > 0 && (
                        <div className="scroll-container-table">
                            {results.skipped.map((emp, idx) => (
                                <div key={idx} className="result-card color-card-warning">
                                    <div className="result-card-header">
                                        <div className="employee-code">
                                            <WarnYellow />
                                            {emp.emp_code}
                                        </div>
                                        <div className="employee-status text-uppercase">
                                            {emp.status}
                                        </div>
                                        <div className="font-size-text">
                                            {emp.message}
                                        </div>
                                        <div className="employee-actions">
                                            <span className="status-badge color-badge-emerald">
                                                Earliest: {emp.earliest_allowed_period}
                                            </span>
                                        </div>
                                    </div>

                                    {emp.errors?.length > 0 && (
                                        <div className="result-card-details">
                                            <strong>Validation Errors:</strong>
                                            <ul>
                                                {emp.errors.map((error, errIdx) => (
                                                    <li key={errIdx} className="font-size-text error-message-input">
                                                        {error}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}


                </div>

                {/* Action Buttons */}
                <div className="button-models">

                    <button
                        className="model-button-cancel model-button font-weight500"
                        onClick={handleComplete}
                    >
                        Done
                    </button>

                    {!isErrorResponse && isDryRun && stats?.failed === 0 && (
                        <button
                            className="model-button-download model-button font-weight500"
                            onClick={handleRetry}
                        >
                            Retry
                        </button>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

const MultipleBulkApiResultSummaryModal = ({
    show,
    handleClose,
    handleComplete,
    handleRetry,
    resultsList,
    isDryRun,
    fileName,
    operationType,
    restData,
    config = {} // Optional config for customization
}) => {
    // State management
    const [activeToggle, setActiveToggle] = useState(0);
    const [activeTab, setActiveTab] = useState('summary');
    const [expandedRows, setExpandedRows] = useState({});

    // Ensure resultsList is always an array
    const resultsArray = Array.isArray(resultsList) ? resultsList : [resultsList];
    const currentResult = resultsArray[activeToggle];
    const showToggles = resultsArray.length > 1;

    // Default configuration
    const defaultConfig = {
        operationTypes: {
            PAYRUN: 'PAYRUN',
            BULK_UPDATE: 'BULK_UPDATE',
            TAX_CALCULATION: 'TAX_CALCULATION',
            LEAVE_RESET: 'LEAVE_RESET',
            // Add more as needed
        },
        fieldMappings: {
            // Map summary field names to display names
            created_count: {
                label: 'Created',
                display: true,
                color: 'success'
            },
            updated_count: {
                label: 'Updated',
                display: true,
                color: 'warning'
            },
            deleted_count: {
                label: 'Deleted',
                display: true,
                color: 'danger'
            },
            saved_count: {
                label: 'Saved',
                display: true,
                color: 'success'
            },
            // Add more mappings as needed
        },
        customRenderers: {
            // Can add custom renderers for specific operation types
        }
    };

    const mergedConfig = { ...defaultConfig, ...config };

    // Determine operation type
    const getOperationType = () => {
        if (operationType) return operationType;
        if (currentResult?.metadata?.operation_type)
            return currentResult.metadata.operation_type;
        if (currentResult?.operation_type)
            return currentResult.operation_type;
        return 'UNKNOWN';
    };

    const operationTypeValue = getOperationType();
    const isPayrun = operationTypeValue === mergedConfig.operationTypes.PAYRUN;
    const isBulkUpdate = operationTypeValue === mergedConfig.operationTypes.BULK_UPDATE;
    const isTaxCalculation = operationTypeValue === mergedConfig.operationTypes.TAX_CALCULATION;

    // Generic stats extraction
    const getStats = (result) => {
        if (!result) return null;

        const summary = result.summary || {};
        const isErrorResponse = Boolean(result.error || result.details);

        // Base stats (common for all operations)
        const baseStats = {
            total: summary.total_employees || summary.total || 0,
            successful: summary.successful_count || summary.successful || 0,
            failed: summary.failed_count || summary.failed || 0,
            skipped: summary.skipped_count || summary.skipped || 0,
            isError: isErrorResponse,
            errorMessage: isErrorResponse ? (result.error || result.details) : null
        };

        // Extract operation-specific stats dynamically
        const operationStats = {};
        Object.keys(mergedConfig.fieldMappings).forEach(field => {
            if (summary[field] !== undefined) {
                operationStats[field] = summary[field];
            }
        });

        // Extract financial metrics
        const financialStats = {
            total_amount_impact: summary.total_amount_impact || summary.total_amount || '0.00',
            total_monthly_tds_amount: summary.total_monthly_tds_amount || '0.00'
        };

        return {
            ...baseStats,
            ...operationStats,
            ...financialStats
        };
    };

    const currentStats = getStats(currentResult);
    const isErrorResponse = currentResult?.error || currentResult?.details;

    // Calculate overall summary
    const getOverallSummary = () => {
        const overall = {
            total: 0,
            successful: 0,
            failed: 0,
            skipped: 0
        };

        // Add dynamic fields
        Object.keys(mergedConfig.fieldMappings).forEach(field => {
            overall[field] = 0;
        });

        resultsArray.forEach(result => {
            const stats = getStats(result);
            if (stats) {
                overall.total += stats.total || 0;
                overall.successful += stats.successful || 0;
                overall.failed += stats.failed || 0;
                overall.skipped += stats.skipped || 0;

                // Add dynamic fields
                Object.keys(mergedConfig.fieldMappings).forEach(field => {
                    overall[field] += stats[field] || 0;
                });
            }
        });

        return overall;
    };

    const overallSummary = getOverallSummary();

    // Generic export function
    const exportToCSV = (result) => {
        if (!result) return;

        const csvData = [];
        const isError = result.error || result.details;
        const opType = operationTypeValue.toLowerCase().replace(/_/g, '-');

        // Header
        csvData.push([`${operationTypeValue.replace(/_/g, ' ')} - Results`]);
        csvData.push([]);

        // Basic info
        csvData.push(['Mode:', isDryRun ? 'Dry Run (Validation Only)' : 'Actual Operation']);
        csvData.push(['Operation Type:', operationTypeValue]);
        if (fileName) csvData.push(['File:', fileName]);
        csvData.push(['Timestamp:', new Date().toLocaleString()]);
        csvData.push([]);

        // Error details
        if (isError) {
            csvData.push(['Error Summary']);
            csvData.push(['Error:', result.error || 'Unknown error']);
            if (result.details) csvData.push(['Details:', result.details]);
            csvData.push([]);
        }

        const stats = getStats(result);

        // Summary statistics
        csvData.push(['Summary Statistics']);
        csvData.push(['Total Employees', stats?.total]);
        csvData.push(['Successful', stats?.successful]);
        csvData.push(['Failed', stats?.failed]);
        csvData.push(['Skipped', stats?.skipped]);

        // Dynamic operation fields
        Object.entries(mergedConfig.fieldMappings).forEach(([field, config]) => {
            if (config.display && stats?.[field] !== undefined) {
                csvData.push([config.label, stats[field]]);
            }
        });
        csvData.push([]);

        // Successful employees
        if (result.successful?.length > 0) {
            csvData.push(['Successful Employees']);

            // Dynamic headers based on available data
            const headers = ['Index', 'Employee Code', 'Status', 'Message'];
            const firstEmp = result.successful[0];

            // Add dynamic fields
            if (firstEmp.created_count !== undefined) headers.push('Created');
            if (firstEmp.updated_count !== undefined) headers.push('Updated');
            if (firstEmp.deleted_count !== undefined) headers.push('Deleted');
            if (firstEmp.total_amount !== undefined) headers.push('Total Amount');

            csvData.push(headers);

            result.successful.forEach((emp, idx) => {
                const row = [
                    idx + 1,
                    emp.emp_code,
                    emp.status,
                    emp.message || emp.status
                ];

                if (emp.created_count !== undefined) row.push(emp.created_count);
                if (emp.updated_count !== undefined) row.push(emp.updated_count);
                if (emp.deleted_count !== undefined) row.push(emp.deleted_count);
                if (emp.total_amount !== undefined) row.push(`₹${formatCurrency(emp.total_amount)}`);

                csvData.push(row);
            });
            csvData.push([]);
        }

        // Failed employees
        if (result.failed?.length > 0) {
            csvData.push(['Failed Employees']);
            csvData.push(['Employee Code', 'Status', 'Error Messages', 'Critical']);

            result.failed.forEach(emp => {
                const errors = Array.isArray(emp.errors) ? emp.errors.join('; ') : (emp.errors || emp.message);
                csvData.push([
                    emp.emp_code,
                    emp.status || 'FAILED',
                    errors,
                    emp.is_critical ? 'YES' : 'NO'
                ]);
            });
            csvData.push([]);
        }

        // Skipped employees
        if (result.skipped?.length > 0) {
            csvData.push(['Skipped Employees']);
            csvData.push(['Employee Code', 'Status', 'Reason']);

            result.skipped.forEach(emp => {
                csvData.push([
                    emp.emp_code,
                    emp.status || 'SKIPPED',
                    emp.message || emp.errors?.[0] || 'Skipped'
                ]);
            });
        }

        // Convert to CSV
        const csvString = csvData.map(row =>
            row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(',')
        ).join('\n');

        // Download
        const blob = new Blob([csvString], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const toggleLabel = resultsArray.length > 1 ? `-batch-${activeToggle + 1}` : '';
        a.download = `${opType}-results${toggleLabel}-${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };

    // Generic card rendering
    const renderOperationCards = () => {
        return (
            <div className="flex-row gap-3">
                {Object.entries(mergedConfig.fieldMappings).map(([field, config]) => {
                    if (!config.display || currentStats?.[field] === undefined) return null;

                    const colorClass = `color-button-${config.color}`;
                    return (
                        <div key={field} className={`priority-button text-center ${colorClass}`}>
                            <div className="font-size-label text-uppercase">
                                {config.label}
                            </div>
                            <div className="font-size-heading font-weight600">
                                {currentStats[field] || 0}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    // Generic employee row renderer
    const renderEmployeeRow = (emp, index, type) => {
        const isSuccess = type === 'successful';
        const isFailed = type === 'failed';
        const isSkipped = type === 'skipped';

        const cardClass = `result-card ${isSuccess ? 'color-card-success' :
            isFailed ? 'color-card-danger' :
                'color-card-warning'
            }`;

        return (
            <div key={`${type}-${index}`} className={cardClass}>
                <div className="result-card-header">
                    <div className="employee-code">
                        {isSuccess ? <CheckTick /> :
                            isFailed ? <CrossRed /> :
                                <WarnYellow />}
                        <strong>{emp.emp_code}</strong>
                        {emp.name && <span className="ml-2 text-secondary-color">({emp.name})</span>}
                    </div>
                    <div className="employee-status text-uppercase">
                        {emp.status}
                    </div>
                    <div className="font-size-text">
                        {emp.message || emp.errors?.[0] || emp.status}
                    </div>

                    {/* Dynamic action badges */}
                    <div className="employee-actions flex-row gap-1">
                        {emp.created_count > 0 && (
                            <span className="badge color-badge-green">+{emp.created_count}</span>
                        )}
                        {emp.updated_count > 0 && (
                            <span className="badge color-badge-yellow">~{emp.updated_count}</span>
                        )}
                        {emp.deleted_count > 0 && (
                            <span className="badge color-badge-red">-{emp.deleted_count}</span>
                        )}
                        {emp.is_critical && (
                            <span className="badge color-badge-red">CRITICAL</span>
                        )}
                    </div>
                </div>

                {/* Additional details for successful employees */}
                {isSuccess && emp.tax_summary && (
                    <div className="result-card-details pt-2">
                        <div className="flex-row justify-evenly">
                            <div className="flex-column">
                                <div className="font-size-label">Monthly TDS</div>
                                <div className="font-weight600">
                                    ₹{formatCurrency(emp.tax_summary.monthly_tds_final || 0)}
                                </div>
                            </div>
                            <div className="flex-column">
                                <div className="font-size-label">Annual Tax</div>
                                <div className="font-weight600">
                                    ₹{formatCurrency(emp.tax_summary.annual_tax || 0)}
                                </div>
                            </div>
                            {emp.tax_summary.regime && (
                                <div className="flex-column">
                                    <div className="font-size-label">Regime</div>
                                    <div className="font-weight600">
                                        {emp.tax_summary.regime}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}


                {/* Additional details for successful leave reset employees */}
                {isSuccess && emp.changes && emp.changes.length > 0 && (
                    <div className="result-card-details pt-2 mt-2">
                        <div className="flex-row justify-between">
                            <strong>Leaves Reset:</strong>
                            <div className="flex-row flex-wrap gap-2 mt-1">
                                {emp.changes.map((change, idx) => (
                                    <span
                                        key={idx}
                                        className="badge color-badge-yellow"
                                        style={{ fontSize: '11px' }}
                                    >
                                        {change.leave_type.replace(/_/g, ' ')}: {change.reset_amount} leaves
                                    </span>
                                ))}
                            </div>

                        </div>
                        <div className="font-size-smaller text-secondary-color mt-1">
                            {emp.changes.map((change, idx) => (
                                <span key={idx}>
                                    {change.leave_type.replace(/_/g, ' ')}: {change.from} → 0
                                    {idx < emp.changes.length - 1 && ', '}
                                </span>
                            ))}
                        </div>
                    </div>
                )}

                {/* Error details for failed employees */}
                {isFailed && emp.errors?.length > 0 && (
                    <div className="result-card-details">
                        <strong>Error Details:</strong>
                        <ul>
                            {emp.errors.map((error, errIdx) => (
                                <li key={errIdx} className="font-size-text error-message-input">
                                    {error}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        );
    };

    return (
        <Modal show={show} onHide={handleClose} dialogClassName="three-fourth-modal">
            <Modal.Header className="font-weight500 font-size-heading">
                <Modal.Title>
                    {operationTypeValue.replace(/_/g, ' ')} Results
                    {resultsArray.length > 1 && ` (${resultsArray.length} batches)`}
                </Modal.Title>

                <div className="flex-row">
                    <button
                        className="priority-button-small model-button-download"
                        title="Export to CSV"
                        onClick={() => exportToCSV(currentResult)}>
                        <DownloadIcon /> Export CSV
                    </button>
                </div>
            </Modal.Header>

            <Modal.Body>
                {/* Overall Summary Banner */}
                {resultsArray.length > 1 && (
                    <div className="overall-summary-banner mb-3 p-3 bg-light rounded">
                        <div className="flex-row justify-between align-center mb-2">
                            <h6 className="mb-0 font-weight600">Overall Summary ({resultsArray.length} batches)</h6>
                            <div className="badge color-badge-blue">
                                Total Employees: {overallSummary.total}
                            </div>
                        </div>
                        <div className="flex-row gap-3">
                            <div className="flex-column align-center">
                                <div className="font-size-label text-success">Successful</div>
                                <div className="font-weight600 font-size-heading">{overallSummary.successful}</div>
                            </div>
                            <div className="flex-column align-center">
                                <div className="font-size-label text-danger">Failed</div>
                                <div className="font-weight600 font-size-heading">{overallSummary.failed}</div>
                            </div>
                            <div className="flex-column align-center">
                                <div className="font-size-label text-warning">Skipped</div>
                                <div className="font-weight600 font-size-heading">{overallSummary.skipped}</div>
                            </div>
                            {/* Dynamic operation stats */}
                            {Object.entries(mergedConfig.fieldMappings).map(([field, config]) => {
                                if (!config.display || overallSummary[field] === 0) return null;
                                return (
                                    <div key={field} className="flex-column align-center">
                                        <div className={`font-size-label text-${config.color}`}>
                                            {config.label}
                                        </div>
                                        <div className="font-weight600 font-size-heading">
                                            {overallSummary[field]}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}

                {/* Toggle Tabs for Multiple Results */}
                {showToggles && (
                    <div className="bloc-tabss wfm-margin mb-3">
                        {resultsArray.map((result, index) => {
                            const stats = getStats(result);
                            const isError = result?.error || result?.details;

                            return (
                                <button
                                    key={index}
                                    className={`dashboardcomponent-tabs ${activeToggle === index ? 'dashboardcomponent-active-tabs' : ''
                                        } ${isError ? 'color-tab-red' : ''}`}
                                    onClick={() => {
                                        setActiveToggle(index);
                                        setActiveTab('summary');
                                    }}
                                >
                                    Batch {index + 1}
                                    {isError && <span className="ml-1" title="Contains errors">⚠️</span>}
                                    <div className="font-size-smaller text-secondary-color">
                                        {stats?.successful || 0}✔️ / {stats?.failed || 0}✖️
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                )}

                {/* Error Banner */}
                {isErrorResponse && (
                    <div className="notice-badge color-tab-red mb-3">
                        <strong>❌ Operation Failed:</strong> {currentResult.error || 'Unknown error'}
                        <br />
                        <strong>Details:</strong> {currentResult.details || 'No additional details'}
                    </div>
                )}

                {/* Stats Cards */}
                <div className="field-cont justify-between">
                    <div className="flex-row gap-3">
                        <div className="color-card color-card-success">
                            <div className="priority-button color-tab-green"><CheckTick /></div>
                            <hr className="field-cont-hr" />
                            <div className="flex-column align-start">
                                <div className="font-weight600 font-size-heading">{currentStats?.successful}</div>
                                <div className="font-size-label text-secondary-color">Successful</div>
                            </div>
                        </div>
                        <div className="color-card color-card-danger">
                            <div className="priority-button color-tab-red"><CrossRed /></div>
                            <hr className="field-cont-hr" />
                            <div className="flex-column align-start">
                                <div className="font-weight600 font-size-heading">{currentStats?.failed}</div>
                                <div className="font-size-label text-secondary-color">Failed</div>
                            </div>
                        </div>
                        <div className="color-card color-card-warning">
                            <div className="priority-button color-tab-yellow"><WarnYellow /></div>
                            <hr className="field-cont-hr" />
                            <div className="flex-column align-start">
                                <div className="font-weight600 font-size-heading">{currentStats?.skipped}</div>
                                <div className="font-size-label text-secondary-color">Skipped</div>
                            </div>
                        </div>
                    </div>

                    {/* Dynamic Operation Cards */}
                    {renderOperationCards()}
                </div>

                {/* Detail Tabs */}
                <div className="bloc-tabss wfm-margin">
                    <button className={`dashboardcomponent-tabs ${activeTab === 'summary' ? 'dashboardcomponent-active-tabs' : ''}`}
                        onClick={() => setActiveTab('summary')}>
                        Summary ({currentStats?.total || 0})
                    </button>
                    {currentResult?.successful?.length > 0 && (
                        <button className={`dashboardcomponent-tabs ${activeTab === 'successful' ? 'dashboardcomponent-active-tabs' : ''}`}
                            onClick={() => setActiveTab('successful')}>
                            Successful ({currentResult.successful.length})
                        </button>
                    )}
                    {currentResult?.failed?.length > 0 && (
                        <button className={`dashboardcomponent-tabs ${activeTab === 'failed' ? 'dashboardcomponent-active-tabs' : ''}`}
                            onClick={() => setActiveTab('failed')}>
                            Failed ({currentResult.failed.length})
                        </button>
                    )}
                    {currentResult?.skipped?.length > 0 && (
                        <button className={`dashboardcomponent-tabs ${activeTab === 'skipped' ? 'dashboardcomponent-active-tabs' : ''}`}
                            onClick={() => setActiveTab('skipped')}>
                            Skipped ({currentResult.skipped.length})
                        </button>
                    )}
                </div>

                {/* Tab Content */}
                <div className="scrollfix-container" style={{ maxHeight: '400px' }}>
                    {activeTab === 'summary' && (
                        <div className="summary-details">
                            {!isErrorResponse && (
                                <div className="notice-badge color-tab-teal mb-2">
                                    <strong>Mode:</strong> {isDryRun ? 'Dry Run (Validation Only)' : 'Actual Operation'}
                                    <br />
                                    <strong>Operation:</strong> {operationTypeValue.replace(/_/g, ' ')}
                                    <br />
                                    <strong>Message:</strong> {currentResult?.message || restData?.message || 'Processing completed'}
                                </div>
                            )}
                            {currentStats?.failed > 0 && (
                                <div className="notice-badge color-tab-red mb-2">
                                    <strong>Attention:</strong> {currentStats.failed} employee(s) failed to process.
                                </div>
                            )}
                        </div>
                    )}

                    {activeTab === 'successful' && currentResult?.successful?.map((emp, idx) =>
                        renderEmployeeRow(emp, idx, 'successful')
                    )}

                    {activeTab === 'failed' && currentResult?.failed?.map((emp, idx) =>
                        renderEmployeeRow(emp, idx, 'failed')
                    )}

                    {activeTab === 'skipped' && currentResult?.skipped?.map((emp, idx) =>
                        renderEmployeeRow(emp, idx, 'skipped')
                    )}
                </div>

                {/* Action Buttons */}
                <div className="button-models">
                    <button className="model-button-cancel model-button font-weight500" onClick={handleComplete}>
                        Done
                    </button>
                    {!isErrorResponse && isDryRun && currentStats?.failed === 0 && (
                        <button className="model-button-download model-button font-weight500" onClick={() => handleRetry(currentResult)}>
                            Retry
                        </button>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};


const PayrollSalaryStructureFormatBackup = ({
    code,
    getSalaryStructure,
}) => {

    const [show, setShow] = useState(false);
    const [customData, setCustomData] = useState([]);
    const handleClose = () => setShow(false);
    const handleShow = async () => {
        getAllSalaryRelatedData(code)
        setShow(true);
    };
    const [sortingVarBY, setSortingVarBY] = useState(false);
    const [roundOffAmount, setRoundOffAmount] = useState(true);


    const [salaryData, setSalaryData] = useState({});
    const [deductionData, setDeductionData] = useState([]);
    const [salaryDeductionPolicies, setSalaryDeductionPolicy] = useState([]);
    const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);



    const getAllSalaryRelatedData = async (emp_code) => {
        try {
            const salary = await axios.get(
                `${BASE_URL}/wfm/getsalarystructurebyemp/${emp_code}/`
            );
            setSalaryData(salary.data);
            const deduction = await axios.get(`${BASE_URL}/wfm/customdeduction-byempsalarystructureid/${salary.data.id}/`);
            setDeductionData(deduction.data);

            const policies = await axios.get(`${BASE_URL}/wfm/salarypolicybysubcompany/${sessionStorage.getItem("company_id")}/`);
            setSalaryDeductionPolicy(policies.data);

            const headings = await axios.get(`${BASE_URL}/wfm/salaryHeadingbysubcompany/${sessionStorage.getItem("company_id")}/`);
            setSalaryStructureHeadings(headings.data);
            if (Array.isArray(headings.data)) {
                setSalaryStructureHeadings(headings.data);
                const customData = headings.data.map(item => ({
                    name: item.id,
                    salary_structure: salary.data.id,
                    salary_type: item.salary_type,
                    sorting_var: item.sorting_var,
                    percentage: '',
                    percentage_of: [],
                    fixed_amount: '',
                }));
                setCustomData(customData);
            } else {
                console.error("Error: Expected a list of Salary Headings");
            }
        } catch (err) {
            handleAllError(err)
        } finally {
        }
    };


    return (
        <>
            <button
                className="model-view-button model-add"
                title="Add Salary Details"
                onClick={handleShow}
            >
                <Wallet />
            </button >
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="five-sixth-modal"
            >
                <Modal.Header closeButton>
                    <div className="parent-div ">
                        <div className="bdy-div">
                            <div className="flex-row justify-between">
                                <Modal.Title>Salary Structure of : "{code}"</Modal.Title>
                                {deductionData.length > 0 &&
                                    <>
                                        <ClearCustomDeductions
                                            salary_structure={salaryData.id}
                                            emp_code={code}
                                            deductionData={deductionData}
                                            getData={getAllSalaryRelatedData}
                                            roundOffAmount={roundOffAmount}
                                            sortingVarBY={sortingVarBY}
                                        />
                                    </>
                                }
                            </div>
                            {deductionData.length > 0 &&
                                <div>
                                    <div className="d-flex align-items-center ">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                id="toggle-sorting"
                                                name="show_emp_data"
                                                checked={sortingVarBY}
                                                onChange={() => setSortingVarBY(!sortingVarBY)}
                                            />
                                            <label htmlFor="toggle-sorting"></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <div className="d-flex align-items-center">
                                            <label className="sort-label me-2">Sort By:</label>
                                            <span className="sort-method">
                                                {sortingVarBY ? "Slip" : "Structure"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center ">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                id="toggle-eoundoff"
                                                name="show_emp_data"
                                                checked={roundOffAmount}
                                                onChange={() => setRoundOffAmount(!roundOffAmount)}
                                            />
                                            <label htmlFor="toggle-eoundoff"></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <div className="d-flex align-items-center">
                                            <label className="sort-label me-2">Show:</label>
                                            <span
                                                className="sort-method"
                                                title={roundOffAmount ? "Rounded Off (0.5+) to next" : "Actual Calculated Amount"}
                                            >
                                                {roundOffAmount ? "Rounded Off Amount" : "Actual Amount"}
                                            </span>
                                        </div>
                                    </div>
                                </div>}

                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ padding: "0" }}>
                    <div className="">
                        <div className="">
                            <UserCustomDeductionswithBulk
                                code={code}
                                deductionData={deductionData}
                                customData={customData}
                                salaryData={salaryData}
                                salaryStructureHeadings={salaryStructureHeadings}
                                salaryDeductionPolicies={salaryDeductionPolicies}
                                getSalaryStructure={getSalaryStructure}
                                getAllSalaryRelatedData={getAllSalaryRelatedData}
                                sortingVarBY={sortingVarBY}
                                roundOffAmount={roundOffAmount}
                            />
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
};

const PayrollSalaryStructureFormat = ({
    code,
    getSalaryStructure,
}) => {

    const [show, setShow] = useState(false);
    const [customData, setCustomData] = useState([]);
    const handleClose = () => setShow(false);
    const handleShow = async () => {
        getAllSalaryRelatedData(code)
        setShow(true);
    };
    const [wefDate, setWefDate] = useState("");
    const [sortingVarBY, setSortingVarBY] = useState(false);
    const [roundOffAmount, setRoundOffAmount] = useState(true);
    const [errors, setErrors] = useState({});

    const [salaryData, setSalaryData] = useState({});
    const [deductionData, setDeductionData] = useState([]);
    const [salaryDeductionPolicies, setSalaryDeductionPolicy] = useState([]);
    const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);
    const [formData, setFormData] = useState(deductionData);
    const [salarychanges, setSalaryChanges] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [buffer, setBuffering] = useState(false);

    const handleSalaryChanges = (e) => {
        setSalaryChanges(e.target.checked);
    };

    const fieldLabels = {
        wef_date: "Date",
        policy: "Salary Policy",
    };


    const validateForm = () => {
        const newErrors = {};

        if (deductionData.length === 0) {
            newErrors.policy = "Please select a salary policy";
        }
        if (!wefDate) {
            newErrors.wef_date = "Date is required";
        }

        // Validate each deduction entry
        formData.forEach((entry, index) => {
            if (entry.fixed_amount && (entry.percentage || entry.percentage_of.length > 0)) {
                newErrors[`deduction_${index}`] = "Cannot have both fixed amount and percentage";
            } else if (entry.percentage && entry.percentage_of.length === 0) {
                newErrors[`deduction_${index}`] = "Related To is required when using percentage";
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        console.log("newErrors:", newErrors)
        return Object.keys(newErrors).length === 0;
    };

    const getAllSalaryRelatedData = async (emp_code) => {
        setBuffering(true); // Start Buffering
        try {
            const salary = await axios.get(
                `${BASE_URL}/wfm/getsalarystructurebyemp/${emp_code}/`
            );
            setSalaryData(salary.data);
            const deduction = await axios.get(`${BASE_URL}/wfm/customdeduction-byempsalarystructureid/${salary.data.id}/`);
            setDeductionData(deduction.data);

            const policies = await axios.get(`${BASE_URL}/wfm/salarypolicybysubcompany/${sessionStorage.getItem("company_id")}/`);
            setSalaryDeductionPolicy(policies.data);

            const headings = await axios.get(`${BASE_URL}/wfm/salaryHeadingbysubcompany/${sessionStorage.getItem("company_id")}/`);
            setSalaryStructureHeadings(headings.data);
            if (Array.isArray(headings.data)) {
                setSalaryStructureHeadings(headings.data);
                const customData = headings.data.map(item => ({
                    name: item.id,
                    salary_structure: salary.data.id,
                    salary_type: item.salary_type,
                    sorting_var: item.sorting_var,
                    percentage: '',
                    percentage_of: [],
                    fixed_amount: '',
                    wef_date: '',
                }));
                setCustomData(customData);
            } else {
                console.error("Error: Expected a list of Salary Headings");
            }
        } catch (err) {
            handleAllError(err)
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    useEffect(() => {
        setFormData(deductionData);
    }, [deductionData]);


    // console.log(formData, "deduction");
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const updatedFormData = formData.map((entry, i) =>
            i === index ? { ...entry, [name]: value } : entry
        );
        setFormData(updatedFormData);
    };

    // const getRelatedToOptions = (currentIndex) => {
    //     return salaryStructureHeadings
    //         .filter(heading => {
    //             // Exclude the current item by ID
    //             if (heading.id === formData[currentIndex]?.name) return false;

    //             const relatedEntry = formData.find(entry => entry.name === heading.id);
    //             if (!relatedEntry) return false;

    //             return (relatedEntry.fixed_amount) ||
    //                 (relatedEntry.percentage && relatedEntry.percentage_of?.length > 0);
    //         })
    //         .sort((a, b) => a.sorting_var - b.sorting_var)
    //         .map(i => ({ value: i.id, label: i.title }));
    // };

    const getRelatedToOptions = (index) => {
        return formData.items
            ?.filter((item, idx) => idx !== index)
            .map(item => ({
                value: item.id,
                label: item.name_title
            }));
    };



    const handleSelectChange = (selectedOptions, index) => {
        setFormData(prev => {
            const updatedFormData = [...prev];
            updatedFormData[index] = {
                ...updatedFormData[index],
                percentage_of: selectedOptions
                    ? selectedOptions.map(option => ({ id: option.value, name: option.label }))
                    : []
            };
            return updatedFormData;
        });
    };


    const handleSubmitCustomDeduction = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            const validPolicyFormat = formData
                .filter(entry =>
                    (entry.fixed_amount) ||
                    (entry.percentage && entry.percentage_of.length > 0)
                )
                .map(entry => ({
                    ...entry,
                    emp_code: code,
                    percentage_of: entry.percentage_of?.map(item => item.name) || []
                }));

            const finalPayload = {
                item_list: validPolicyFormat,
                wef_date: wefDate,
                updated_by: sessionStorage.getItem('emp_code'),
            };

            const res = await axios.post(
                `${BASE_URL}/wfm/bulkcustomdeduction/`,
                finalPayload
            );
            if (res.status === 200 || res.status === 201) {
                await getAllSalaryRelatedData(code);
                toast.success("Deductions updated successfully!");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                className="model-view-button model-add"
                title="Add Salary Details"
                onClick={handleShow}
            >
                <Wallet />
            </button >
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="five-sixth-modal"
            >
                <Modal.Header closeButton>
                    <div className="parent-div w-100">
                        <div className="bdy-div" style={{ justifyContent: 'flex-start' }}>
                            <div className="flex-row gap-3">
                                <Modal.Title>Salary Structuress of : "{code}"</Modal.Title>
                                {deductionData.length > 0 &&
                                    <>
                                        <ClearCustomDeductions
                                            salary_structure={salaryData.id}
                                            emp_code={code}
                                            deductionData={deductionData}
                                            getData={getAllSalaryRelatedData}
                                            roundOffAmount={roundOffAmount}
                                            sortingVarBY={sortingVarBY}
                                        />
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ padding: "15px" }}>
                    {buffer && <Loader container={false} />}
                    <div>
                        {deductionData.length > 0 &&
                            <div className="flex flex-row align-center justify-between">
                                <div>
                                    <div className="d-flex align-items-center ">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                id="toggle-sorting"
                                                name="show_emp_data"
                                                checked={sortingVarBY}
                                                onChange={() => setSortingVarBY(!sortingVarBY)}
                                            />
                                            <label htmlFor="toggle-sorting"></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <div className="d-flex align-items-center">
                                            <label className="sort-label me-2">Sort By:</label>
                                            <span className="sort-method">
                                                {sortingVarBY ? "Slip" : "Structure"}
                                            </span>
                                        </div>
                                        {/* <hr className="field-cont-hr" /> */}
                                    </div>
                                    <div className="d-flex align-items-center ">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                id="toggle-eoundoff"
                                                name="show_emp_data"
                                                checked={roundOffAmount}
                                                onChange={() => setRoundOffAmount(!roundOffAmount)}
                                            />
                                            <label htmlFor="toggle-eoundoff"></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <div className="d-flex align-items-center">
                                            <label className="sort-label me-2">Show:</label>
                                            <span
                                                className="sort-method"
                                                title={roundOffAmount ? "Rounded Off (0.5+) to next" : "Actual Calculated Amount"}
                                            >
                                                {roundOffAmount ? "Rounded Off Amount" : "Actual Amount"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                id="toggle-salary-data"
                                                name="show_salary_data"
                                                checked={salarychanges}
                                                onChange={handleSalaryChanges}
                                            />
                                            <label htmlFor="toggle-salary-data"></label>


                                        </div>
                                        <hr className="field-cont-hr" />
                                        <div className="d-flex align-items-center">
                                            <label className="sort-label me-2">View:</label>
                                            <span
                                                className="sort-method"
                                                title={
                                                    salarychanges
                                                        ? "Currently showing salary change summary compared to baseline"
                                                        : "Currently showing detailed actual calculated amounts"
                                                }
                                            >
                                                {salarychanges ? "Salary Change Summary" : "Detailed Actual Amounts"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-column" style={{ alignItems: 'start' }}>
                                    <label htmlFor="wef_date" className="form-labels">
                                        Date
                                    </label>
                                    <input
                                        type="month"
                                        name="wef_date"
                                        value={wefDate}
                                        className={`multi-day-input1 form-input-background ${errors.wef_date ? "error" : ""}`}
                                        onChange={(e) => {
                                            setWefDate(e.target.value)
                                            if (errors.wef_date) {
                                                setErrors((prev) => {
                                                    const newErr = { ...prev };
                                                    delete newErr.wef_date;
                                                    return newErr;
                                                });
                                            }
                                        }}
                                    />
                                </div>
                            </div>}
                    </div>
                    <div>

                        {!salarychanges && (
                            <UserCustomDeductionswithBulk
                                code={code}
                                deductionData={deductionData}
                                customData={customData}
                                salaryData={salaryData}
                                wefdate={wefDate}
                                salaryStructureHeadings={salaryStructureHeadings}
                                salaryDeductionPolicies={salaryDeductionPolicies}
                                getSalaryStructure={getSalaryStructure}
                                getAllSalaryRelatedData={getAllSalaryRelatedData}
                                sortingVarBY={sortingVarBY}
                                roundOffAmount={roundOffAmount}
                            />
                        )}

                        {salarychanges && (
                            <div className="p-li" style={{ width: '100%', overflowX: 'auto', maxWidth: '-webkit-fill-available' }}>
                                <table className="table-css" style={{ width: '27%', minWidth: '-webkit-fill-available' }}>

                                    <thead>
                                        <tr className="custom-table-head-tr">
                                            <th className="align-left width-5vw">Position</th>
                                            <th className="align-left width-5vw">Heading</th>
                                            <th className="align-center width-5vw">Type</th>
                                            <th className="align-right width-5vw">Amount</th>
                                            <th className="align-center" style={{ width: '0.5vw' }}>OR</th>
                                            <th className="align-center width-5vw">Percentage</th>
                                            <th className="align-center" style={{ width: '0.5vw' }}></th>
                                            <th className="align-center width-5vw text-left">Related To</th>
                                            <th className="align-right width-5vw">Actual Amount</th>
                                            {/* {deductionData.length > 0 ?
                                                <th className="align-center width-5vw">Action</th>
                                                : null
                                            } */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formData
                                            ?.sort((a, b) => a.name_sorting_var - b.name_sorting_var)

                                            ?.map((entry, index) => {
                                                const { value: calculatedValue } = getCalculatedAmount(entry, formData)
                                                return (
                                                    <React.Fragment key={index}>
                                                        <tr className="custom-table-head-td" key={index}>
                                                            <td className="align-left" title={`${entry.sorting_var ? 'sorting_var' : 'name_sorting_var'}`}>{entry.sorting_var || entry.name_sorting_var}</td>
                                                            <td>
                                                                <div title="Salary Heading" className="flex-column ">
                                                                    <label
                                                                        htmlFor={`name_${index}`}
                                                                        className="font-weight500 font-size-heading text-capitalize"
                                                                    >
                                                                        {salaryStructureHeadings.find(t => t.id === entry.name)?.title || "Loading..."}
                                                                        {/* <span className="required">*</span> */}
                                                                    </label>
                                                                    <input
                                                                        id={`name_${index}`}
                                                                        name="name"
                                                                        style={{ display: 'none' }}
                                                                        value={salaryStructureHeadings.find(t => t.id === entry.name)?.title || "Loading..."}
                                                                        className={`width-5vw form-input-date ${errors[`${index}_name`] ? "error" : ""}`}
                                                                        disabled
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div title="Salary Type" className="flex-column ">
                                                                    <label
                                                                        htmlFor="name_type"
                                                                        className="font-weight500 font-size-heading text-capitalize"
                                                                    >
                                                                        {salaryStructureHeadings.find(t => t.id === entry.name)?.salary_type || "Loading..."}

                                                                    </label>
                                                                    <input
                                                                        id={`name_type_${index}`}
                                                                        name="name_type"
                                                                        style={{ display: 'none' }}
                                                                        value={salaryStructureHeadings.find(t => t.salary_type === entry.name_type)?.salary_type || "Loading..."}
                                                                        className={`width-5vw form-input-date ${errors[`${index}_name`] ? "error" : ""}`}
                                                                        disabled
                                                                    />
                                                                </div>
                                                            </td>

                                                            <td>
                                                                {entry.percentage || entry.percentage_of.length > 0 ? <div className="align-center">-</div> :
                                                                    <div title="Fixed Amount" className="flex-column">
                                                                        <input
                                                                            id={`fixed_amount_${index}`}
                                                                            name="fixed_amount"
                                                                            placeholder="Fixed Amount"
                                                                            type="number"
                                                                            min={0}
                                                                            step="0.01"
                                                                            onWheel={(e) => e.target.blur()}
                                                                            value={entry.fixed_amount}

                                                                            onChange={(e) => {
                                                                                const value = e.target.value;
                                                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                                                    handleInputChange(e, index);
                                                                                }
                                                                            }}
                                                                            className={`form-input-date width-5vw ${errors[`${index}_fixed_amount`] ? "error" : ""}`}
                                                                        />
                                                                    </div>
                                                                }
                                                            </td>
                                                            <td className="align-center">
                                                                <div style={{ width: '1vw' }} className="align-center width-5vw ">OR</div>

                                                            </td>
                                                            <td>
                                                                {entry.fixed_amount ? <div className="align-center">-</div> :
                                                                    <div title="Percentage of Amount" className="flex-column form-group-selectt">
                                                                        <input
                                                                            id={`percentage_${index}`}
                                                                            name="percentage"
                                                                            type="number"
                                                                            min={0}
                                                                            onWheel={(e) => e.target.blur()}
                                                                            value={entry.percentage}
                                                                            placeholder="Percentage of Amount"
                                                                            onChange={(e) => handleInputChange(e, index)}
                                                                            className={`form-input-date width-5vw ${errors[`${index}_percentage`] ? "error" : ""}`}
                                                                        />%
                                                                    </div>
                                                                }
                                                            </td>
                                                            <td className="align-center">
                                                                <div style={{ width: '1vw' }} className="align-center width-5vw ">
                                                                    {(entry.percentage || entry.percentage_of.length > 0) && 'of'}</div>
                                                            </td>
                                                            <td>
                                                                {entry.fixed_amount ? <div className="align-center">-</div> :
                                                                    <div title="Related To" className="flex-column form-group-selectt">
                                                                        <Select
                                                                            isMulti
                                                                            name="percentage_of"
                                                                            // value={getRelatedToOptions(index).filter(option =>
                                                                            //     entry.percentage_of?.some(po => po.id === option.value)
                                                                            // )}
                                                                            value={
                                                                                entry.percentage_of?.map(po => ({
                                                                                    value: po.id,
                                                                                    label: po.name
                                                                                })) || []
                                                                            }

                                                                            onChange={(selectedOptions) => handleSelectChange(selectedOptions, index)}
                                                                            options={getRelatedToOptions(index)}
                                                                            className={`width-15vw ${errors[`${index}_percentage_of`] ? 'is-invalid' : ''}`}
                                                                            classNamePrefix="select"
                                                                            placeholder="Select Related To"
                                                                            closeMenuOnSelect={false}
                                                                            styles={{
                                                                                control: (provided) => ({
                                                                                    ...provided,
                                                                                    minHeight: '50px',
                                                                                    borderRadius: '10px',
                                                                                    border: '1px solid #e3e3e3',
                                                                                    margin: '10px 0px 20px 0px',
                                                                                    color: '#4a4a4a',
                                                                                    backgroundColor: '#f7f8fa',
                                                                                    padding: '0px 10px',
                                                                                }),
                                                                                placeholder: (provided) => ({
                                                                                    ...provided,
                                                                                    color: '#4a4a4a',
                                                                                }),
                                                                                menu: (provided) => ({
                                                                                    ...provided,
                                                                                    borderRadius: '10px',
                                                                                    marginTop: '0',
                                                                                    zIndex: 9999,
                                                                                }),
                                                                                menuPortal: (base) => ({
                                                                                    ...base,
                                                                                    zIndex: 999999,
                                                                                }),
                                                                                input: (provided) => ({
                                                                                    ...provided,
                                                                                    color: '#4a4a4a',
                                                                                }),
                                                                                singleValue: (provided) => ({
                                                                                    ...provided,
                                                                                    color: '#4a4a4a',
                                                                                }),
                                                                            }}
                                                                        />
                                                                    </div>
                                                                }
                                                            </td>
                                                            <td className="align-center">
                                                                <div style={{ width: '1vw' }} className="align-center width-5vw ">
                                                                    {calculatedValue ? formatCurrencyIndian(calculatedValue.toFixed(2)) : "-"}
                                                                </div>

                                                            </td>
                                                        </tr>
                                                        {errors[`deduction_${index}`] && (
                                                            <tr>
                                                                <td colSpan='7' className="align-center error-message font-size-text">
                                                                    {errors[`deduction_${index}`]}
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                )
                                            })}
                                    </tbody>
                                </table>

                                <div className="button-models">

                                    <button
                                        type="submit"
                                        className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
                                        onClick={handleSubmitCustomDeduction}
                                        disabled={loading}
                                    >
                                        {loading ? 'Submitting...' : 'Submit Deductions'}
                                    </button>

                                </div>
                                <p className="error-message font-size-text">
                                    {isSubmitted && Object.keys(errors).length > 0 && (
                                        Object.keys(errors).length > 5 ? (
                                            <h5 className="text-center">Please fill all mandatory fields!</h5>
                                        ) : (

                                            <h6 className="text-center">
                                                {/* {Object.keys(errors).map((field) =>
                                                    field.charAt(0).toUpperCase() + field.slice(1)
                                                ).join(', ') + ' are required!'} */}
                                                {Object.keys(errors).map((field) =>
                                                    fieldLabels[field] || (field.charAt(0).toUpperCase() + field.slice(1))
                                                ).join(', ') + ' are required!'}

                                            </h6>
                                        )
                                    )}
                                </p>
                            </div>
                        )}
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
};

const UserCustomDeductionswithBulk = ({
    code,
    salaryData,
    customData,
    deductionData,
    handleClose,
    salaryStructureHeadings,
    getSalaryStructure,
    getAllSalaryRelatedData,
    salaryDeductionPolicies,
    sortingVarBY,
    roundOffAmount,
}) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState(customData);
    const [selectedPolicy, setSelectedPolicy] = useState("null");

    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handlePolicySelect = (e) => {
        const { value } = e.target;
        setSelectedPolicy(value);

        if (value === "null") {
            // Reset to original data when 'null' is selected
            setFormData(customData);
            return;
        }

        const selected = salaryDeductionPolicies.find(
            (format) => String(format.id) === String(value)
        );

        if (selected) {
            const transformedDeductions = selected.custom_deductions?.map((deduction) => ({
                ...deduction,
                percentage_of: deduction.percentage_of.map((item) => ({
                    id: item.name, // switch from item.id to item.name
                    name: item.name_title || item.name, // fallback to name if title is missing
                    title: item.name_title, // fallback to name if title is missing
                })),
            }));

            setFormData(transformedDeductions);
        }
    };



    const validateForm = () => {
        const newErrors = {};

        if (!selectedPolicy && deductionData.length === 0) {
            newErrors.policy = "Please select a salary policy";
        }

        // Validate each deduction entry
        formData.forEach((entry, index) => {
            if (entry.fixed_amount && (entry.percentage || entry.percentage_of.length > 0)) {
                newErrors[`deduction_${index}`] = "Cannot have both fixed amount and percentage";
            } else if (entry.percentage && entry.percentage_of.length === 0) {
                newErrors[`deduction_${index}`] = "Related To is required when using percentage";
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        console.log("newErrors:", newErrors)
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmitCustomDeduction = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            const validPolicyFormat = formData
                .filter(entry =>
                    (entry.fixed_amount) ||
                    (entry.percentage && entry.percentage_of.length > 0)
                )
                .map(entry => ({
                    ...entry,
                    emp_code: code,
                    percentage_of: entry.percentage_of?.map(item => item.name) || []
                }));


            const res = await axios.post(
                `${BASE_URL}/wfm/bulkcustomdeduction/`,
                validPolicyFormat
            );
            if (res.status === 200 || res.status === 201) {
                await getAllSalaryRelatedData(code);
                toast.success("Deductions saved successfully!");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const updatedFormData = formData.map((entry, i) =>
            i === index ? { ...entry, [name]: value } : entry
        );
        setFormData(updatedFormData);
    };

    const handleSelectChange = (selectedOptions, index) => {
        setFormData(prev => {
            const updatedFormData = [...prev];
            updatedFormData[index] = {
                ...updatedFormData[index],
                percentage_of: selectedOptions
                    ? selectedOptions.map(option => ({ id: option.value, name: option.label }))
                    : []
            };
            return updatedFormData;
        });
    };

    const getRelatedToOptions = (currentIndex) => {
        return salaryStructureHeadings
            .filter(heading => {
                // Exclude the current item by ID
                if (heading.id === formData[currentIndex]?.name) return false;

                const relatedEntry = formData.find(entry => entry.name === heading.id);
                if (!relatedEntry) return false;

                return (relatedEntry.fixed_amount) ||
                    (relatedEntry.percentage && relatedEntry.percentage_of?.length > 0);
            })
            .sort((a, b) => a.sorting_var - b.sorting_var)
            .map(i => ({ value: i.id, label: i.title }));
    };

    const deductionIds = deductionData.map(item => item.name);


    function dependencySort(data) {
        const idToEntry = Object.fromEntries(data.map(entry => [entry.id, entry]));
        const adjacencyList = {};
        const inDegree = {};

        data.forEach(entry => {
            const id = entry.id;
            inDegree[id] = 0;
            adjacencyList[id] = [];
        });

        data.forEach(entry => {
            entry.percentage_of?.forEach(dep => {
                if (adjacencyList[dep.id]) {
                    adjacencyList[dep.id].push(entry.id);
                    inDegree[entry.id]++;
                }
            });
        });

        const queue = Object.keys(inDegree).filter(id => inDegree[id] === 0);
        const sorted = [];

        while (queue.length) {
            const current = queue.shift();
            sorted.push(idToEntry[current]);

            adjacencyList[current].forEach(depId => {
                inDegree[depId]--;
                if (inDegree[depId] === 0) queue.push(depId);
            });
        }

        // Handle circular dependencies or remaining items
        const remaining = Object.keys(inDegree).filter(id => inDegree[id] > 0);
        if (remaining.length) {
            console.warn("Circular dependency detected. Adding remaining unsorted items at the end.");
            remaining.forEach(id => sorted.push(idToEntry[id]));
        }

        return sorted;
    }

    let sortedData = deductionData;

    if (sortingVarBY) {
        sortedData = [...deductionData].sort((a, b) => a.name_sorting_var - b.name_sorting_var);
    } else if (deductionData.every(item => item.sorting_var !== null)) {
        sortedData = [...deductionData].sort((a, b) => a.sorting_var - b.sorting_var);
    } else {
        sortedData = dependencySort(deductionData);
    }




    return (
        <>
            <div>
                {deductionData.length === 0 && (
                    <>
                        <div className="flex-column form-group-selectt">
                            <label htmlFor="salary_policy" className="form-labels">
                                Select Salary Policy
                            </label>
                            <br />
                            <select
                                name="salary_policy"
                                value={selectedPolicy}
                                onChange={handlePolicySelect}
                                placeholder="Select a policy"
                                className={`form-input form-group-selection ${errors.policy ? 'is-invalid' : ''}`}
                            >
                                <option value="null">Select Statuary Deduction Policy</option>
                                {salaryDeductionPolicies?.map((i) => (
                                    <option key={i.id} value={i.id}>{i.policy_name}</option>
                                ))}
                            </select>
                            <div className="form-group-selection-arrow">
                                <DropdownArrowOption />
                            </div>
                            {errors.salary_policy && <span className="error-message">{errors.salary_policy}</span>}
                        </div>
                    </>
                )}

                <table className="table-css width-10vw">
                    <thead>
                        <tr className="custom-table-head-tr">
                            <th className="align-left width-5vw">Position</th>
                            <th className="align-left width-5vw">Heading</th>
                            <th className="align-center width-5vw">Type</th>
                            <th className="align-right width-5vw">Amount</th>
                            <th className="align-center" style={{ width: '0.5vw' }}>OR</th>
                            <th className="align-center width-5vw">Percentage</th>
                            <th className="align-center" style={{ width: '0.5vw' }}></th>
                            <th className="align-center width-5vw text-left">Related To</th>
                            <th className="align-right width-5vw">Actual Amount</th>
                            {deductionData.length > 0 ?
                                <th className="align-center width-5vw">Action</th>
                                : null
                            }
                        </tr>
                    </thead>
                    {deductionData.length > 0 ? (
                        <tbody>
                            {sortedData
                                // .sort((a, b) =>
                                //     sortingVarBY
                                //         ? a.name_sorting_var - b.name_sorting_var
                                //         : a.sorting_var - b.sorting_var
                                // )
                                .map((entry, index) => (
                                    <tr className="custom-table-head-td" key={index}>
                                        <td className="align-left">{sortingVarBY ? entry.name_sorting_var : (entry.sorting_var || index + 1)}</td>
                                        <td className="align-left">{entry.name_title}</td>
                                        <td className="align-center text-capitalize">{entry.name_type}</td>

                                        <td className="align-right">
                                            {entry.fixed_amount
                                                ?
                                                roundOffAmount
                                                    ?
                                                    formatRoundoffComplete(entry.fixed_amount)
                                                    :
                                                    entry.fixed_amount
                                                :
                                                '-'
                                            }
                                        </td>
                                        <td className="align-center">
                                            <div style={{ width: '1vw' }} className="align-center width-5vw ">OR</div>
                                            {/* <hr className="field-cont-hr" /> */}
                                        </td>
                                        <td className="align-center">
                                            {entry.percentage ?
                                                `${parseFloat(entry.percentage) % 1 === 0 ?
                                                    parseFloat(entry.percentage).toFixed(0)
                                                    : parseFloat(entry.percentage).toFixed(2)}%`
                                                : '-'}
                                        </td>
                                        <td className="align-center">
                                            <div style={{ width: '1vw' }} className="align-center width-5vw ">
                                                {(entry.percentage || entry.percentage_of.length > 0) && 'of'}</div>
                                            {/* <hr className="field-cont-hr" /> */}
                                        </td>
                                        <td className="align-leftt width-10vw">
                                            {entry.percentage_of.length === 0 ?
                                                <div className="align-center">-</div> :
                                                // entry.percentage_of?.join(", ") || '-'
                                                <ul style={{ paddingLeft: '0' }}>
                                                    {entry.percentage_of.map((data, index) => (
                                                        <li key={index}>
                                                            <span className="text-capitalize">
                                                                {data.name}
                                                            </span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            }
                                        </td>
                                        <td className="align-right" style={{ cursor: 'help' }} title={`Calculations:\n${getCalculatedAmount(entry, sortedData).explanation}`}>
                                            {roundOffAmount ? formatRoundoffComplete(getCalculatedAmount(entry, sortedData).value || 0) : getCalculatedAmount(entry, sortedData).value}
                                        </td>

                                        <td className="align-center ">
                                            <div className="flex-row justify-around">
                                                <UpdateCustomDeductions
                                                    i={entry}
                                                    code={code}
                                                    deductionData={deductionData}
                                                    salaryStructureHeadings={salaryStructureHeadings}
                                                    getAllSalaryRelatedData={getAllSalaryRelatedData}
                                                />
                                                <DeleteCustomDeductions
                                                    i={entry}
                                                    code={code}
                                                    deductionData={deductionData}
                                                    salaryStructureHeadings={salaryStructureHeadings}
                                                    getAllSalaryRelatedData={getAllSalaryRelatedData}
                                                />
                                            </div>

                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    ) : (
                        <tbody>
                            {formData
                                ?.sort((a, b) => a.sorting_var - b.sorting_var)
                                // .sort((a, b) =>
                                //     sortingVarBY
                                //         ? a.name_sorting_var - b.name_sorting_var
                                //         : a.sorting_var - b.sorting_var
                                // )
                                ?.map((entry, index) => (
                                    <React.Fragment key={index}>
                                        <tr className="custom-table-head-td" key={index}>
                                            <td className="align-left" title={`${entry.sorting_var ? 'sorting_var' : 'name_sorting_var'}`}>{entry.sorting_var || entry.name_sorting_var}</td>
                                            <td>
                                                <div title="Salary Heading" className="flex-column ">
                                                    <label
                                                        htmlFor={`name_${index}`}
                                                        className="font-weight500 font-size-heading text-capitalize"
                                                    >
                                                        {salaryStructureHeadings.find(t => t.id === entry.name)?.title || "Loading..."}
                                                        {/* <span className="required">*</span> */}
                                                    </label>
                                                    <input
                                                        id={`name_${index}`}
                                                        name="name"
                                                        style={{ display: 'none' }}
                                                        value={salaryStructureHeadings.find(t => t.id === entry.name)?.title || "Loading..."}
                                                        className={`width-5vw form-input-date ${errors[`${index}_name`] ? "error" : ""}`}
                                                        disabled
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <div title="Salary Type" className="flex-column ">
                                                    <label
                                                        htmlFor="name_type"
                                                        className="font-weight500 font-size-heading text-capitalize"
                                                    >
                                                        {salaryStructureHeadings.find(t => t.id === entry.name)?.salary_type || "Loading..."}
                                                        {/* <span className="required">*</span>  */}
                                                    </label>
                                                    <input
                                                        id={`name_type_${index}`}
                                                        name="name_type"
                                                        style={{ display: 'none' }}
                                                        value={salaryStructureHeadings.find(t => t.salary_type === entry.name_type)?.salary_type || "Loading..."}
                                                        className={`width-5vw form-input-date ${errors[`${index}_name`] ? "error" : ""}`}
                                                        disabled
                                                    />
                                                </div>
                                            </td>

                                            <td>
                                                {entry.percentage || entry.percentage_of.length > 0 ? <div className="align-center">-</div> :
                                                    <div title="Fixed Amount" className="flex-column">
                                                        <input
                                                            id={`fixed_amount_${index}`}
                                                            name="fixed_amount"
                                                            placeholder="Fixed Amount"
                                                            type="number"
                                                            min={0}
                                                            step="0.01"
                                                            onWheel={(e) => e.target.blur()}
                                                            value={entry.fixed_amount}
                                                            // onChange={(e) => handleInputChange(e, index)}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                                    handleInputChange(e, index);
                                                                }
                                                            }}
                                                            className={`form-input-date width-5vw ${errors[`${index}_fixed_amount`] ? "error" : ""}`}
                                                        />
                                                    </div>
                                                }
                                            </td>
                                            <td className="align-center">
                                                <div style={{ width: '1vw' }} className="align-center width-5vw ">OR</div>
                                                {/* <hr className="field-cont-hr" /> */}
                                            </td>
                                            <td>
                                                {entry.fixed_amount ? <div className="align-center">-</div> :
                                                    <div title="Percentage of Amount" className="flex-column form-group-selectt">
                                                        <input
                                                            id={`percentage_${index}`}
                                                            name="percentage"
                                                            type="number"
                                                            min={0}
                                                            onWheel={(e) => e.target.blur()}
                                                            value={entry.percentage}
                                                            placeholder="Percentage of Amount"
                                                            onChange={(e) => handleInputChange(e, index)}
                                                            className={`form-input-date width-5vw ${errors[`${index}_percentage`] ? "error" : ""}`}
                                                        />%
                                                    </div>
                                                }
                                            </td>
                                            <td className="align-center">
                                                <div style={{ width: '1vw' }} className="align-center width-5vw ">
                                                    {(entry.percentage || entry.percentage_of.length > 0) && 'of'}</div>
                                                {/* <hr className="field-cont-hr" /> */}
                                            </td>
                                            <td>
                                                {entry.fixed_amount ? <div className="align-center">-</div> :
                                                    <div title="Related To" className="flex-column form-group-selectt">
                                                        <Select
                                                            isMulti
                                                            name="percentage_of"
                                                            value={getRelatedToOptions(index).filter(option =>
                                                                entry.percentage_of?.some(po => po.id === option.value)
                                                            )}
                                                            onChange={(selectedOptions) => handleSelectChange(selectedOptions, index)}
                                                            options={getRelatedToOptions(index)}
                                                            className={`width-15vw ${errors[`${index}_percentage_of`] ? 'is-invalid' : ''}`}
                                                            classNamePrefix="select"
                                                            placeholder="Select Related To"
                                                            closeMenuOnSelect={false}
                                                            styles={{
                                                                control: (provided) => ({
                                                                    ...provided,
                                                                    minHeight: '50px',
                                                                    borderRadius: '10px',
                                                                    border: '1px solid #e3e3e3',
                                                                    margin: '10px 0px 20px 0px',
                                                                    color: '#4a4a4a',
                                                                    backgroundColor: '#f7f8fa',
                                                                    padding: '0px 10px',
                                                                }),
                                                                placeholder: (provided) => ({
                                                                    ...provided,
                                                                    color: '#4a4a4a',
                                                                }),
                                                                menu: (provided) => ({
                                                                    ...provided,
                                                                    borderRadius: '10px',
                                                                    marginTop: '0',
                                                                    zIndex: 9999,
                                                                }),
                                                                menuPortal: (base) => ({
                                                                    ...base,
                                                                    zIndex: 999999,
                                                                }),
                                                                input: (provided) => ({
                                                                    ...provided,
                                                                    color: '#4a4a4a',
                                                                }),
                                                                singleValue: (provided) => ({
                                                                    ...provided,
                                                                    color: '#4a4a4a',
                                                                }),
                                                            }}
                                                        />
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                        {errors[`deduction_${index}`] && (
                                            <tr>
                                                <td colSpan='7' className="align-center error-message font-size-text">
                                                    {errors[`deduction_${index}`]}
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                        </tbody>
                    )}
                </table>
                <p className="error-message font-size-text">
                    {isSubmitted && Object.keys(errors).length > 0 && (
                        Object.keys(errors).length > 5 ? (
                            <h5 className="text-center">Please fill all mandatory fields!</h5>
                        ) : (

                            <h6 className="text-center">
                                {Object.keys(errors).map((field) =>
                                    field.charAt(0).toUpperCase() + field.slice(1)
                                ).join(', ') + ' are required!'}
                            </h6>
                        )
                    )}
                </p>
                <div className="button-models">
                    {deductionData.length > 0 ?
                        (salaryStructureHeadings?.filter(i => !deductionIds.includes(i.id)).length > 0 ?
                            <AddCustomDeductions
                                code={code}
                                deductionData={deductionData}
                                salaryData={salaryData}
                                salaryStructureHeadings={salaryStructureHeadings}
                                salaryDeductionPolicies={salaryDeductionPolicies}
                                getAllSalaryRelatedData={getAllSalaryRelatedData}
                            /> :
                            null
                        )
                        : (
                            <button
                                type="submit"
                                className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
                                onClick={handleSubmitCustomDeduction}
                                disabled={loading}
                            >
                                {loading ? 'Submitting...' : 'Submit Deductions'}
                            </button>
                        )}
                </div>
            </div>
        </>
    );
};

function getCalculatedAmount(entry, data, visited = new Set()) {
    if (visited.has(entry.id)) {
        return { value: 0, explanation: `[Cycle detected for ${entry.name_title}]` };
    }

    visited.add(entry.id);

    if (entry.fixed_amount) {
        const amount = parseFloat(entry.fixed_amount);
        return {
            value: amount,
            explanation: `${entry.name_title}: fixed amount = ${amount}`
        };
    }

    if (entry.percentage && entry.percentage_of?.length > 0) {
        const percentage = parseFloat(entry.percentage);
        const components = [];

        const values = entry.percentage_of.map(refItem => {
            const targetEntry = data.find(
                i =>
                    i.id === refItem.id ||
                    i.name === refItem.id ||
                    i.name === refItem.name ||
                    i.id === refItem.name
            );

            if (!targetEntry) {
                components.push(`Unknown ref: ${refItem.name || refItem.id}`);
                return 0;
            }

            const { value, explanation } = getCalculatedAmount(targetEntry, data, new Set(visited));
            components.push(`${targetEntry.name_title}: ${value}`);
            return value;
        });

        let baseTotal = 0;
        let breakdown = '';

        if (entry.name_type === 'difference') {
            const sorted = [...values].sort((a, b) => b - a); // Descending order
            const max = sorted[0];
            const restSum = sorted.slice(1).reduce((sum, v) => sum + v, 0);
            baseTotal = Math.max(0, max - restSum); // Ensure non-negative
            breakdown = `Max (${max}) - Sum of rest (${restSum}) = ${baseTotal}`;
        } else {
            baseTotal = values.reduce((sum, v) => sum + v, 0);
            breakdown = `Sum = ₹${baseTotal}`;
        }

        const result = (percentage / 100) * baseTotal;
        const explanation = `${entry.name_title} = (${percentage}%) of [${components.join(', ')}] \n→ ${breakdown} \n→ Final = ${result.toFixed(2)}`;

        return {
            value: result,
            explanation
        };
    }

    return {
        value: 0,
        explanation: `${entry.name_title}: No fixed or percentage defined`
    };
}

// ----------------------------------------------------------------------------------------------------------------
const MONTH_NAMES = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const EmployeePayrollSalaryStructure = ({
    code,
    getSalaryStructure,
}) => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setRequestSalaryChanges(false)
        setUpdateMode('specific')
        setDeductionData([])
        setShow(false)
    };

    const handleShow = async () => {
        // await getAllSalaryRelatedData(code);
        getAllSalaryRelatedData(code);
        setShow(true);
    };

    const [requestSalaryChanges, setRequestSalaryChanges] = useState(false);
    const [updateMode, setUpdateMode] = useState('specific'); // 'specific' or 'bulk'
    const [sortingVarBY, setSortingVarBY] = useState(false);
    const [roundOffAmount, setRoundOffAmount] = useState(true);
    const [wefPeriod, setWefPeriod] = useState('');
    const [minWefPeriod, setMinWefPeriod] = useState('');
    const [maxWefPeriod, setMaxWefPeriod] = useState('');
    const [empData, setEmpData] = useState({});
    const [joiningDate, setJoiningDate] = useState(null);
    const [empTimelineData, setEmployeeTimelineData] = useState(null); // Add state for timeline data

    const [buffer, setBuffering] = useState(false);
    const [buffer1, setBuffering1] = useState(false);
    const [buffer2, setBuffering2] = useState(false);
    const [buffer3, setBuffering3] = useState(false);
    const [salaryData, setSalaryData] = useState({});
    const [deductionData, setDeductionData] = useState([]);
    const [currentDeductionData, setCurrentDeductionData] = useState([]);
    const [salaryDeductionPolicies, setSalaryDeductionPolicy] = useState([]);
    const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);
    const [selectedPolicy, setSelectedPolicy] = useState("null");

    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const formatDateToMonthInput = (date) => {
        if (!date) return '';
        const d = new Date(date);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    };

    const getCurrentMonthYear = () => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    };

    const getNextMonth = (monthYearStr) => {
        if (!monthYearStr) return monthYearStr;

        const [yearStr, monthStr] = monthYearStr.split('-');
        let year = parseInt(yearStr);
        let month = parseInt(monthStr);

        if (month === 12) {
            year += 1;
            month = 1;
        } else {
            month += 1;
        }

        return `${year}-${String(month).padStart(2, '0')}`;
    };

    const formatMonthYear = (month, year) => {
        return `${year}-${String(month).padStart(2, '0')}`;
    };

    const addOneMonth = (month, year) => {
        const date = new Date(year, month - 1, 1);
        date.setMonth(date.getMonth() + 1);
        return formatMonthYear(date.getMonth() + 1, date.getFullYear());
    };


    // Function to get the latest date from timeline for minWefPeriod
    const getLatestTimelinePeriod = (timeline) => {
        if (!timeline) return null;

        let minPeriods = [];

        // 1️⃣ Add joining date if available
        if (timeline.joining_date) {
            minPeriods.push(formatDateToMonthInput(timeline.joining_date));
        }

        // 2️⃣ Salary Slip → NEXT month only
        if (
            timeline.last_salary_slip &&
            timeline.last_salary_slip.month &&
            timeline.last_salary_slip.year
        ) {
            const nextSlipMonth = addOneMonth(
                timeline.last_salary_slip.month,
                timeline.last_salary_slip.year
            );
            minPeriods.push(nextSlipMonth);
        }

        // 3️⃣ Salary Change → SAME month allowed
        if (
            timeline.last_salary_change &&
            timeline.last_salary_change.month &&
            timeline.last_salary_change.year
        ) {
            const changeMonth = formatMonthYear(
                timeline.last_salary_change.month,
                timeline.last_salary_change.year
            );
            minPeriods.push(changeMonth);
        }
        if (minPeriods.length === 0) return null;

        // Find the latest date
        return minPeriods.reduce((latest, current) => {
            return current > latest ? current : latest;
        });
    };

    // Function to update minWefPeriod based on slip data and requestSalaryChanges
    const updateMinWefPeriod = () => {
        let minPeriod = getCurrentMonthYear();

        if (empTimelineData) {
            const latestPeriod = getLatestTimelinePeriod(empTimelineData);

            if (latestPeriod) {
                if (requestSalaryChanges) {
                    // For salary change requests, set min to next month after latest period
                    minPeriod = latestPeriod;
                } else {
                    // For view mode, Fallback to joining date
                    minPeriod = formatDateToMonthInput(empTimelineData.joining_date);
                }
            } else if (empTimelineData.joining_date) {
                // Fallback to joining date if no other periods
                minPeriod = formatDateToMonthInput(empTimelineData.joining_date);
            }
        }
        setMinWefPeriod(minPeriod);
        // Adjust wefPeriod if it's less than the new min
        if (wefPeriod && wefPeriod < minPeriod) {
            setWefPeriod(minPeriod);
        }
    };

    useEffect(() => {
        if (show && empTimelineData) {
            updateMinWefPeriod();
        }
    }, [empTimelineData, requestSalaryChanges]);

    const getAllSalaryRelatedData = async (emp_code) => {
        setBuffering(true);
        try {
            // const currentMonthYear = getCurrentMonthYear();
            const currentMonthYear = wefPeriod != '' ? wefPeriod : getCurrentMonthYear();
            setWefPeriod(currentMonthYear);
            setMaxWefPeriod(getCurrentMonthYear());

            setBuffering1(true);
            setBuffering2(true);
            setBuffering3(true);

            await getEmployeeRelatedData(emp_code);
            await getBasicSalaryRelatedData(emp_code, currentMonthYear);
            await getCompanySalaryRelatedData(emp_code);
        } catch (err) {
            handleAllError(err);
        } finally {
            setBuffering(false);
        }
    };


    const getEmployeeRelatedData = async (emp_code) => {
        setBuffering3(true);
        try {
            // const emp = await axios.get(
            //     `${BASE_URL}/wfm/ourcompanydetailsbyemp/${emp_code}/`
            // );
            // setEmpData(emp.data)
            // if (emp.data.joining_date) {
            //     setJoiningDate(emp.data.joining_date);
            //     setMinWefPeriod(formatDateToMonthInput(emp.data.joining_date));
            // }

            // const slip = await axios.get(
            //     `${BASE_URL}/wfm/employeesalarysliplist/${emp_code}/`
            // );
            // setSlipData(slip.data)

            const emptimeline = await axios.get(`${BASE_URL}/wfm/employee-latest-timeline/${emp_code}/`);

            setEmployeeTimelineData(emptimeline.data);

            // Set joining date from timeline
            if (emptimeline.data.joining_date) {
                setJoiningDate(emptimeline.data.joining_date);
            }

            // // Update slip data if available from timeline
            // if (timelineResponse.data.last_salary_slip) {
            //     // Convert timeline slip data to format expected by slipData state
            //     const slipDataFromTimeline = [{
            //         month: timelineResponse.data.last_salary_slip.month,
            //         year: timelineResponse.data.last_salary_slip.year
            //     }];
            //     setSlipData(slipDataFromTimeline);
            // }


        } catch (err) {
            handleAllError(err);
            setMinWefPeriod(getCurrentMonthYear());
        } finally {
            setBuffering3(false);
        }
    };

    const getBasicSalaryRelatedData = async (emp_code, period) => {
        setBuffering1(true);
        try {
            // Get month and year from wefPeriod
            let month, year;
            if (wefPeriod || period) {
                const [periodYear, periodMonth] = period ? period.split('-') : wefPeriod.split('-');
                year = parseInt(periodYear);
                month = parseInt(periodMonth);
            } else {
                const now = new Date();
                month = now.getMonth() + 1;
                year = now.getFullYear();
            }

            // Use the new combined API
            const salaryDataResponse = await axios.get(`${BASE_URL}/wfm/fetch-empsalarydata-byhistorylog/${emp_code}/${month}/${year}/`,);

            if (salaryDataResponse.data && salaryDataResponse.data.salary_structure) {
                // Set salary structure data
                setSalaryData(salaryDataResponse.data.salary_structure);

                const deductions = salaryDataResponse.data.deductions || [];
                setDeductionData(deductions);
                setCurrentDeductionData(deductions);

                if (deductions.length === 0 && !requestSalaryChanges) {
                    setRequestSalaryChanges(true);
                }
            }
            setSelectedPolicy('current');
        } catch (err) {
            handleAllError(err);
        } finally {
            setBuffering1(false);
        }
    };

    const getCompanySalaryRelatedData = async (emp_code) => {
        setBuffering2(true);
        try {
            const policies = await axios.get(
                `${BASE_URL}/wfm/salarypolicybysubcompany/${sessionStorage.getItem("company_id")}/`
            );
            setSalaryDeductionPolicy(policies.data);

            const headings = await axios.get(
                `${BASE_URL}/wfm/salaryHeadingbysubcompany/${sessionStorage.getItem("company_id")}/`
            );
            setSalaryStructureHeadings(headings.data);
        } catch (err) {
            handleAllError(err);
        } finally {
            setBuffering2(false);
        }
    };

    const handleSalaryChanges = (e) => {
        const isChecked = e.target.checked;
        setRequestSalaryChanges(isChecked);

        if (!isChecked) {
            setSelectedPolicy("null");
            setErrors({});
            setIsSubmitted(false);
            // Reset wefPeriod to current month when disabling request changes
            setWefPeriod(getCurrentMonthYear());
        } else {
            // When enabling request changes, update minWefPeriod based on slip data
            updateMinWefPeriod();
        }
    };

    const handleUpdateModeChange = (mode) => {
        setUpdateMode(mode);
        setErrors({});
        setIsSubmitted(false);
    };

    const handleWefPeriodChange = (e) => {
        const newValue = e.target.value;

        // Validate that selected date is not in the future
        const currentMonthYear = getCurrentMonthYear();
        if (newValue > currentMonthYear) {
            setErrors(prev => ({
                ...prev,
                wef_period: "Cannot select a future period"
            }));
            return;
        }

        // Validate that selected date is not before minWefPeriod
        if (minWefPeriod && newValue < minWefPeriod) {
            let errorMessage = "Cannot select period before ";

            if (empTimelineData) {
                const latestPeriod = getLatestTimelinePeriod(empTimelineData);
                if (latestPeriod) {
                    if (empTimelineData.last_salary_slip &&
                        formatMonthYear(empTimelineData.last_salary_slip.month, empTimelineData.last_salary_slip.year) === latestPeriod) {
                        errorMessage += `last salary slip (${latestPeriod})`;
                    } else if (empTimelineData.last_salary_change &&
                        formatMonthYear(empTimelineData.last_salary_change.month, empTimelineData.last_salary_change.year) === latestPeriod) {
                        errorMessage += `last salary change (${latestPeriod})`;
                    } else if (empTimelineData.joining_date) {
                        errorMessage += `joining date (${latestPeriod})`;
                    }
                }
            } else {
                errorMessage += `${minWefPeriod}`;
            }

            setErrors(prev => ({
                ...prev,
                wef_period: errorMessage
            }));
            return;
        }

        setWefPeriod(newValue);

        // Clear any existing wef_period errors
        if (errors.wef_period) {
            setErrors(prev => {
                const newErr = { ...prev };
                delete newErr.wef_period;
                return newErr;
            });
        }

        // Refresh data for the new period
        if (show) {
            getBasicSalaryRelatedData(code, newValue);
        }
    };


    // Update the tooltip title in the JSX to show correct info
    const getWefPeriodTitle = () => {
        if (requestSalaryChanges && empTimelineData) {
            const latestPeriod = getLatestTimelinePeriod(empTimelineData);
            if (latestPeriod) {
                // const nextMonth = getNextMonth(latestPeriod);
                // return `Select period after latest event (${formatDate(latestPeriod, true).MonthYear}) - minimum ${formatDate(nextMonth, true).MonthYear}`;
                return `Minimum allowed period: ${formatDate(latestPeriod, true).MonthYear}`;

            }
        }
        return `Select period between ${formatDate(minWefPeriod, true).MonthYear || 'joining date'} and ${formatDate(maxWefPeriod, true).MonthYear || 'current month'}`;
    };


    const getWefPeriodTitle1 = () => {
        if (empTimelineData) {
            const minPeriod = getLatestTimelinePeriod(empTimelineData);
            if (minPeriod) {
                return `Minimum allowed period: ${minPeriod}`;
            }
        }
        return `Select period up to ${maxWefPeriod || 'current month'}`;
    };

    return (
        <>
            <button
                className="model-view-button model-add"
                title="Add Salary Details"
                onClick={handleShow}
            >
                <Wallet />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="five-sixth-modal"
                size="xl"
            >
                <Modal.Header className="custom-modal-header" closeButton>
                    <div style={{ minWidth: '97%' }} className="flex-row justify-between">
                        <Modal.Title>
                            Salary Structure of : "{code}"
                        </Modal.Title>
                        {/* {deductionData.length > 0 && ( */}
                        <div className="align-end">
                            <div className="flex-row align-center">
                                <span className="sort-method me-2">
                                    {requestSalaryChanges
                                        ? "Request Salary Structure Change"
                                        : "View Current Salary Structure"}
                                </span>
                                <div className="checkbox-toggle">
                                    <input
                                        type="checkbox"
                                        id="toggle-salary-data"
                                        checked={requestSalaryChanges}
                                        onChange={handleSalaryChanges}
                                    />
                                    <label htmlFor="toggle-salary-data"></label>
                                </div>
                            </div>
                        </div>
                        {/* )} */}
                    </div>
                </Modal.Header>

                <Modal.Body style={{ padding: "15px" }}>

                    {/* Control Panel */}
                    <div className="mb-3">
                        {/* {deductionData.length > 0 && ( */}
                        <div className="flex-row align-center justify-between mb-3">
                            <div style={{ width: "75%" }} className='align-items-center'>
                                {requestSalaryChanges ? (
                                    <div className="leave-duration-tabs" style={{ width: "100%", position: "relative", display: "flex", marginBottom: "15px" }}>
                                        <input
                                            type="radio"
                                            id="update-specific"
                                            name="updateType"
                                            value="specific"
                                            checked={updateMode === "specific"}
                                            onChange={(e) => handleUpdateModeChange(e.target.value)}
                                            hidden
                                        />
                                        <label htmlFor="update-specific" className="leave-tab" style={{ flex: 1, textAlign: "center" }}>
                                            Specific
                                        </label>

                                        <input
                                            type="radio"
                                            id="update-bulk"
                                            name="updateType"
                                            value="bulk"
                                            checked={updateMode === "bulk"}
                                            onChange={(e) => handleUpdateModeChange(e.target.value)}
                                            hidden
                                        />
                                        <label htmlFor="update-bulk" className="leave-tab" style={{ flex: 1, textAlign: "center" }}>
                                            Bulk
                                        </label>

                                        <span
                                            className="leave-tab-glider"
                                            style={{
                                                transform: updateMode === "specific" ? "translateX(0%)" : "translateX(100%)",
                                                width: "50%"
                                            }}
                                        ></span>
                                    </div>

                                ) : (
                                    <>
                                        <div className="flex-row align-start me-3">
                                            <div className="checkbox-toggle">
                                                <input
                                                    type="checkbox"
                                                    id="toggle-sorting"
                                                    checked={sortingVarBY}
                                                    onChange={() => setSortingVarBY(!sortingVarBY)}
                                                />
                                                <label htmlFor="toggle-sorting"></label>
                                            </div>
                                            <hr className="field-cont-hr" />
                                            <div className="d-flex align-items-center">
                                                <label className="sort-label me-2">Sort By:</label>
                                                <span className="sort-method">
                                                    {sortingVarBY ? "Slip" : "Structure"}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="flex-row align-start">
                                            <div className="checkbox-toggle">
                                                <input
                                                    type="checkbox"
                                                    id="toggle-roundoff"
                                                    checked={roundOffAmount}
                                                    onChange={() => setRoundOffAmount(!roundOffAmount)}
                                                />
                                                <label htmlFor="toggle-roundoff"></label>
                                            </div>
                                            <hr className="field-cont-hr" />
                                            <div className="flex-row">
                                                <label className="sort-label me-2">Show:</label>
                                                <span className="sort-method" title={roundOffAmount ? "Rounded Off" : "Actual"}>
                                                    {roundOffAmount ? "Rounded Amount" : "Actual Amount"}
                                                </span>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>

                            <div title="With Effect from Period" className="flex-column" style={{ alignItems: 'start' }}>
                                <label htmlFor="wef_period" className="form-labels">
                                    With Effect From :
                                </label>
                                <input
                                    type="month"
                                    name="wef_period"
                                    value={wefPeriod}
                                    min={minWefPeriod}
                                    max={maxWefPeriod}
                                    // disabled={!requestSalaryChanges}
                                    className={`multi-day-input1 form-input-background ${errors.wef_period ? "error" : ""}`}
                                    onChange={handleWefPeriodChange}
                                    title={getWefPeriodTitle()}
                                    style={{ cursor: 'help' }}
                                />
                                {errors.wef_period && (
                                    <div className="error-message" style={{ fontSize: '0.8rem', color: 'red' }}>
                                        {errors.wef_period}
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* )} */}
                    </div>

                    {/* Main Content */}
                    {
                        buffer1
                            ?
                            <Loader container={true} />
                            :
                            <div>
                                {!requestSalaryChanges ? (
                                    // View Current Salary Structure
                                    <SalaryStructureSpecificUpdate
                                        code={code}
                                        buffer2={buffer2}
                                        deductionData={deductionData}
                                        currentData={currentDeductionData}
                                        salaryData={salaryData}
                                        wefPeriod={wefPeriod}
                                        salaryStructureHeadings={salaryStructureHeadings}
                                        salaryDeductionPolicies={salaryDeductionPolicies}
                                        getSalaryStructure={getSalaryStructure}
                                        getAllSalaryRelatedData={getAllSalaryRelatedData}
                                        sortingVarBY={sortingVarBY}
                                        roundOffAmount={roundOffAmount}
                                    />
                                ) : (
                                    // Request Changes Mode
                                    <>
                                        {updateMode === 'specific' ? (
                                            // Specific Updates
                                            <SalaryStructureSpecificUpdate
                                                code={code}
                                                buffer2={buffer2}
                                                deductionData={deductionData}
                                                currentData={currentDeductionData}
                                                salaryData={salaryData}
                                                wefPeriod={wefPeriod}
                                                salaryStructureHeadings={salaryStructureHeadings}
                                                salaryDeductionPolicies={salaryDeductionPolicies}
                                                getSalaryStructure={getSalaryStructure}
                                                getAllSalaryRelatedData={getAllSalaryRelatedData}
                                                sortingVarBY={false}
                                                roundOffAmount={false}
                                                onClose={() => {
                                                    getAllSalaryRelatedData(code);
                                                    setRequestSalaryChanges(false);
                                                }}
                                                isEditMode={true}
                                            />
                                        ) : (
                                            // Bulk Updates
                                            <SalaryStructureBulkUpdate
                                                code={code}
                                                buffer1={buffer1}
                                                salaryData={salaryData}
                                                deductionData={deductionData}
                                                currentData={currentDeductionData}
                                                salaryStructureHeadings={salaryStructureHeadings}
                                                salaryDeductionPolicies={salaryDeductionPolicies}
                                                selectedPolicy={selectedPolicy}
                                                setSelectedPolicy={setSelectedPolicy}
                                                wefPeriod={wefPeriod}
                                                onWefPeriodChange={handleWefPeriodChange}
                                                errors={errors}
                                                setErrors={setErrors}
                                                isSubmitted={isSubmitted}
                                                setIsSubmitted={setIsSubmitted}
                                                getAllSalaryRelatedData={getAllSalaryRelatedData}
                                            />
                                        )}
                                    </>
                                )}
                            </div>
                    }
                </Modal.Body>
            </Modal >
        </>
    );
};

const SalaryStructureSpecificUpdate = ({
    code,
    salaryData,
    currentData,
    deductionData,
    salaryStructureHeadings,
    getAllSalaryRelatedData,
    salaryDeductionPolicies,
    sortingVarBY,
    roundOffAmount,
    buffer2,
    wefPeriod,
    onClose,
    isEditMode = false // When in request changes mode
}) => {
    const [formData, setFormData] = useState(currentData);

    // Helper for dependency sorting
    function dependencySort(data) {
        const idToEntry = Object.fromEntries(data.map(entry => [entry.id, entry]));
        const adjacencyList = {};
        const inDegree = {};

        data.forEach(entry => {
            const id = entry.id;
            inDegree[id] = 0;
            adjacencyList[id] = [];
        });

        data.forEach(entry => {
            entry.percentage_of?.forEach(dep => {
                if (adjacencyList[dep.id]) {
                    adjacencyList[dep.id].push(entry.id);
                    inDegree[entry.id]++;
                }
            });
        });

        const queue = Object.keys(inDegree).filter(id => inDegree[id] === 0);
        const sorted = [];

        while (queue.length) {
            const current = queue.shift();
            sorted.push(idToEntry[current]);

            adjacencyList[current].forEach(depId => {
                inDegree[depId]--;
                if (inDegree[depId] === 0) queue.push(depId);
            });
        }

        const remaining = Object.keys(inDegree).filter(id => inDegree[id] > 0);
        if (remaining.length) {
            console.warn("Circular dependency detected. Adding remaining unsorted items at the end.");
            remaining.forEach(id => sorted.push(idToEntry[id]));
        }

        return sorted;
    }

    let sortedData = deductionData;
    if (sortingVarBY) {
        sortedData = [...deductionData].sort((a, b) => a.name_sorting_var - b.name_sorting_var);
    } else if (deductionData.every(item => item.sorting_var !== null)) {
        sortedData = [...deductionData].sort((a, b) => a.sorting_var - b.sorting_var);
    } else {
        sortedData = dependencySort(deductionData);
    }

    const deductionIds = deductionData.map(item => item.name);

    console.log(sortedData, "sorteddata");

    return (
        <div>
            <hr />
            <div className="scroll-container-table">
                <table className="table-css " style={{ width: '100%', minWidth: '800px' }}>
                    <thead>
                        <tr className="custom-table-head-tr">
                            <th className="align-left width-5vw">Position</th>
                            <th className="align-left width-5vw">Heading</th>
                            <th className="align-center width-5vw">Type</th>
                            <th className="align-right width-5vw">Amount</th>
                            <th className="align-center" style={{ width: '0.5vw' }}>OR</th>
                            <th className="align-center width-5vw">Percentage</th>
                            {/* <th className="align-center" style={{ width: '0.5vw' }}></th> */}
                            <th className="align-center width-5vw text-left">Related To</th>
                            <th className="align-right width-5vw">Actual Amount</th>
                            {(isEditMode && deductionData.length > 0) && (
                                <th className="align-center width-5vw">Action</th>
                            )}
                        </tr>
                    </thead>

                    <tbody>
                        {sortedData.length > 0 ? (
                            sortedData.map((entry, index) => (
                                <tr className='custom-table-head-td request-status' request-status={entry.salary_is_final ? 'approved' : ''} key={index}>
                                    <td className="align-left">
                                        {sortingVarBY ? entry.name_sorting_var : (entry.sorting_var || index + 1)}
                                    </td>
                                    {/* <td className={`align-center ${entry.salary_is_final ? 'text-warning-color' : ''}`} >{entry.name_title}</td> */}
                                    <td className="align-left">{entry.name_title}</td>
                                    <td className="align-center text-capitalize">{entry.name_type}</td>
                                    <td className="align-right">
                                        {/* {entry.fixed_amount || '-'} */}
                                        {entry.fixed_amount
                                            ?
                                            roundOffAmount
                                                ?
                                                formatRoundoffComplete(entry.fixed_amount)
                                                :
                                                entry.fixed_amount
                                            :
                                            '-'
                                        }
                                    </td>

                                    <td className="align-center">
                                        <div style={{ width: '1vw' }} className="align-center width-5vw">OR</div>
                                    </td>
                                    <td className="align-center">
                                        {entry.percentage ?
                                            `${parseFloat(entry.percentage) % 1 === 0 ?
                                                parseFloat(entry.percentage).toFixed(0)
                                                : parseFloat(entry.percentage).toFixed(2)}%`
                                            : '-'}
                                    </td>
                                    {/* <td className="align-center">
                                        <div style={{ width: '1vw' }} className="align-center width-5vw">
                                            {(entry.percentage || entry.percentage_of.length > 0) && 'of'}
                                        </div>
                                    </td> */}
                                    <td className="align-leftt width-10vw">
                                        {entry.percentage_of.length === 0 ?
                                            <div className="align-center">-</div> :
                                            <ul style={{ paddingLeft: '0' }}>
                                                {entry.percentage_of.map((data, idx) => (
                                                    <li key={idx}>
                                                        <span className="text-capitalize">
                                                            {data.name}
                                                        </span>
                                                    </li>
                                                ))}
                                            </ul>
                                        }
                                    </td>
                                    <td className="align-right" style={{ cursor: 'help' }}
                                        title={`Calculations:\n${getCalculatedAmount(entry, sortedData).explanation}`}>
                                        {roundOffAmount
                                            ? formatRoundoffComplete(getCalculatedAmount(entry, sortedData).value || 0)
                                            : getCalculatedAmount(entry, sortedData).value}
                                    </td>
                                    {isEditMode && deductionData.length > 0 && (
                                        <td className="align-center">
                                            <div className="flex-row justify-around">
                                                <UpdateCustomDeductions
                                                    i={entry}
                                                    code={code}
                                                    deductionData={deductionData}
                                                    salaryStructureHeadings={salaryStructureHeadings}
                                                    getAllSalaryRelatedData={getAllSalaryRelatedData}
                                                    wefPeriod={wefPeriod}
                                                />
                                                <DeleteCustomDeductions
                                                    i={entry}
                                                    code={code}
                                                    deductionData={deductionData}
                                                    salaryStructureHeadings={salaryStructureHeadings}
                                                    getAllSalaryRelatedData={getAllSalaryRelatedData}
                                                    wefPeriod={wefPeriod}
                                                />
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={isEditMode ? 10 : 9} className="align-center">
                                    No salary structure data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Action buttons */}
            <div className="button-models">
                {
                    buffer2 ?
                        <div className="spinner-small"></div>
                        :
                        isEditMode && (
                            // deductionData.length > 0 && 
                            salaryStructureHeadings?.filter(i => !deductionIds.includes(i.id)).length > 0 ? (
                                <AddCustomDeductions
                                    code={code}
                                    deductionData={deductionData}
                                    salaryData={salaryData}
                                    salaryStructureHeadings={salaryStructureHeadings}
                                    salaryDeductionPolicies={salaryDeductionPolicies}
                                    getAllSalaryRelatedData={getAllSalaryRelatedData}
                                    wefPeriod={wefPeriod}
                                />
                            ) : null
                        )
                }
            </div>
        </div>
    );
};

const SalaryStructureBulkUpdate = ({
    code,
    salaryData,
    deductionData,
    currentData,
    salaryStructureHeadings,
    salaryDeductionPolicies,
    selectedPolicy,
    setSelectedPolicy,
    wefPeriod,
    errors,
    setErrors,
    isSubmitted,
    setIsSubmitted,
    getAllSalaryRelatedData,
}) => {
    // const [formData, setFormData] = useState(currentData || []);
    const [formData, setFormData] = useState([...currentData].map(item => ({
        ...item,
        percentage_of: item.percentage_of?.map(po => ({
            id: po.id || po.name,
            name: po.name || po.name_title || po.label
        })) || []
    })));
    const [loading, setLoading] = useState(false);
    const [updateType, setUpdateType] = useState('existing'); // 'existing' or 'new'
    const [changeReason, setChangeReason] = useState('');

    const handlePolicySelect = (e) => {
        const { value } = e.target;
        setSelectedPolicy(value);

        if (value === "current" && currentData.length > 0) {
            // set table data based on the currentData
            if (currentData && currentData.length > 0) {
                setFormData([...currentData].map(item => ({
                    ...item,
                    percentage_of: item.percentage_of?.map(po => ({
                        id: po.id || po.name,
                        name: po.name || po.name_title || po.label
                    })) || []
                })));
                setUpdateType('existing');
            }
        } else if (value === "null") {
            // set table data foth empty data for all available salaryheadding 
            const emptyForm = salaryStructureHeadings
                ?.sort((a, b) => a.sorting_var - b.sorting_var)
                .map(heading => ({
                    name: heading.id,
                    name_title: heading.title,
                    name_type: heading.salary_type,
                    name_sorting_var: heading.sorting_var,
                    salary_structure: salaryData?.id || '',
                    fixed_amount: '',
                    percentage: '',
                    percentage_of: [],
                    updated_by: sessionStorage.getItem('emp_code'),
                })) || [];
            setFormData(emptyForm);
            setUpdateType('new');
        }
        else if (value !== "null") {
            // Load selected policy data
            const selectedPolicyData = salaryDeductionPolicies?.find(p => p.id === value);
            if (selectedPolicyData && selectedPolicyData.custom_deductions) {
                const policyFormData = selectedPolicyData.custom_deductions.map(ded => ({
                    name: ded.name,
                    name_title: ded.name_title,
                    name_type: ded.name_type,
                    name_sorting_var: ded.sorting_var,
                    salary_structure: salaryData?.id || '',
                    fixed_amount: ded.fixed_amount || '',
                    percentage: ded.percentage || '',
                    percentage_of: ded.percentage_of?.map(po => ({
                        id: po.id,
                        name: po.name_title || po.name
                    })) || [],
                    updated_by: sessionStorage.getItem('emp_code'),
                }));
                setFormData(policyFormData);
                setUpdateType('policy');
            }
        }
        // Clear errors when policy changes
        setErrors({});
        setIsSubmitted(false);
        setChangeReason('');
    };

    const handleClearFormData = () => {
        // Reset to blank salary structure
        setSelectedPolicy("null");

        // Create empty form data for all available salary headings
        const emptyForm = salaryStructureHeadings
            ?.sort((a, b) => a.sorting_var - b.sorting_var)
            .map(heading => ({
                name: heading.id,
                name_title: heading.title,
                name_type: heading.salary_type,
                name_sorting_var: heading.sorting_var,
                salary_structure: salaryData?.id || '',
                fixed_amount: '',
                percentage: '',
                percentage_of: [],
                updated_by: sessionStorage.getItem('emp_code'),
            })) || [];

        setFormData(emptyForm);
        setUpdateType('new');

        // Clear all errors
        setErrors({});
        setIsSubmitted(false);
        setChangeReason('');

        // Show confirmation toast
        toast.info("Form cleared. You can now start fresh with a blank salary structure.");
    };


    const validateForm = () => {
        const newErrors = {};

        if (!wefPeriod) {
            newErrors.wef_period = "WEF Period is required";
        }

        if (!changeReason) {
            newErrors.change_reason = "Change reason is required";
        }

        if (selectedPolicy === "null" || selectedPolicy === "empty") {
            newErrors.policy = "Please select a salary structure";
        }

        // Validate each deduction entry
        formData.forEach((entry, index) => {
            if (entry.fixed_amount && (entry.percentage || entry.percentage_of?.length > 0)) {
                newErrors[`deduction_${index}`] = "Cannot have both fixed amount and percentage";
            } else if (entry.percentage && (!entry.percentage_of || entry.percentage_of.length === 0)) {
                newErrors[`deduction_${index}`] = "Related To is required when using percentage";
            }

            // Ensure at least one field is filled
            if (!entry.fixed_amount && !entry.percentage && updateType === 'new') {
                newErrors[`deduction_${index}`] = "Either fixed amount or percentage must be provided";
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmitCustomDeduction = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            const validPolicyFormat = formData
                .filter(entry =>
                    (entry.fixed_amount && parseFloat(entry.fixed_amount) > 0) ||
                    (entry.percentage && entry.percentage_of?.length > 0)
                )
                .map(entry => {
                    const baseEntry = {
                        name: entry.name, // UUID of SalaryHeading
                        sorting_var: entry.sorting_var || entry.name_sorting_var,
                        updated_by: sessionStorage.getItem('emp_code'),
                    };

                    if (entry.fixed_amount && parseFloat(entry.fixed_amount) > 0) {
                        baseEntry.fixed_amount = entry.fixed_amount;
                    } else if (entry.percentage && entry.percentage_of?.length > 0) {
                        baseEntry.percentage = entry.percentage;
                        // Convert percentage_of to array of titles
                        baseEntry.percentage_of = entry.percentage_of.map(po =>
                            po.name || po.name_title || po.label
                        ).filter(Boolean);
                    }

                    return baseEntry;
                });

            // Final payload for bulk update
            const finalPayload = {
                emp_code: code,
                effective_month: wefPeriod ? parseInt(wefPeriod.split('-')[1]) : new Date().getMonth() + 1,
                effective_year: wefPeriod ? parseInt(wefPeriod.split('-')[0]) : new Date().getFullYear(),
                // change_reason: 'Bulk salary structure update',
                change_reason: changeReason,
                updated_by: sessionStorage.getItem('emp_code'),
                deductions: validPolicyFormat,
                partial: false, // Set to true for partial update, false for complete replace
            };


            const res = await axios.put(
                `${BASE_URL}/wfm/customdeduction-bulkforsingleemployee-withhistorylog/update-delete/${code}/`,
                finalPayload
            );

            if (res.status === 200 || res.status === 201) {
                await getAllSalaryRelatedData(code);
                toast.success("Salary structure updated successfully!");
                console.log('Bulk operation summary:', res.data.summary);
                return true;
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
            return false;
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const updatedFormData = formData.map((entry, i) => {
            if (i === index) {
                const updatedEntry = { ...entry, [name]: value };

                // Clear percentage fields if fixed amount is entered
                if (name === 'fixed_amount' && value) {
                    updatedEntry.percentage = '';
                    updatedEntry.percentage_of = [];
                }
                // Clear fixed amount if percentage is entered
                else if (name === 'percentage' && value) {
                    updatedEntry.fixed_amount = '';
                }

                return updatedEntry;
            }
            return entry;
        });
        setFormData(updatedFormData);

        // Clear error for this field
        if (errors[`deduction_${index}`]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[`deduction_${index}`];
                return newErrors;
            });
        }
    };

    const handleSelectChange = (selectedOptions, index) => {
        setFormData(prev => {
            const updatedFormData = [...prev];
            updatedFormData[index] = {
                ...updatedFormData[index],
                percentage_of: selectedOptions
                    ? selectedOptions.map(option => ({
                        id: option.value,
                        name: option.label
                    }))
                    : []
            };
            return updatedFormData;
        });

        // Clear error for this field
        if (errors[`deduction_${index}`]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[`deduction_${index}`];
                return newErrors;
            });
        }
    };

    // const getRelatedToOptions = (currentIndex) => {
    //     return formData
    //         .filter((_, index) => index !== currentIndex)
    //         .filter(item => item.name_title || item.name)
    //         .map(item => ({
    //             value: item.name || item.id,
    //             label: item.name_title || salaryStructureHeadings?.find(h => h.id === item.name)?.title || 'Unknown'
    //         }));
    // };

    // Get related to options - only show items that have values (either fixed_amount or percentage)
    const getRelatedToOptions = (currentIndex) => {
        return formData
            .filter((_, index) => index !== currentIndex)
            .filter(item => (item.fixed_amount && item.fixed_amount !== '') ||
                (item.percentage && item.percentage !== ''))
            .map(item => ({
                value: item.name || item.id,
                label: item.name_title || salaryStructureHeadings?.find(h => h.id === item.name)?.title || 'Unknown'
                // value: item.name_title || item.name,
                // label: `${item.name_title || salaryStructureHeadings?.find(h => h.id === item.name)?.title || 'Unknown'} 
                //         (${item.name_type || salaryStructureHeadings?.find(h => h.id === item.name)?.salary_type || 'N/A'})`
            }));
    };

    // const removeRow = (index) => {
    //     if (formData.length > 1) {
    //         setFormData(formData.filter((_, i) => i !== index));
    //     }
    // };

    const removeRow = (index) => {
        if (formData.length > 1) {
            // Get the item being removed
            const itemToRemove = formData[index];
            const itemTitle = itemToRemove.name_title ||
                salaryStructureHeadings?.find(h => h.id === itemToRemove.name)?.title ||
                'Unknown';

            // Remove references to this item in other rows' percentage_of
            const updatedFormData = formData
                .filter((_, i) => i !== index)
                .map(entry => ({
                    ...entry,
                    percentage_of: entry.percentage_of?.filter(po =>
                        po.name !== itemTitle &&
                        po.name_title !== itemTitle
                    ) || []
                }));

            setFormData(updatedFormData);

            // Clear any errors for the removed row
            if (errors[`deduction_${index}`]) {
                setErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors[`deduction_${index}`];
                    return newErrors;
                });
            }
        }
    };

    const handleChangeReasonChange = (e) => {
        setChangeReason(e.target.value);
        if (errors.change_reason) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.change_reason;
                return newErrors;
            });
        }
    };


    return (
        <div className="">
            <hr />
            <div className="">
                {/* Policy Selection Header */}
                <div className="flex-rowalign-center justify-between">
                    <div className="flex-row justify-between">
                        <div title="Predefined Salary Structure Suggestion" className="flex-column" style={{ alignItems: 'start' }}>
                            <label htmlFor="salary_policy" className="form-labels">
                                Select Salary Structure :
                            </label>
                            <select
                                name="salary_policy"
                                value={selectedPolicy}
                                onChange={handlePolicySelect}
                                className={`form-input ${errors.policy ? 'is-invalid' : ''}`}
                                style={{ minWidth: '250px' }}
                            >
                                <option value="null">Blank Salary Structure</option>
                                <option value="current">Current Salary</option>
                                {salaryDeductionPolicies?.map((i) => (
                                    <option key={i.id} value={i.id}>{i.policy_name}</option>
                                ))}
                            </select>
                            {errors.policy && <span className="error-message">{errors.policy}</span>}
                        </div>
                        {/* <hr className="field-cont-hr" /> */}
                        <ClearCustomDeductions
                            salary_structure={salaryData.id}
                            emp_code={code}
                            deductionData={deductionData}
                            wefPeriod={wefPeriod}
                            getData={getAllSalaryRelatedData}
                        />
                    </div>

                    <div className="flex-row">
                        <div className="flex-column" style={{ flex: 2 }}>
                            <label htmlFor="change_reason" className="form-labels">
                                Change Reason<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                name="change_reason"
                                placeholder="Enter change reason"
                                value={changeReason}
                                onChange={handleChangeReasonChange}
                                className={`form-input ${errors.change_reason ? 'is-invalid' : ''}`}
                            />
                            {errors.change_reason && <div className="error-message">{errors.change_reason}</div>}
                        </div>
                        <div className="flex-row">
                            {selectedPolicy !== 'null' &&
                                <>
                                    <button
                                        title="Clear All Selections"
                                        className="model-button model-button-delete "
                                        onClick={handleClearFormData}
                                    >
                                        Clear Form
                                    </button>
                                    <hr className="field-cont-hr" />
                                </>
                            }
                            <AddSalaryHeadingModal
                                salaryStructureHeadings={salaryStructureHeadings}
                                salaryData={salaryData}
                                wefPeriod={wefPeriod}
                                formData={formData}
                                setFormData={setFormData}
                            />
                        </div>
                    </div>
                </div>

                <div className="scroll-container-table">
                    <table className="table-css " style={{ width: '100%', minWidth: '800px' }}>
                        <thead>
                            <tr className="custom-table-head-tr">
                                <th className="align-left width-5vw">Position</th>
                                <th className="align-center width-15vw">Heading</th>
                                <th className="align-center width-10vw">Type</th>
                                <th className="align-center width-10vw">Fixed Amount</th>
                                <th className="align-center width-5vw">OR</th>
                                <th className="align-center width-10vw">Percentage</th>
                                <th className="align-center width-5vw">of</th>
                                <th className="align-center width-20vw">Related To</th>
                                <th className="align-right width-10vw">Calculated Amount</th>
                                <th className="align-center width-5vw">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {formData
                                .sort((a, b) => a.name_sorting_var - b.name_sorting_var)
                                .map((entry, index) => {
                                    const { value: calculatedValue } = getCalculatedAmount(entry, formData);
                                    const headingInfo = salaryStructureHeadings?.find(h => h.id === entry.name);

                                    return (
                                        <React.Fragment key={index}>
                                            <tr className="custom-table-head-td">
                                                <td className="align-left">
                                                    {entry.name_sorting_var || index + 1}
                                                </td>
                                                <td>
                                                    <div className="flex-column">
                                                        <span className="font-weight500 text-capitalize">
                                                            {entry.name_title || headingInfo?.title || "N/A"}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td className="align-center">
                                                    <span className="text-capitalize">
                                                        {entry.name_type || headingInfo?.salary_type || "N/A"}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="flex-column">
                                                        {(entry.percentage && entry.percentage !== '') || entry.percentage_of.length > 0 ? (
                                                            <div className="align-center">-</div>
                                                        ) : (<>
                                                            <input
                                                                name="fixed_amount"
                                                                placeholder="0.00"
                                                                type="number"
                                                                min="0"
                                                                step="0.01"
                                                                onWheel={(e) => e.target.blur()}
                                                                value={entry.fixed_amount || ''}
                                                                onChange={(e) => handleInputChange(e, index)}
                                                                disabled={entry.percentage && entry.percentage !== ''}
                                                                className={`form-input-date width-full ${errors[`deduction_${index}`] ? "error" : ""}`}
                                                            />
                                                        </>)}
                                                    </div>
                                                </td>
                                                <td className="align-center">
                                                    OR
                                                </td>
                                                <td className={`align-center ${entry.percentage ? 'flex-row' : ''}`}>
                                                    {entry.fixed_amount && entry.fixed_amount !== '' ? (
                                                        <div className="align-center">-</div>
                                                    ) : (<>
                                                        <input
                                                            name="percentage"
                                                            type="number"
                                                            min="0"
                                                            step="0.01"
                                                            onWheel={(e) => e.target.blur()}
                                                            value={entry.percentage || ''}
                                                            placeholder="0.00"
                                                            onChange={(e) => handleInputChange(e, index)}
                                                            disabled={entry.fixed_amount && entry.fixed_amount !== ''}
                                                            className={`form-input-date width-full ${errors[`deduction_${index}`] ? "error" : ""}`}
                                                        />
                                                        {entry.percentage && <span>%</span>}
                                                    </>)}
                                                </td>
                                                <td className="align-center">
                                                    {(entry.percentage && entry.percentage !== '') ? 'of' : ''}
                                                </td>
                                                <td>
                                                    {entry.fixed_amount && entry.fixed_amount !== '' ? (
                                                        <div className="align-center">-</div>
                                                    ) : (
                                                        <div className="flex-column form-group-selectt">
                                                            <Select
                                                                isMulti
                                                                name="percentage_of"
                                                                value={entry.percentage_of?.map(po => ({
                                                                    value: po.id,
                                                                    label: po.name
                                                                })) || []}
                                                                onChange={(selectedOptions) => handleSelectChange(selectedOptions, index)}
                                                                options={getRelatedToOptions(index)}
                                                                isDisabled={entry.fixed_amount && entry.fixed_amount !== ''}
                                                                className={`width-full ${errors[`deduction_${index}`] ? 'is-invalid' : ''}`}
                                                                classNamePrefix="select"
                                                                placeholder="Select Related To"
                                                                closeMenuOnSelect={false}
                                                                menuPortalTarget={document.body}
                                                                menuPlacement="auto"
                                                                menuPosition="fixed"
                                                                styles={{
                                                                    control: (provided) => ({
                                                                        ...provided,
                                                                        minWidth: '14vw',
                                                                        minHeight: '40px',
                                                                        borderRadius: '5px',
                                                                        border: '1px solid #e3e3e3',
                                                                        backgroundColor: '#f7f8fa',
                                                                    }),
                                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                                </td>
                                                <td className="align-right">
                                                    <span title={getCalculatedAmount(entry, formData).explanation}>
                                                        {calculatedValue ? formatCurrencyIndian(calculatedValue.toFixed(2)) : "-"}
                                                    </span>
                                                </td>
                                                <td className="align-center">
                                                    {formData.length > 1 && (
                                                        <button
                                                            type="button"
                                                            // className="btn btn-sm btn-danger"
                                                            onClick={() => removeRow(index)}
                                                            title="Remove this row"
                                                        >
                                                            <CrosswithRedCircle />
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                            {errors[`deduction_${index}`] && (
                                                <tr>
                                                    <td colSpan="10" className="align-center error-message">
                                                        {errors[`deduction_${index}`]}
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    );
                                })}
                        </tbody>
                    </table>
                </div>

                {/* Submit Button and Error Messages */}
                <div className="button-models mt-3">
                    <button
                        type="submit"
                        className="model-button font-weight500 model-button-leave"
                        onClick={handleSubmitCustomDeduction}
                        disabled={loading}
                    >
                        {loading ? 'Submitting...' : 'Submit Salary Structure'}
                    </button>
                </div>

                {isSubmitted && Object.keys(errors).length > 0 && (
                    <div className="error-message mt-2">
                        {Object.keys(errors).length > 5 ? (
                            <h5 className="text-center">Please fill all mandatory fields correctly!</h5>
                        ) : (
                            <h6 className="text-center">
                                {Object.values(errors).join(', ')}
                            </h6>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

const AddSalaryHeadingModal = ({
    salaryStructureHeadings,
    formData,
    setFormData,
    salaryData,
    wefPeriod
}) => {
    const [show, setShow] = useState(false)
    const handleClose = () => {
        setShow(false)
    };
    const handleShow = () => {
        setShow(true)
    };
    const [selectedHeading, setSelectedHeading] = useState("");

    const availableHeadings = salaryStructureHeadings
        ?.sort((a, b) => a.sorting_var - b.sorting_var)
        .filter(
            heading => !formData.some(item => item.name === heading.id)
        ) || [];


    const handleAddHeading = (newRow) => {
        setFormData(prev => [...prev, newRow]);
    };

    const handleSubmitAdd = () => {
        if (selectedHeading) {
            const heading = salaryStructureHeadings?.find(h => h.id === selectedHeading);
            if (heading) {
                const newRow = {
                    name: heading.id,
                    name_title: heading.title,
                    name_type: heading.salary_type,
                    name_sorting_var: heading.sorting_var,
                    salary_structure: salaryData?.id || '',
                    fixed_amount: '',
                    percentage: '',
                    percentage_of: [],
                    wef_period: wefPeriod || '',
                    updated_by: sessionStorage.getItem('emp_code'),
                };
                handleAddHeading(newRow);
                setSelectedHeading("");
                handleClose();
            }
        }
    };

    return (
        <>
            <button
                type="button"
                className="model-button model-button-cancel"
                onClick={handleShow}
                style={{
                    cursor:
                        (!salaryStructureHeadings || salaryStructureHeadings.length === formData.length)
                            ? 'not-allowed'
                            : 'default'
                }}
                disabled={!salaryStructureHeadings || salaryStructureHeadings.length === formData.length}
            >
                <AddwithBlueCircle /> Salary Heading
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
                <Modal.Header closeButton>
                    <Modal.Title>Add Salary Heading</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        <div className="flex-column">
                            <label htmlFor="headingSelect" className="form-labels">
                                Select Salary Heading
                            </label>
                            <select
                                id="headingSelect"
                                value={selectedHeading}
                                onChange={(e) => setSelectedHeading(e.target.value)}
                                className="form-input"
                            >
                                <option value="">Select a heading</option>
                                {availableHeadings.map(heading => (
                                    <option key={heading.id} value={heading.id}>
                                        {heading.title}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="button-models">
                            <button className="model-button model-button-cancel" onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                className="model-button model-button-leave"
                                onClick={handleSubmitAdd}
                                disabled={!selectedHeading}
                            >
                                Add to Form
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


const AddCustomDeductions = ({
    code,
    salaryData,
    deductionData,
    salaryStructureHeadings,
    getAllSalaryRelatedData,
    wefPeriod
}) => {

    const [formData, setFormData] = useState({
        emp_code: code,
        name: "",
        salary_structure: salaryData.id,
        salary_type: "",
        percentage: '',
        percentage_of: [], // Initialize as an array for multiple selections
        fixed_amount: '',
        // sorting_var: '', // Add sorting_var

        effective_month: wefPeriod ? parseInt(wefPeriod.split('-')[1]) : new Date().getMonth() + 1,
        effective_year: wefPeriod ? parseInt(wefPeriod.split('-')[0]) : new Date().getFullYear(),
        // change_reason: 'Adding new deduction',
        change_reason: '',
        updated_by: sessionStorage.getItem('emp_code'),
    });
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const handleShow = () => setShow(true);
    const handleClose = () => {
        setFormData({
            emp_code: code,
            name: "",
            salary_structure: salaryData.id,
            salary_type: "",
            percentage: '',
            percentage_of: [], // Initialize as an array for multiple selections
            fixed_amount: '',
            // sorting_var: '', // Add sorting_var

            effective_month: wefPeriod ? parseInt(wefPeriod.split('-')[1]) : new Date().getMonth() + 1,
            effective_year: wefPeriod ? parseInt(wefPeriod.split('-')[0]) : new Date().getFullYear(),
            // change_reason: 'Adding new deduction',
            change_reason: '',
            updated_by: sessionStorage.getItem('emp_code'),
        })
        setShow(false)
    };


    const validateForm = () => {
        const newErrors = {};

        const isSalaryHeadingSelected = !!formData.name;
        const hasFixedAmount = formData.fixed_amount !== '';
        const hasPercentage = formData.percentage !== '' && formData.percentage_of.length > 0;

        // Validate WEF Period
        if (!wefPeriod) {
            newErrors.wef_period = 'WEF Period is required!';
        }

        // Validate change reason
        if (!formData.change_reason) {
            newErrors.change_reason = 'Change reason is required!';
        }

        // Validate Salary Heading
        if (!isSalaryHeadingSelected) {
            newErrors.name = 'Salary Heading is required!';
        }

        // Validation for Fixed Amount or Percentage
        if (!hasFixedAmount && !hasPercentage) {
            newErrors.mixed = 'Either Fixed Amount or Percentage with Related To is required!';
        }

        // Additional validation for Fixed Amount if it's entered
        if (hasFixedAmount && !formData.fixed_amount) {
            newErrors.fixed_amount = 'Fixed Amount is required!';
        }

        // Additional validation for Percentage if it's entered
        if (hasPercentage) {
            if (!formData.percentage) {
                newErrors.percentage = 'Percentage of Amount is required!';
            }
            if (formData.percentage_of.length === 0) {
                newErrors.percentage_of = 'Related To is required!';
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        setInputState(prev => ({
            ...prev,
            [name]: value.trim() ? "green" : "",
        }));

        if (errors[name]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }

        if (errors.mixed && (name === 'fixed_amount' || name === 'percentage' || name === 'percentage_of')) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.mixed;
                return newErrors;
            });
        }
    };

    const handleHeadingChange = (e) => {
        const { value } = e.target;
        const selectedHeading = salaryStructureHeadings.find(heading => heading.id === value);

        setFormData({
            ...formData,
            name: selectedHeading ? selectedHeading.id : "",
            salary_type: selectedHeading ? selectedHeading.salary_type : "",
        });

        setInputState({
            ...inputState,
            name: value.trim() ? "green" : "",
        });

        if (errors.name) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.name;
                return newErrors;
            });
        }
    };
    const handleSelectChange = (selectedOptions) => {
        setFormData({
            ...formData,
            percentage_of: selectedOptions ? selectedOptions.map(option => option.value) : [],
        });

        if (errors.percentage_of) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.percentage_of;
                return newErrors;
            });
        }

        if (errors.mixed && selectedOptions && selectedOptions.length > 0) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.mixed;
                return newErrors;
            });
        }
    };
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        // Updated payload format for new API
        const formattedFormData = {
            emp_code: formData.emp_code,
            name: formData.name, // UUID of SalaryHeading
            salary_structure: formData.salary_structure,
            effective_month: formData.effective_month,
            effective_year: formData.effective_year,
            change_reason: formData.change_reason,
            updated_by: formData.updated_by,
            // sorting_var: formData.sorting_var || null, // Add sorting_var
        };

        if (formData.fixed_amount && formData.fixed_amount !== '') {
            formattedFormData.fixed_amount = formData.fixed_amount;
        } else if (formData.percentage && formData.percentage !== '') {
            formattedFormData.percentage = formData.percentage;

            // For percentage_of, we need to send titles (not IDs)
            if (formData.percentage_of && formData.percentage_of.length > 0) {
                formattedFormData.percentage_of = formData.percentage_of.map(title => {
                    // Find the title from the selected options
                    const option = salaryStructureHeadings.find(
                        heading => heading.title === title || heading.id === title
                    );
                    return option ? option.title : title;
                });
            }
        }

        try {
            const res = await axios.post(`${BASE_URL}/wfm/customdeduction-withhistorylog/add/`, formattedFormData);

            if (res.status === 200 || res.status === 201) {
                toast.success("Deduction added successfully!");
                await getAllSalaryRelatedData(code);
                handleClose();
            } else {
                console.log('Error Check in AddCustomDeductions - customdeduction-withhistorylog/add/');
            }
        } catch (err) {
            // toast.error("An error occurred while adding the deduction");
            handleAllError(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const deductionIds = deductionData.map(item => item.name);
    const deductionTitles = deductionData.map(item => item.name_title);
    const relatedToOptions = deductionData
        .filter(item => item.name_title &&
            (item.fixed_amount || (item.percentage && item.percentage_of && item.percentage_of.length > 0))
        )
        .sort((a, b) => a.sorting_var - b.sorting_var)
        .map(item => ({
            value: item.name_title,
            label: item.name_title,
            // label: `${item.name_title} (${item.name_type})`
        }));

    return (
        <div>
            <button title='Add Deduction' className="model-button model-button-leave" onClick={handleShow}>
                Add
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="five-sixth-modal">
                <Modal.Header closeButton>
                    <div
                        style={{ minWidth: '97%' }}
                        className="flex-row justify-between"
                    >
                        <Modal.Title>Add Custom Deduction</Modal.Title>
                        <div className="">
                            <label className="form-labels font-weight500 font-size-subheading">
                                WEF Period :
                            </label>
                            {" "}
                            <span style={{ padding: '5px 10px', backgroundColor: '#f7f8fa' }} className="form-labels font-size-subheading">
                                {formatDate(wefPeriod, true).MonthYear}
                            </span>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
                    <form className="register-form">
                        <div className="form-flex-wrap">



                            <div title="Salary Structure Heading" className="flex-column">
                                <label htmlFor="name" className="form-labels font-weight500 font-size-subheading">
                                    Salary Structure Heading<span className="required">*</span>
                                </label>
                                <select
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleHeadingChange}
                                    className={`form-input ${errors.name ? "error" : inputState.name ? "success" : ""}`}
                                >
                                    <option value="">Select Salary Heading</option>
                                    {salaryStructureHeadings
                                        ?.sort((a, b) => a.sorting_var - b.sorting_var)
                                        ?.filter(i => !deductionIds.includes(i.id))
                                        .map((i) => (
                                            <option key={i.id} value={i.id}>
                                                {i.title} ({i.salary_type})
                                            </option>
                                        ))}
                                </select>
                                <div>
                                    {errors.name && <span className="error-message font-size-text">{errors.name}</span>}
                                </div>
                            </div>

                            {formData.percentage || formData.percentage_of.length > 0 ? null : (
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Fixed Amount<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="fixed_amount"
                                        placeholder="Fixed Amount"
                                        min={0}
                                        value={formData.fixed_amount}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.fixed_amount ? 'is-invalid' : ''}`}
                                    />
                                    {errors.fixed_amount && <div className="error-message font-size-text">{errors.fixed_amount}</div>}
                                </div>
                            )}
                            {formData.fixed_amount ? null : (
                                <>
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Percentage of Amount<span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            name="percentage"
                                            placeholder="Percentage of Amount"
                                            min={0}
                                            step={0.01}
                                            value={formData.percentage}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.percentage ? 'is-invalid' : ''}`}
                                        />
                                        {errors.percentage && <div className="error-message font-size-text">{errors.percentage}</div>}
                                    </div>

                                    <div title="Related To" className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Related To<span className="required">*</span>
                                        </label>
                                        <Select
                                            isMulti
                                            name="percentage_of"
                                            value={relatedToOptions.filter(option => formData.percentage_of?.includes(option.value))}
                                            // onChange={(selectedOptions) => handleSelectChange(selectedOptions)}
                                            onChange={handleSelectChange}
                                            options={relatedToOptions}
                                            className={`${errors.percentage_of ? 'is-invalid' : ''}`}
                                            classNamePrefix="select"
                                            placeholder="Select Related To"
                                            isDisabled={!!formData.fixed_amount} // Disable if fixed amount is provided
                                            menuPortalTarget={document.body}
                                            menuPlacement="auto"
                                            menuPosition="fixed"
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    minWidth: '10vw',
                                                    width: '33vw',
                                                    minHeight: '50px',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e3e3e3',
                                                    margin: '10px 0px 10px 0px',
                                                    color: '#4a4a4a',
                                                    backgroundColor: '#f7f8fa',
                                                    padding: '0px 10px',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    width: '33vw',
                                                    borderRadius: '10px',
                                                    marginTop: '0',
                                                }),
                                                // singleValue: (provided) => ({
                                                //     ...provided,
                                                //     color: '#4a4a4a',
                                                // }),
                                                // input: (provided) => ({
                                                //     ...provided,
                                                //     color: '#4a4a4a',
                                                // }),
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),

                                            }}
                                        />
                                        {errors.percentage_of && <div className="error-message font-size-text">{errors.percentage_of}</div>}
                                    </div>
                                </>
                            )}
                            {/* Change Reason Input */}
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Reason<span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="change_reason"
                                    placeholder="Enter change reason"
                                    value={formData.change_reason}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.change_reason ? 'is-invalid' : ''}`}
                                />
                                {errors.change_reason && <div className="error-message font-size-text">{errors.change_reason}</div>}
                            </div>
                        </div>
                        {errors.mixed && <div className="error-message font-size-text">{errors.mixed}</div>}
                        <div className="button-models">
                            <button className="model-button-cancel model-button font-weight500" type="button" onClick={handleClose}>
                                Cancel
                            </button>
                            <button className="model-button font-weight500 model-button-leave font-size-heading" onClick={handleFormSubmit} disabled={loading}>
                                {loading ? 'Adding...' : 'Add'}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    );
};

const UpdateCustomDeductions = ({ i, code, deductionData, salaryStructureHeadings, getAllSalaryRelatedData, wefPeriod }) => {

    const [formData, setFormData] = useState({
        name: i.id,
        salary_structure: i.salary_structure || "",
        salary_type: i.salary_type,
        percentage: i.percentage || '',
        percentage_of: i.percentage_of || [],
        fixed_amount: i.fixed_amount || '',
        // sorting_var: i.sorting_var || '',

        effective_month: wefPeriod ? parseInt(wefPeriod.split('-')[1]) : new Date().getMonth() + 1,
        effective_year: wefPeriod ? parseInt(wefPeriod.split('-')[0]) : new Date().getFullYear(),
        // change_reason: 'Updating deduction',
        change_reason: '',
        updated_by: sessionStorage.getItem('emp_code'),
    })

    const [show, setShow] = useState(false);
    const [selectedPercentageOf, setSelectedPercentageOf] = useState([]);

    const handleShow = () => {

        // Transform percentage_of data to match select options
        const percentageOfOptions = Array.isArray(i.percentage_of)
            ? i.percentage_of.map(item => ({
                value: item.name || item.name_title,
                label: item.name || item.name_title
            }))
            : [];

        // setFormData({
        //     ...i,
        //     name: i.name, // SalaryHeading UUID
        //     sorting_var: i.sorting_var || '',
        //     percentage_of: i.percentage_of || []
        // });

        setFormData({
            ...i,
            name: i.name || i.id,
            salary_structure: i.salary_structure || "",
            salary_type: i.salary_type || "",
            percentage: i.percentage || '',
            percentage_of: i.percentage_of || [],
            fixed_amount: i.fixed_amount || '',
            sorting_var: i.sorting_var || i.name_sorting_var || '',
            effective_month: wefPeriod ? parseInt(wefPeriod.split('-')[1]) : new Date().getMonth() + 1,
            effective_year: wefPeriod ? parseInt(wefPeriod.split('-')[0]) : new Date().getFullYear(),
            change_reason: '',
            updated_by: sessionStorage.getItem('emp_code'),
        });

        setSelectedPercentageOf(percentageOfOptions);
        setErrors({});
        setInputState({});
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
    }

    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});


    const validateForm = () => {
        const newErrors = {};
        const isSalaryHeadingSelected = !!formData.name;
        const hasFixedAmount = formData.fixed_amount !== '';
        const hasPercentage = formData.percentage !== '' && formData.percentage_of.length > 0;

        // Validate WEF Period
        if (!wefPeriod) {
            newErrors.wef_period = 'WEF Period is required!';
        }

        // Validate change reason
        if (!formData.change_reason) {
            newErrors.change_reason = 'Change reason is required!';
        }

        // Validate Salary Heading
        if (!isSalaryHeadingSelected) {
            newErrors.name = 'Salary Heading is required!';
        }

        // Validation for Fixed Amount or Percentage
        if (!hasFixedAmount && !hasPercentage) {
            newErrors.mixed = 'Either Fixed Amount or Percentage with Related To is required!';
        }

        // Additional validation for Fixed Amount if it's entered
        if (hasFixedAmount && !formData.fixed_amount) {
            newErrors.fixed_amount = 'Fixed Amount is required!';
        }

        // Additional validation for Percentage if it's entered
        if (hasPercentage) {
            if (!formData.percentage) {
                newErrors.percentage = 'Percentage of Amount is required!';
            }
            if (formData.percentage_of.length === 0) {
                newErrors.percentage_of = 'Related To is required!';
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        if (errors[name]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }

        if (errors.mixed && (name === 'fixed_amount' || name === 'percentage' || name === 'percentage_of')) {
            if ((name === 'fixed_amount' && value) ||
                (name === 'percentage' && value && formData.percentage_of.length > 0)) {
                setErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors.mixed;
                    return newErrors;
                });
            }
        }
    };

    const handleSelectChange = (selectedOptions) => {
        setSelectedPercentageOf(selectedOptions);
        // setFormData({
        //     ...formData,
        //     percentage_of: selectedOptions ? selectedOptions.map(option => ({ value: option.value, label: option.label })) : [],
        // });

        const percentage_of = selectedOptions ? selectedOptions.map(option => ({
            value: option.value,
            name: option.label,
            name_title: option.value
        })) : [];

        setFormData(prev => ({
            ...prev,
            percentage_of: percentage_of,
        }));

        if (errors.percentage_of) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.percentage_of;
                return newErrors;
            });
        }

        if (errors.mixed && selectedOptions && selectedOptions.length > 0 && formData.percentage) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.mixed;
                return newErrors;
            });
        }
    };
    // ?  ************** Validation End **************  ! //

    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true); //loading logic
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const updatedFormData = {
                effective_month: formData.effective_month,
                effective_year: formData.effective_year,
                change_reason: formData.change_reason,
                updated_by: formData.updated_by,
            };

            // Add sorting_var if provided
            if (formData.sorting_var) {
                updatedFormData.sorting_var = parseInt(formData.sorting_var);
            }

            // Add either fixed_amount or percentage with percentage_of
            if (formData.fixed_amount && formData.fixed_amount !== '') {
                updatedFormData.fixed_amount = parseFloat(formData.fixed_amount);
            } else if (formData.percentage && formData.percentage !== '') {
                updatedFormData.percentage = parseFloat(formData.percentage);

                // percentage_of should be array of deduction titles
                const percentageOfTitles = formData.percentage_of
                    .map(po => po.name || po.name_title)
                    .filter(Boolean);

                if (percentageOfTitles.length > 0) {
                    updatedFormData.percentage_of = percentageOfTitles;
                }
            }

            // Note: The URL uses the custom_deduction ID, not the deduction ID
            let res = await axios.put(`${BASE_URL}/wfm/customdeduction-withhistorylog/update-delete/${i.id}/`, updatedFormData);

            if (res.status === 200 || res.status === 201) {
                toast.success("Updated Deduction Successfully!");
                await getAllSalaryRelatedData(code);
                handleClose();
            }
            else {
                console.log('Error Check in DeleteCustomDeductions - customdeduction-withhistorylog');
            }
        } catch (err) {
            handleAllError(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const deductionIds = deductionData.map(item => item.name);
    const deductionTitles = deductionData.map(item => item.name_title);
    const relatedToOptions = deductionData
        .filter(item =>
            item.name_title &&
            item.id !== i.id &&
            (item.fixed_amount || (item.percentage && item.percentage_of && item.percentage_of.length > 0))
        )
        .sort((a, b) => a.sorting_var - b.sorting_var)
        .map(item => ({
            value: item.name_title,
            label: item.name_title,
            // label: `${item.name_title} (${item.name_type})`
        }));

    const headingTitle = salaryStructureHeadings?.find(t => t.id === formData.name)?.title ||
        i.name_title || 'Unknown';

    return (
        <div>
            <>
                <button title='Update Deduction' className='model-edit-button-ml' onClick={handleShow}>
                    <UpdatePencil />
                </button>
                <Modal show={show} onHide={handleClose} dialogClassName="five-sixth-modal">
                    <Modal.Header closeButton>
                        <div
                            style={{ minWidth: '97%' }}
                            className="flex-row justify-between"
                        >
                            <Modal.Title>Update Deduction of : "{salaryStructureHeadings?.find(t => t.id === formData.name)?.title} ({salaryStructureHeadings?.find(t => t.id === formData.name)?.salary_type})"</Modal.Title>
                            <div className="">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    WEF Period :
                                </label>
                                {" "}
                                <span style={{ padding: '5px 10px', backgroundColor: '#f7f8fa' }} className="form-labels font-size-subheading">
                                    {formatDate(wefPeriod, true).MonthYear}
                                </span>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <form className="register-form">

                            <div className="form-flex-wrap">



                                {/* <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Sorting Order
                                    </label>
                                    <input
                                        type="number"
                                        name="sorting_var"
                                        placeholder="Sorting Order"
                                        min="1"
                                        value={formData.sorting_var}
                                        onChange={handleInputChange}
                                        className={`form-input`}
                                    />
                                </div> */}

                                {formData.percentage || formData.percentage_of.length > 0 ? "" :
                                    <div className="flex-column">
                                        <label className="form-labels  font-weight500 font-size-subheading">Fixed Amount<span className="required">*</span></label>
                                        <input
                                            type="number"
                                            name="fixed_amount"
                                            placeholder="Fixed Amount"
                                            min={0}
                                            value={formData.fixed_amount}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.fixed_amount ? 'is-invalid' : ''}`}
                                        />
                                        {errors.fixed_amount && <div className="error-message font-size-text">{errors.fixed_amount}</div>}
                                    </div>
                                }
                                {formData.fixed_amount ? "" :
                                    <>
                                        <div className="flex-column">
                                            <label className="form-labels  font-weight500 font-size-subheading">Percentage of Amount<span className="required">*</span></label>
                                            <input
                                                type="number"
                                                name="percentage"
                                                placeholder="Percentage of Amount"
                                                min={0}
                                                value={formData.percentage}
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.percentage ? 'is-invalid' : ''}`}
                                            />
                                            {errors.percentage && <div className="error-message font-size-text">{errors.percentage}</div>}
                                        </div>
                                        <div title="Related To" className="flex-column ">
                                            <label className="form-labels  font-weight500 font-size-subheading">Related To<span className="required">*</span></label>
                                            <Select
                                                isMulti
                                                name="percentage_of"
                                                value={selectedPercentageOf}
                                                onChange={handleSelectChange}
                                                options={relatedToOptions}
                                                className={`${errors.percentage_of ? 'is-invalid' : ''}`}
                                                classNamePrefix="select"
                                                placeholder="Select Related To"
                                                isDisabled={!!formData.fixed_amount}
                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        minWidth: '10vw',
                                                        width: '33vw',
                                                        minHeight: '50px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #e3e3e3',
                                                        margin: '10px 0px 10px 0px',
                                                        color: '#4a4a4a',
                                                        backgroundColor: '#f7f8fa',
                                                        padding: '0px 10px',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        width: '33vw',
                                                        borderRadius: '10px',
                                                        marginTop: '0',
                                                    }),
                                                    // singleValue: (provided) => ({
                                                    //     ...provided,
                                                    //     color: '#4a4a4a',
                                                    // }),
                                                    // input: (provided) => ({
                                                    //     ...provided,
                                                    //     color: '#4a4a4a',
                                                    // }),
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                            />
                                            {errors.percentage_of && <div className="error-message font-size-text">{errors.percentage_of}</div>}
                                        </div>
                                    </>
                                }
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Change Reason<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="change_reason"
                                        placeholder="Enter change reason"
                                        value={formData.change_reason}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.change_reason ? 'is-invalid' : ''}`}
                                    />
                                    {errors.change_reason && <div className="error-message font-size-text">{errors.change_reason}</div>}
                                </div>
                            </div>
                        </form>
                        {errors.mixed && <div className="error-message font-size-text">{errors.mixed}</div>}
                        <div className="button-models">
                            <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                                Cancel
                            </button>
                            <button className="model-button  font-weight500  model-button-leave font-size-heading" onClick={handleFormSubmit} disabled={loading}>
                                {loading ? 'Updating...' : 'Update'}
                            </button>
                        </div>

                    </Modal.Body>
                </Modal>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </>

        </div>
    )

}

const DeleteCustomDeductions = ({ i, code, deductionData, salaryStructureHeadings, getAllSalaryRelatedData, wefPeriod }) => {

    const [show, setShow] = useState(false);
    const [errors, setErrors] = useState({});

    const handleShow = () => {
        // const transformedData = {
        //     ...i,
        //     percentage_of: Array.isArray(i.percentage_of) ? i.percentage_of.map(item => ({
        //         value: item.id || item.value,
        //         label: item.name || item.label,
        //     })) : [],
        // };
        // setFormData(transformedData);
        setFormData({
            effective_month: wefPeriod ? parseInt(wefPeriod.split('-')[1]) : new Date().getMonth() + 1,
            effective_year: wefPeriod ? parseInt(wefPeriod.split('-')[0]) : new Date().getFullYear(),
            change_reason: '',
            updated_by: sessionStorage.getItem('emp_code'),
        });
        setErrors({});
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
    }

    const [formData1, setFormData1] = useState({
        name: i.id,
        salary_structure: "",
        salary_type: i.salary_type,
        percentage: '',
        percentage_of: [],
        fixed_amount: '',
        wef_date: '',
    })

    const [formData, setFormData] = useState({
        effective_month: wefPeriod ? parseInt(wefPeriod.split('-')[1]) : new Date().getMonth() + 1,
        effective_year: wefPeriod ? parseInt(wefPeriod.split('-')[0]) : new Date().getFullYear(),
        change_reason: '',
        updated_by: sessionStorage.getItem('emp_code'),
    })

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (errors[name]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };


    const validateForm = () => {
        const newErrors = {};
        // Validate WEF Period
        if (!wefPeriod) {
            newErrors.wef_period = 'WEF Period is required!';
        }

        // Validate change reason
        if (!formData.change_reason) {
            newErrors.change_reason = 'Change reason is required!';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true); //loading logic
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const payload = {
                effective_month: formData.effective_month,
                effective_year: formData.effective_year,
                change_reason: formData.change_reason,
                updated_by: formData.updated_by,
            };

            let res = await axios.delete(
                `${BASE_URL}/wfm/customdeduction-withhistorylog/update-delete/${i.id}/`,
                { data: payload }
            );

            if (res.status === 200 || res.status === 201) {
                toast.success("Deleted Deduction Successfully");
                await getAllSalaryRelatedData(code);
                handleClose();
            }
            else {
                console.log('Error Check in DeleteCustomDeductions - customdeduction-withhistorylog');
            }
        } catch (err) {
            //toast Logic
            handleAllError(err);
        } finally {
            setLoading(false)
            toast.dismiss(loadingToastId);
        }

    };

    return (
        <div>
            <button title='Delete Deduction' className='model-delete-button' onClick={handleShow}>
                <DeleteDustbin />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="half-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Deduction: "{i.name_title} ({i.name_type})":</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="register-form">
                        {/* <div className="">
                            {formData?.percentage || formData?.percentage_of?.length > 0 ? "" :
                                <div className="flex-column">
                                    <label className="form-labels  font-weight500 font-size-subheading">Amount :</label>
                                    <div className='form-labels  justify-center'>
                                        {formData?.fixed_amount}
                                    </div>
                                </div>
                            }
                            {formData.fixed_amount ? "" :
                                <>
                                    <div className="flex-column">
                                        <label className="form-labels  font-weight500 font-size-subheading">Percentage:</label>

                                        <div className='form-labels  justify-center'>
                                            {formData?.percentage}   %
                                        </div>
                                    </div>
                                    <div title="Related To" className="flex-column ">
                                        <label className="form-labels  font-weight500 font-size-subheading">Related To :</label>
                                        <ul>
                                            {formData?.percentage_of ?
                                                formData?.percentage_of.map((item, index) => {

                                                    return (
                                                        <li key={index}>
                                                            {item?.label}
                                                        </li>)
                                                }) :
                                                null
                                            }
                                        </ul>
                                    </div>
                                </>
                            }
                        </div> */}

                        {/* Current Deduction Details */}
                        <div className="flex-row justify-between">

                            <div>
                                <div className="form-flex-wraap">

                                    <div className="flex-row">
                                        <label className="form-labels font-weight500">
                                            {i.fixed_amount ? 'Fixed Amount:' : 'Percentage:'}
                                        </label>
                                        <div className="" style={{ padding: '5px 10px', backgroundColor: '#f7f8fa' }}>
                                            {i.fixed_amount ? formatCurrencyIndian(i.fixed_amount) : `${i.percentage}%`}
                                        </div>
                                    </div>
                                </div>

                                {i.percentage_of && i.percentage_of.length > 0 && (
                                    <div className="flex-column mt-2">
                                        <label className="form-labels font-weight500">Related To:</label>
                                        <div className="" style={{ padding: '5px 10px' }}>
                                            <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                                {i.percentage_of.map((item, index) => (
                                                    <li key={index}>{item.name || item.name_title}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="align-start">
                                <div className="flex-column ">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        With Effect From Period :
                                    </label>
                                    {" "}
                                    <span style={{ padding: '5px 10px', backgroundColor: '#f7f8fa' }} className="form-labels font-size-subheading">
                                        {formatDate(wefPeriod, true).MonthYear}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="flex-column mb-3">
                            <label className="form-labels font-weight500 font-size-subheading">
                                Reason for Deletion<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                name="change_reason"
                                placeholder="Enter reason for deletion"
                                value={formData.change_reason}
                                onChange={handleInputChange}
                                className={`form-input ${errors.change_reason ? 'is-invalid' : ''}`}
                            />
                            {errors.change_reason && <div className="error-message font-size-text">{errors.change_reason}</div>}
                        </div>
                        <hr />
                        <div className="alert alert-danger">
                            Are you sure you want to delete the salary component <strong>"{i.name_title} ({i.name_type})"</strong>?<br />
                        </div>

                    </form>
                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="model-button  font-weight500  model-button-delete font-size-heading" onClick={handleFormSubmit} disabled={loading}>
                            {loading ? 'Deleting...' : 'Delete'}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    )
}

const ClearCustomDeductions = ({ salary_structure, emp_code, getData, deductionData, wefPeriod, sortingVarBY, roundOffAmount }) => {
    const [show, setShow] = useState(false);
    const [changeReason, setChangeReason] = useState(''); // Clearing all deductions
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setShow(false);
        setChangeReason('');
        setErrors({});
    };

    const handleShow = () => {
        setChangeReason('');
        setErrors({});
        setShow(true);
    };

    const validateForm = () => {
        const newErrors = {};

        if (!wefPeriod) {
            newErrors.change_reason = "WEF Period is required";
        }

        if (!changeReason) {
            newErrors.change_reason = "Change reason is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        // needs chanegs based on new api 
        const payload = {
            effective_month: wefPeriod ? parseInt(wefPeriod.split('-')[1]) : new Date().getMonth() + 1,
            effective_year: wefPeriod ? parseInt(wefPeriod.split('-')[0]) : new Date().getFullYear(),
            change_reason: changeReason,
            updated_by: sessionStorage.getItem('emp_code'),
        };

        try {
            let res = await axios.delete(
                `${BASE_URL}/wfm/customdeduction-bulkforsingleemployee-withhistorylog/update-delete/${emp_code}/`,
                // `${BASE_URL}/wfm/customdeduction-forsingleemployee-withhistorylog/bulkdelete/${salary_structure}/`,
                { data: payload }
            );

            if (res.status === 200) {
                await getData(emp_code);
                setShow(false);
                toast.success("Salary Structure Cleared successfully");
                // console.log('Clear operation log ID:', res.data.log_id);
            } else {
                console.log('Error Check in ClearCustomDeductions - customdeduction-bulkforsingleemployee-withhistorylog/update-delete/');
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Clear Complete Salary Structure"
                className="model-button model-button-delete "
                onClick={handleShow}
            >
                <DeleteDustbin /> Clear Structure
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="five-sixth-modal"
            >
                <Modal.Header closeButton>
                    <div
                        style={{ minWidth: '97%' }}
                        className="flex-row justify-between"
                    >
                        <Modal.Title>Clear Salary Breakup of "{emp_code}"</Modal.Title>
                        <div className="">
                            <label className="form-labels font-weight500 font-size-subheading">
                                WEF Period :
                            </label>
                            {" "}
                            <span style={{ padding: '5px 10px', backgroundColor: '#f7f8fa' }} className="form-labels font-size-subheading">
                                {formatDate(wefPeriod, true).MonthYear}
                            </span>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        {/* <div className="form-flex-wrap"> */}
                        <div className="flex-row justify-evenly">
                            <div className="flex-column">
                                <label className="form-labels font-weight500">
                                    Change Reason for Clearing<span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="change_reason"
                                    placeholder="Enter reason for clearing salary structure"
                                    value={changeReason}
                                    onChange={(e) => {
                                        setChangeReason(e.target.value);
                                        if (errors.change_reason) {
                                            setErrors(prev => ({ ...prev, change_reason: undefined }));
                                        }
                                    }}
                                    className={`form-input ${errors.change_reason ? 'is-invalid' : ''}`}
                                />
                                {errors.change_reason && <div className="error-message">{errors.change_reason}</div>}
                            </div>


                            <div className="button-models">
                                <button
                                    className="model-button font-weight500 model-button-cancel "
                                    onClick={handleClose}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleFormSubmitDelete}
                                    className="model-button font-weight500 model-button-delete"
                                    disabled={loading}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                        <hr />
                        <div className="alert alert-danger">
                            Are you sure you want to delete/clear the complete salary structure of the employee <strong>"{emp_code}"</strong>?<br />
                        </div>

                        <hr />
                        <table className="table-css">
                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="align-left width-5vw">Position</th>
                                    <th className="align-left width-5vw">Heading</th>
                                    <th className="align-center width-5vw">Type</th>
                                    <th className="align-right width-5vw">Amount</th>
                                    <th className="align-center" style={{ width: '0.5vw' }}>OR</th>
                                    <th className="align-center width-5vw">Percentage</th>
                                    <th className="align-center width-5vw text-left">Related To</th>
                                    <th className="align-right width-5vw">Actual Amount</th>

                                </tr>
                            </thead>
                            {deductionData.length > 0 ? (
                                <tbody>
                                    {deductionData
                                        // .sort((a, b) =>
                                        //     sortingVarBY
                                        //         ? a.name_sorting_var - b.name_sorting_var
                                        //         : a.sorting_var - b.sorting_var
                                        // )
                                        .map((entry, index) => (
                                            <tr className="custom-table-head-td" key={index}>
                                                <td className="align-left">{sortingVarBY ? entry.name_sorting_var : (entry.sorting_var || index + 1)}</td>
                                                <td className="align-left">{entry.name_title}</td>
                                                <td className="align-center text-capitalize">{entry.name_type}</td>

                                                <td className="align-right">{entry.fixed_amount || '-'}</td>
                                                <td className="align-center">
                                                    <div style={{ width: '1vw' }} className="align-center width-5vw ">OR</div>
                                                    {/* <hr className="field-cont-hr" /> */}
                                                </td>
                                                <td className="align-center">
                                                    {entry.percentage ?
                                                        `${parseFloat(entry.percentage) % 1 === 0 ?
                                                            parseFloat(entry.percentage).toFixed(0)
                                                            : parseFloat(entry.percentage).toFixed(2)}%`
                                                        : '-'}
                                                </td>

                                                <td className="align-leftt width-10vw">
                                                    {entry.percentage_of.length === 0 ?
                                                        <div className="align-center">-</div> :
                                                        // entry.percentage_of?.join(", ") || '-'
                                                        <ul style={{ paddingLeft: '0' }}>
                                                            {entry.percentage_of.map((data, index) => (
                                                                <li key={index}>
                                                                    <span className="text-capitalize">
                                                                        {data.name}
                                                                    </span>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    }
                                                </td>
                                                <td className="align-right" style={{ cursor: 'help' }} title={`Calculations:\n${getCalculatedAmount(entry, deductionData).explanation}`}>
                                                    {roundOffAmount ? formatRoundoffComplete(getCalculatedAmount(entry, deductionData).value || 0) : getCalculatedAmount(entry, deductionData).value}
                                                </td>


                                            </tr>
                                        ))}
                                </tbody>
                            ) : (
                                <tbody>
                                    No Data
                                </tbody>
                            )}
                        </table>

                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};


// ----------------------------------------------------------------------------------------------------------------

const AddSalaryStructurePolicyFormat = ({ getSalaryStructureFormat }) => {
    const [show, setShow] = useState(false);
    const [showloading, setShowLoading] = useState(false);
    const [formData, setFormData] = useState({
        policy_name: "",
        sub_company: sessionStorage.getItem('company_id'),
        salaryPolicyDeductionsFormat: [],
        updated_by: sessionStorage.getItem('emp_code'),
    });
    const [addMode, setAddMode] = useState('bulk'); // 'bulk' or 'single'

    const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();
    const [loading, setLoading] = useState(false);

    const [isSubmitted, setIsSubmitted] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const [salaryDeductionPolicies, setSalaryDeductionPolicy] = useState([]);
    const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);

    const handleClose = () => setShow(false);
    const handleShow = async () => {
        setShowLoading(true);
        await getAllSalaryRelatedData();
        setShowLoading(false);
        setShow(true);
    };

    const [buffer, setBuffering] = useState(false); //buffering logic
    const getAllSalaryRelatedData = async (emp_code) => {
        setBuffering(true); // Start Buffering
        try {
            const policies = await axios.get(`${BASE_URL}/wfm/salarypolicybysubcompany/${sessionStorage.getItem("company_id")}/`);
            setSalaryDeductionPolicy(policies.data);

            const headings = await axios.get(`${BASE_URL}/wfm/salaryHeadingbysubcompany/${sessionStorage.getItem("company_id")}/`);

            if (Array.isArray(headings.data)) {
                setSalaryStructureHeadings(headings.data);

                const salaryPolicyDeductionsFormat = headings.data.map(item => ({
                    name: item.id,
                    sorting_var: item.sorting_var,
                    percentage: '',
                    percentage_of: [],
                    fixed_amount: '',
                    useFixedAmount: false,
                    usePercentage: false
                }));

                setFormData(prev => ({
                    ...prev,
                    salaryPolicyDeductionsFormat
                }));
            } else {
                console.error("Error: Expected a list of Salary Headings");
            }
        } catch (err) {
            handleAllError(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    const inputRefs = useRef([]);
    const [focusedInput, setFocusedInput] = useState(null);
    const [prevSortingVars, setPrevSortingVars] = useState([]);

    useEffect(() => {
        inputRefs.current = inputRefs.current.slice(0, formData.salaryPolicyDeductionsFormat.length);
        setPrevSortingVars(formData.salaryPolicyDeductionsFormat.map(item => item.sorting_var));
    }, [formData.salaryPolicyDeductionsFormat]);

    const handleFocus = (index) => {
        const input = inputRefs.current[index];
        if (input) {
            setFocusedInput({
                sorting_var: formData.salaryPolicyDeductionsFormat[index].sorting_var,
                cursorPos: input.selectionStart
            });
        }
    };

    // console.log("focusedInput", focusedInput)

    useEffect(() => {
        if (!focusedInput) return;

        const newIndex = formData.salaryPolicyDeductionsFormat.findIndex(
            item => item.sorting_var === focusedInput.sorting_var
        );

        if (newIndex !== -1 && inputRefs.current[newIndex]) {
            const input = inputRefs.current[newIndex];
            input.focus();

            // Only set cursor position if we have a valid position
            if (focusedInput.cursorPos !== null && focusedInput.cursorPos !== undefined) {
                input.setSelectionRange(
                    focusedInput.cursorPos,
                    focusedInput.cursorPos
                );
            }
        }
    }, [formData.salaryPolicyDeductionsFormat, focusedInput]);



    const handlePositionChange = (e, index) => {
        const newPosition = parseInt(e.target.value);
        const oldPosition = parseInt(formData.salaryPolicyDeductionsFormat[index].sorting_var);

        if (newPosition === oldPosition) return;

        setFormData(prev => {
            const updatedFormat = [...prev.salaryPolicyDeductionsFormat];

            // First update the current item's position
            updatedFormat[index] = {
                ...updatedFormat[index],
                sorting_var: newPosition.toString() // Keep as string for consistency
            };

            // Create a map of current positions
            const positionMap = {};
            updatedFormat.forEach((item, i) => {
                positionMap[i] = parseInt(item.sorting_var);
            });

            if (newPosition < oldPosition) {
                // Moving to a lower position (e.g., from 8 to 2)
                // Increment positions that are >= newPosition and < oldPosition
                updatedFormat.forEach((item, i) => {
                    const currentPos = parseInt(item.sorting_var);
                    if (i !== index &&
                        currentPos >= newPosition &&
                        currentPos < oldPosition) {
                        item.sorting_var = (currentPos + 1).toString();
                    }
                });
            } else {
                // Moving to a higher position (e.g., from 2 to 5)
                // Decrement positions that are > oldPosition and <= newPosition
                updatedFormat.forEach((item, i) => {
                    const currentPos = parseInt(item.sorting_var);
                    if (i !== index &&
                        currentPos > oldPosition &&
                        currentPos <= newPosition) {
                        item.sorting_var = (currentPos - 1).toString();
                    }
                });
            }

            // Ensure all positions are unique and sequential
            const sortedItems = [...updatedFormat].sort((a, b) =>
                parseInt(a.sorting_var) - parseInt(b.sorting_var)
            );

            // Reassign positions sequentially to fix any gaps
            sortedItems.forEach((item, i) => {
                item.sorting_var = (i + 1).toString();
            });

            return {
                ...prev,
                salaryPolicyDeductionsFormat: sortedItems
            };
        });
    };

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;

        const currentInput = inputRefs.current[index];
        const cursorPos = currentInput?.selectionStart;

        setFormData(prev => {
            const updatedSalaryPolicyDeductionsFormat = [...prev.salaryPolicyDeductionsFormat];


            if (name === "fixed_amount") {
                updatedSalaryPolicyDeductionsFormat[index] = {
                    ...updatedSalaryPolicyDeductionsFormat[index],
                    fixed_amount: value,
                    useFixedAmount: true,
                    usePercentage: false,
                    percentage: '',
                    percentage_of: []
                };
            } else if (name === "percentage") {
                updatedSalaryPolicyDeductionsFormat[index] = {
                    ...updatedSalaryPolicyDeductionsFormat[index],
                    percentage: value,
                    usePercentage: true,
                    useFixedAmount: false,
                    fixed_amount: ''
                };
            }
            // else if (name === "sorting_var") {
            //     updatedSalaryPolicyDeductionsFormat[index] = {
            //         ...updatedSalaryPolicyDeductionsFormat[index],
            //         [name]: value
            //     };

            //     setFocusedInput({
            //         sorting_var: value, // Track the new value
            //         cursorPos: cursorPos
            //     });
            // }
            else {
                updatedSalaryPolicyDeductionsFormat[index] = {
                    ...updatedSalaryPolicyDeductionsFormat[index],
                    [name]: value
                };
            }

            return {
                ...prev,
                salaryPolicyDeductionsFormat: updatedSalaryPolicyDeductionsFormat
            };
        });
    };

    const handleCheckboxChange = (type, index) => {
        setFormData(prev => {
            const updatedSalaryPolicyDeductionsFormat = [...prev.salaryPolicyDeductionsFormat];

            if (type === 'fixed') {
                updatedSalaryPolicyDeductionsFormat[index] = {
                    ...updatedSalaryPolicyDeductionsFormat[index],
                    useFixedAmount: !updatedSalaryPolicyDeductionsFormat[index].useFixedAmount,
                    usePercentage: updatedSalaryPolicyDeductionsFormat[index].useFixedAmount ? false : updatedSalaryPolicyDeductionsFormat[index].usePercentage,
                    fixed_amount: updatedSalaryPolicyDeductionsFormat[index].useFixedAmount ? '' : '0',
                    percentage: updatedSalaryPolicyDeductionsFormat[index].useFixedAmount ? updatedSalaryPolicyDeductionsFormat[index].percentage : '',
                    percentage_of: updatedSalaryPolicyDeductionsFormat[index].useFixedAmount ? updatedSalaryPolicyDeductionsFormat[index].percentage_of : []
                };
            } else if (type === 'percentage') {
                updatedSalaryPolicyDeductionsFormat[index] = {
                    ...updatedSalaryPolicyDeductionsFormat[index],
                    usePercentage: !updatedSalaryPolicyDeductionsFormat[index].usePercentage,
                    useFixedAmount: updatedSalaryPolicyDeductionsFormat[index].usePercentage ? false : updatedSalaryPolicyDeductionsFormat[index].useFixedAmount,
                    percentage: updatedSalaryPolicyDeductionsFormat[index].usePercentage ? '' : '0',
                    percentage_of: updatedSalaryPolicyDeductionsFormat[index].usePercentage ? [] : updatedSalaryPolicyDeductionsFormat[index].percentage_of,
                    fixed_amount: updatedSalaryPolicyDeductionsFormat[index].usePercentage ? updatedSalaryPolicyDeductionsFormat[index].fixed_amount : ''
                };
            }

            return {
                ...prev,
                salaryPolicyDeductionsFormat: updatedSalaryPolicyDeductionsFormat
            };
        });
    };

    const handleSelectChange = (selectedOptions, index) => {
        setFormData(prev => {
            const updatedSalaryPolicyDeductionsFormat = [...prev.salaryPolicyDeductionsFormat];

            updatedSalaryPolicyDeductionsFormat[index] = {
                ...updatedSalaryPolicyDeductionsFormat[index],
                percentage_of: selectedOptions ? selectedOptions.map(option => option.value) : [],
            };

            return {
                ...prev,
                salaryPolicyDeductionsFormat: updatedSalaryPolicyDeductionsFormat
            };
        });
    };

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "policy_name",
            "sub_company",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        const hasValidDeductions = formData.salaryPolicyDeductionsFormat.some(entry =>
            (entry.useFixedAmount && entry.fixed_amount) ||
            (entry.usePercentage && entry.percentage && entry.percentage_of.length > 0)
        );

        if (!hasValidDeductions) {
            newErrors.deductions = "Atleast 1 Deduction  is required";
        }

        // Validate each policy format
        formData.salaryPolicyDeductionsFormat.forEach((entry, index) => {
            if (entry.useFixedAmount && entry.usePercentage) {
                newErrors[`policy_${index}`] = "Cannot use both Fixed Amount and Percentage";
            } else if (entry.usePercentage && (!entry.percentage || entry.percentage_of.length === 0)) {
                newErrors[`policy_${index}`] = "Percentage and Related To are required when using Percentage";
            } else if (entry.useFixedAmount && !entry.fixed_amount) {
                newErrors[`policy_${index}`] = "Fixed Amount is required";
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // console.log("validateForm-", validateForm)
        if (!validateForm()) return;

        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            // Filter out entries that don't have either fixed amount or percentage set
            const validPolicyFormat = formData.salaryPolicyDeductionsFormat.filter(entry =>
                (entry.useFixedAmount && entry.fixed_amount) ||
                (entry.usePercentage && entry.percentage && entry.percentage_of.length > 0)
            );

            const payload = {
                ...formData,
                salaryPolicyDeductionsFormat: validPolicyFormat.map(entry => ({
                    ...entry,
                    // Remove the UI control fields before sending
                    useFixedAmount: undefined,
                    usePercentage: undefined
                }))
            };

            console.log("payload-", payload)
            const res = await axios.post(`${BASE_URL}/wfm/salarypolicywithcustomdeductions/`, payload);

            if (res.status === 200 || res.status === 201) {
                toast.success("Salary structure saved successfully.");
                getSalaryStructureFormat();
                handleClose();
            }
        } catch (err) {
            handleAllError(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };


    const getRelatedToOptions = (currentIndex) => {
        const currentPosition = parseInt(formData.salaryPolicyDeductionsFormat[currentIndex]?.sorting_var) || 0;

        return salaryStructureHeadings
            .filter(heading => {
                if (heading.id === formData.salaryPolicyDeductionsFormat[currentIndex]?.name) return false;
                const policy = formData.salaryPolicyDeductionsFormat.find(p => p.name === heading.id);
                if (!policy) return false;
                const headingPosition = parseInt(policy.sorting_var) || 0;
                return (
                    headingPosition < currentPosition &&
                    (
                        (policy.useFixedAmount && policy.fixed_amount) ||
                        (policy.usePercentage && policy.percentage && policy.percentage_of.length > 0)
                    )
                );
            })
            .sort((a, b) => parseInt(a.sorting_var) - parseInt(b.sorting_var))
            .map(i => ({ value: i.id, label: i.title }));
    };

    return (
        <>
            <button className="upload-svg flex-row" title="Add Salary Details" onClick={handleShow}>
                {showloading ? <div className="spinner-vsmall"></div> : <AddwithWhiteCircle />} Add Salary Details
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="five-sixth-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Add Salary Structure Format</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

                            <div className="form-flex-wrap">
                                <div className="flex-column">
                                    <label
                                        htmlFor="policy_name"
                                        className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                    >
                                        Format Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="policy_name"
                                        placeholder="Salary Policy Format Name"
                                        onChange={(e) => setFormData(prev => ({
                                            ...prev,
                                            policy_name: e.target.value
                                        }))}
                                        value={formData.policy_name}
                                        className={`form-input ${errors.policy_name ? "error" : inputState.policy_name ? "success" : ""}`}
                                    />
                                    <div>
                                        {errors.policy_name && (
                                            <span className="error-message font-size-text">{errors.policy_name}</span>
                                        )}
                                    </div>
                                </div>

                                {PERMISSION_AUTHORITY && (
                                    <div className="flex-column form-group-select">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>
                                        <br />
                                        <select
                                            name="sub_company"
                                            onChange={(e) => setFormData(prev => ({
                                                ...prev,
                                                sub_company: e.target.value
                                            }))}
                                            value={formData.sub_company}
                                            className={`form-input ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""}`}
                                        >
                                            <option value="">Select Sub Company</option>
                                            {SUB_COMPANIES.map((company) => (
                                                <option key={company.id} value={company.id}>{company.title}</option>
                                            ))}
                                        </select>
                                        <div>
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text">{errors.sub_company}</span>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* <div className="flex-row">
                                <label className="form-labels">
                                    Add Mode:
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        type="checkbox"
                                        id="toggle-requests"
                                        name="request_approval"
                                        checked={addMode === 'single'}
                                        onChange={() => setAddMode(addMode === 'bulk' ? 'single' : 'bulk')}
                                    />
                                    <label htmlFor="toggle-requests"></label>
                                </div>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <label className="form-labels">
                                    {addMode === 'bulk' ? 'Bulk' : 'Single'}
                                </label>
                            </div> */}

                            <div>
                                {errors.deductions && (
                                    <span className="error-message font-size-text">{errors.deductions}</span>
                                )}
                            </div>
                            <table className="table-css width-10vw">
                                <thead>
                                    <tr className="custom-table-head-tr">
                                        <th className="align-left width-5vw">Position</th>
                                        <th className="align-left width-5vw">Heading</th>
                                        <th className="align-center width-5vw">Type</th>
                                        <th className="align-center width-5vw">Fixed Amount</th>
                                        <th className="align-center" style={{ width: '0.5vw' }}>OR</th>
                                        <th className="align-center width-5vw">Percentage</th>
                                        <th className="align-center width-5vw">Related To</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.salaryPolicyDeductionsFormat
                                        .sort((a, b) => a.sorting_var - b.sorting_var)
                                        .map((entry, index) => {
                                            const heading = salaryStructureHeadings.find(t => t.id === entry.name);
                                            return (
                                                <React.Fragment key={index}>
                                                    <tr className="custom-table-head-td">
                                                        <td className="align-left">
                                                            {/* <input
                                                                ref={el => inputRefs.current[index] = el}
                                                                type="number"
                                                                name="sorting_var"
                                                                min={1}
                                                                value={entry.sorting_var}
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) => handleInputChange(e, index)}
                                                                onFocus={() => handleFocus(index)}
                                                                onBlur={() => setFocusedInput(null)} // Clear focus when leaving

                                                                className={`form-input-date ${errors[`policy_${index}`] ? 'is-invalid' : ''}`}
                                                                style={{ width: '60px' }} // Fixed width for better UX
                                                            /> */}
                                                            <select
                                                                ref={el => inputRefs.current[index] = el}
                                                                name="sorting_var"
                                                                value={entry.sorting_var}
                                                                onChange={(e) => handlePositionChange(e, index)}
                                                                onFocus={() => handleFocus(index)}
                                                                onBlur={() => setFocusedInput(null)}
                                                                className={`form-input-date ${errors[`policy_${index}`] ? 'is-invalid' : ''}`}
                                                                style={{ width: '60px' }}
                                                            >
                                                                {Array.from({ length: salaryStructureHeadings.length }, (_, i) => (
                                                                    <option key={i + 1} value={i + 1}>
                                                                        {i + 1}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </td>
                                                        <td className="align-left">{heading?.title || "Loading..."}</td>
                                                        <td className="align-center text-capitalize">
                                                            {heading?.salary_type || "Loading..."}
                                                        </td>
                                                        <td className="align-center">
                                                            <div className="checkbox-toggle">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`toggle-fixed-${index}`}
                                                                    checked={entry.useFixedAmount}
                                                                    onChange={() => {
                                                                        handleCheckboxChange('fixed', index);
                                                                        if (!entry.useFixedAmount) {
                                                                            setFormData(prev => {
                                                                                const updated = [...prev.salaryPolicyDeductionsFormat];
                                                                                updated[index] = {
                                                                                    ...updated[index],
                                                                                    usePercentage: false,
                                                                                    percentage: '',
                                                                                    percentage_of: []
                                                                                };
                                                                                return { ...prev, salaryPolicyDeductionsFormat: updated };
                                                                            });
                                                                        }
                                                                    }}
                                                                />
                                                                <label htmlFor={`toggle-fixed-${index}`}></label>
                                                            </div>
                                                        </td>
                                                        <td className="align-center">
                                                            <div style={{ width: '1vw' }} className="align-center width-5vw">OR</div>
                                                        </td>
                                                        <td
                                                            // colSpan={entry.usePercentage ? 1 : 2}
                                                            className="align-center">
                                                            <div className="flex-row justify-center align-center">
                                                                <div className="checkbox-toggle">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`toggle-percentage-${index}`}
                                                                        checked={entry.usePercentage}
                                                                        onChange={() => {
                                                                            handleCheckboxChange('percentage', index);
                                                                            if (!entry.usePercentage) {
                                                                                setFormData(prev => {
                                                                                    const updated = [...prev.salaryPolicyDeductionsFormat];
                                                                                    updated[index] = {
                                                                                        ...updated[index],
                                                                                        useFixedAmount: false,
                                                                                        fixed_amount: ''
                                                                                    };
                                                                                    return { ...prev, salaryPolicyDeductionsFormat: updated };
                                                                                });
                                                                            }
                                                                        }}
                                                                    />
                                                                    <label htmlFor={`toggle-percentage-${index}`}></label>
                                                                </div>
                                                                {entry.usePercentage && (
                                                                    <input
                                                                        type="number"
                                                                        name="percentage"
                                                                        min={0}
                                                                        max={100}
                                                                        placeholder="0%"
                                                                        value={entry.percentage}
                                                                        onWheel={(e) => e.target.blur()}
                                                                        onChange={(e) => handleInputChange(e, index)}
                                                                        className={`form-input-date ${errors[`policy_${index}`] ? 'is-invalid' : ''}`}
                                                                        style={{ width: '80px', marginLeft: '8px' }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="align-center">
                                                            {entry.usePercentage ? (
                                                                <Select
                                                                    isMulti
                                                                    name="percentage_of"
                                                                    value={getRelatedToOptions(index).filter(option =>
                                                                        entry.percentage_of?.includes(option.value)
                                                                    )}
                                                                    onChange={(selectedOptions) => handleSelectChange(selectedOptions, index)}
                                                                    options={getRelatedToOptions(index)}
                                                                    className={`width-15vw ${errors[`policy_${index}`] ? 'is-invalid' : ''}`}
                                                                    classNamePrefix="select"
                                                                    placeholder="Select Related To"
                                                                    styles={{
                                                                        control: (provided) => ({
                                                                            ...provided,
                                                                            minHeight: '50px',
                                                                            borderRadius: '10px',
                                                                            border: '1px solid #e3e3e3',
                                                                            margin: '10px 0px 20px 0px',
                                                                            color: '#4a4a4a',
                                                                            backgroundColor: '#f7f8fa',
                                                                            padding: '0px 10px',
                                                                        }),
                                                                        placeholder: (provided) => ({
                                                                            ...provided,
                                                                            color: '#4a4a4a',
                                                                        }),
                                                                        menu: (provided) => ({
                                                                            ...provided,
                                                                            borderRadius: '10px',
                                                                            marginTop: '0',
                                                                            zIndex: 999999,
                                                                        }),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 999999,
                                                                        }),
                                                                        input: (provided) => ({
                                                                            ...provided,
                                                                            color: '#4a4a4a',
                                                                        }),
                                                                        singleValue: (provided) => ({
                                                                            ...provided,
                                                                            color: '#4a4a4a',
                                                                        }),
                                                                    }}
                                                                />
                                                            ) :
                                                                // null
                                                                (
                                                                    <div className="flex-row justify-center">
                                                                        <div className="checkbox-toggle">
                                                                            <input
                                                                                type="checkbox"
                                                                                disabled
                                                                                checked={false}
                                                                                className="form-checkbox"
                                                                            />
                                                                            <label></label>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                        </td>
                                                    </tr>
                                                    {errors[`policy_${index}`] && (
                                                        <tr>
                                                            <td colSpan='7' className="align-center error-message font-size-text">
                                                                {errors[`policy_${index}`]}
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })}
                                </tbody>
                            </table>
                            <div className="button-models">
                                <button
                                    onClick={handleSubmit}
                                    className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
                                    disabled={loading}
                                >
                                    {loading ? 'Saving...' : 'Save Structure'}
                                </button>
                            </div>
                            <br />
                            <p className="error-message font-size-text">
                                {isSubmitted && Object.keys(errors).length > 0 && (
                                    Object.keys(errors).length > 5 ? (
                                        <h5 className="text-center">Please fill all mandatory fields!</h5>
                                    ) : (

                                        <h6 className="text-center">
                                            {Object.keys(errors).map((field) =>
                                                field.charAt(0).toUpperCase() + field.slice(1)
                                            ).join(', ') + ' are required!'}
                                        </h6>
                                    )
                                )}
                            </p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteSalaryStructurePolicyFormat = ({ i, getSalaryStructureFormat }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = async () => setShow(true);

    const [sortingVarBY, setSortingVarBY] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmitDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            const res = await axios.delete(`${BASE_URL}/wfm/salarypolicy/${i.id}/`);

            if (res.status === 200 || res.status === 201) {
                toast.success("Salary Format Deleted Successfully.");
                getSalaryStructureFormat();
                handleClose();
            }
        } catch (err) {
            handleAllError(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };



    return (
        <>
            <button title="Delete Salary Format" onClick={handleShow} className="model-delete-button">
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Salary Structure Format</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete salary structure format "{i.policy_name}"

                        <div className="button-models">
                            <button className="model-button font-weight500 model-button-cancel" onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleSubmitDelete}
                                className="model-button font-weight500 model-button-delete"
                                disabled={loading}
                            >
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

const ViewSalaryPolicyFormatDeductions = ({ i, getSalaryStructureFormat, buttonDisplayIcon = 'Eye', actionButtons = false }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [sortingVarBY, setSortingVarBY] = useState(false);

    return (
        <>
            <ButtonVariants
                buttonDisplay={buttonDisplayIcon}
                buttonDisplayTitle={"View Salary Policy Format"}
                handleShow={handleShow}
            />

            <Modal show={show} onHide={handleClose} dialogClassName="three-fourth-modal">
                <Modal.Header closeButton className="modal-header-custom">
                    <div className="d-flex flex-row justify-between w-100">
                        <Modal.Title className="mb-2">
                            <span className="title-text">Salary Policy Format: "{i.policy_name}"</span>
                        </Modal.Title>
                        <div className="d-flex align-items-center ">
                            <div className="d-flex align-items-center">
                                <label className="sort-label me-2">Sort By:</label>
                                <span className="sort-method">
                                    {sortingVarBY ? "Slip" : "Structure"}
                                </span>
                            </div>
                            <hr className="field-cont-hr" />
                            <div className="checkbox-toggle">
                                <input
                                    type="checkbox"
                                    id="View-salary-format-toggle"
                                    name="show_emp_data"
                                    checked={sortingVarBY}
                                    onChange={() => setSortingVarBY(!sortingVarBY)}
                                />
                                <label htmlFor="View-salary-format-toggle"></label>
                            </div>
                            <hr className="field-cont-hr" />
                        </div>
                    </div>

                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <table className="table-css width-10vw">
                                <thead>
                                    <tr className="custom-table-head-tr">
                                        <th className="align-left width-5vw">Position</th>
                                        <th className="align-left width-5vw">Heading</th>
                                        <th className="align-center width-5vw">Type</th>
                                        <th className="align-center width-5vw">Amount</th>
                                        <th className="align-center" style={{ width: '0.5vw' }}>OR</th>
                                        <th className="align-center width-5vw">Percentage</th>
                                        <th className="align-center width-5vw">Related To</th>
                                        {actionButtons && <th className="align-center width-5vw">Action</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {i.custom_deductions
                                        ?.sort((a, b) =>
                                            sortingVarBY
                                                ? a.name_sorting_var - b.name_sorting_var
                                                : a.sorting_var - b.sorting_var
                                        )
                                        .map((deduction, index) => (
                                            <tr className="custom-table-head-td" key={index}>
                                                <td className="align-left">{sortingVarBY ? deduction.name_sorting_var : deduction.sorting_var}</td>
                                                <td className="align-left">{deduction.name_title}</td>
                                                <td className="align-center text-capitalize">
                                                    {deduction.name_type}
                                                </td>
                                                <td className="align-center">
                                                    {/* {deduction.fixed_amount ? (Number(deduction.fixed_amount) === 0 && `Variable ${deduction.fixed_amount}`) : '-'} */}
                                                    {deduction.fixed_amount ? (Number(deduction.fixed_amount) === 0 && `Variable`) : '-'}
                                                </td>
                                                <td className="align-center">
                                                    <div style={{ width: '1vw' }} className="align-center width-5vw">OR</div>
                                                </td>
                                                <td className="align-center">
                                                    {deduction.percentage ?
                                                        `${parseFloat(deduction.percentage) % 1 === 0 ?
                                                            parseFloat(deduction.percentage).toFixed(0)
                                                            : parseFloat(deduction.percentage).toFixed(2)}%`
                                                        : '-'}
                                                </td>
                                                <td className="align-leftt width-10vw">
                                                    {deduction.percentage_of.length === 0 ?
                                                        <div className="align-center">-</div> :
                                                        <ul style={{ paddingLeft: '0' }}>
                                                            {deduction.percentage_of.map((data, idx) => (
                                                                <li key={idx}>
                                                                    <span className="text-capitalize">
                                                                        {data.name_title}
                                                                    </span>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    }
                                                </td>
                                                {actionButtons &&
                                                    <td className="align-center ">
                                                        <div className="flex-row ">
                                                            <UpdateCustomDeductionPolicy
                                                                i={deduction}
                                                                deductionData={i.custom_deductions}
                                                                getSalaryStructureFormat={getSalaryStructureFormat}
                                                            />
                                                            <DeleteCustomDeductionPolicy
                                                                i={deduction}
                                                                getSalaryStructureFormat={getSalaryStructureFormat}
                                                            />
                                                        </div>
                                                    </td>}
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

const UpdateCustomDeductionPolicy = ({ i, deductionData, getSalaryStructureFormat }) => {
    const [formData, setFormData] = useState({
        name: i.id,
        salary_policy: "",
        salary_type: i.salary_type,
        percentage: '',
        percentage_of: [],
        fixed_amount: '',
    });
    const [show, setShow] = useState(false);
    const [buffer, setBuffering] = useState(false);
    const [selectedPercentageOf, setSelectedPercentageOf] = useState([]);
    const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);

    const handleShow = () => {
        getAllSalaryRelatedData();

        const transformedData = {
            ...i,
            percentage_of: Array.isArray(i.percentage_of) ? i.percentage_of.map(item => ({
                value: item.name_title,
                label: item.name_title,
            })) : [],
        };

        setFormData(transformedData);
        setSelectedPercentageOf(transformedData.percentage_of);
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
    };

    const getAllSalaryRelatedData = async () => {
        setBuffering(true);
        try {
            const headings = await axios.get(`${BASE_URL}/wfm/salaryHeadingbysubcompany/${sessionStorage.getItem("company_id")}/`);
            setSalaryStructureHeadings(headings.data);
        } catch (err) {
            handleAllError(err);
        } finally {
            setBuffering(false);
        }
    };

    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSelectChange = (selectedOptions) => {
        setSelectedPercentageOf(selectedOptions);
        setFormData({
            ...formData,
            percentage_of: selectedOptions ? selectedOptions.map(option => ({
                value: option.value,
                label: option.label
            })) : [],
        });
    };

    const [loading, setLoading] = useState(false);
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        const updatedFormData = {
            ...formData,
            percentage_of: formData.percentage_of.map(item => item.label),
        };

        try {
            let ress = await axios.put(`${BASE_URL}/wfm/customdeductionpolicyupdate/${i.id}/`, updatedFormData);
            if (ress.status === 200 || ress.status === 201) {
                toast.success("Updated Deduction");
                await getAllSalaryRelatedData();
                await getSalaryStructureFormat();
                handleClose();
            }
        } catch (err) {
            handleAllError(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    // Get current item's sorting_var
    const currentItem = deductionData.find(item => item.id === i.id);
    const currentSortingVar = currentItem?.sorting_var || 0;

    // Filter options based on sorting_var
    const relatedToOptionsnew = deductionData
        .filter(item => {
            // Exclude current item
            if (item.id === i.id) return false;

            // Only include items with sorting_var less than current item
            return item.sorting_var < currentSortingVar;
        })
        .sort((a, b) => a.sorting_var - b.sorting_var)
        .map(item => {
            // Find the corresponding heading for display name
            const heading = salaryStructureHeadings.find(h => h.id === item.name);
            return {
                value: heading?.title || item.name,
                label: heading?.title || item.name
            };
        });

    const relatedToOptions = deductionData
        .filter(item => item.id !== formData.id)
        .filter(item => Number(item.sorting_var) < Number(formData.sorting_var))
        .sort((a, b) => a.sorting_var - b.sorting_var)
        .map(i => ({ value: i.name_title, label: i.name_title }));


    // console.log('relatedToOptions-1', relatedToOptions)
    // console.log('formData-1', formData)
    // console.log('deductionData-1', deductionData)
    // console.log('salaryStructureHeadings-1', salaryStructureHeadings)
    return (
        <div>
            <>
                <button title='Update Deduction' className='model-edit-button-ml' onClick={handleShow}>
                    <UpdatePencil />
                </button>
                <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
                    <Modal.Header closeButton>
                        <Modal.Title>Update Deduction of : "{salaryStructureHeadings?.find(t => t.id === formData.name)?.title} ({salaryStructureHeadings?.find(t => t.id === formData.name)?.salary_type})"</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
                        <form className="register-form">
                            <div className="">
                                {formData.percentage || formData.percentage_of.length > 0 ? "" :
                                    <div className="flex-column">
                                        <label className="form-labels  font-weight500 font-size-subheading">Fixed Amount<span className="required">*</span></label>
                                        <input
                                            type="number"
                                            name="fixed_amount"
                                            placeholder="Fixed Amount"
                                            min={0}
                                            value={formData.fixed_amount}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.fixed_amount ? 'is-invalid' : ''}`}
                                        />
                                        {errors.fixed_amount && <div className="error-message font-size-text">{errors.fixed_amount}</div>}
                                    </div>
                                }
                                {formData.fixed_amount ? "" :
                                    <>
                                        <div className="flex-column">
                                            <label className="form-labels  font-weight500 font-size-subheading">Percentage of Amount<span className="required">*</span></label>
                                            <input
                                                type="number"
                                                name="percentage"
                                                placeholder="Percentage of Amount"
                                                min={0}
                                                value={formData.percentage}
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.percentage ? 'is-invalid' : ''}`}
                                            />
                                            {errors.percentage && <div className="error-message font-size-text">{errors.percentage}</div>}
                                        </div>
                                        <div title="Related To" className="flex-column ">
                                            <label className="form-labels  font-weight500 font-size-subheading">Related To<span className="required">*</span></label>
                                            <Select
                                                isMulti
                                                name="percentage_of"
                                                value={selectedPercentageOf}
                                                onChange={handleSelectChange}
                                                options={relatedToOptions}
                                                className={`width-15vw ${errors.percentage_of ? 'is-invalid' : ''}`}
                                                classNamePrefix="select"
                                                placeholder="Select Related To"
                                                isDisabled={!!formData.fixed_amount}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '33vw',
                                                        minHeight: '50px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #e3e3e3',
                                                        margin: '10px 0px 20px 0px',
                                                        color: '#4a4a4a',
                                                        backgroundColor: '#f7f8fa',
                                                        padding: '0px 10px',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        width: '33vw',
                                                        borderRadius: '10px',
                                                        marginTop: '0',
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                }}
                                            />
                                            {errors.percentage_of && <div className="error-message font-size-text">{errors.percentage_of}</div>}
                                        </div>
                                    </>
                                }
                            </div>
                        </form>
                        {errors.mixed && <div className="error-message font-size-text">{errors.mixed}</div>}
                        <div className="button-models">
                            <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                                Cancel
                            </button>
                            <button className="model-button  font-weight500  model-button-leave font-size-heading" onClick={handleFormSubmit} disabled={loading}>
                                {loading ? 'Updating...' : 'Update'}
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </>
        </div>
    );
};

const DeleteCustomDeductionPolicy = ({ i, deductionData, getSalaryStructureFormat }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let response = await axios.delete(`${BASE_URL}/wfm/customdeductionpolicyupdate/${i.id}/`);
            if (response.status === 200 || response.status === 201) {
                toast.success("Deleted Deduction Successfully");
                await getSalaryStructureFormat();
                handleClose();
            }
        } catch (err) {
            handleAllError(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button title='Delete Deduction' className='model-delete-button' onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Custom Deduction: "{i.name_title}"</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
                    <form className="register-form">
                        <div className="">
                            {i.percentage || i.percentage_of?.length > 0 ? "" :
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">Amount:</label>
                                    <div className='form-labels justify-center'>
                                        {/* {i?.fixed_amount} */}
                                        Variable
                                    </div>
                                </div>
                            }
                            {i.fixed_amount ? "" :
                                <>
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">Percentage:</label>
                                        <div className='form-labels justify-center'>
                                            {i?.percentage}%
                                        </div>
                                    </div>
                                    <div title="Related To" className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">Related To:</label>
                                        <ul>
                                            {i?.percentage_of?.map((item, index) => (
                                                <li key={index}>
                                                    {item?.name_title}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </>
                            }
                        </div>
                    </form>
                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            className="model-button font-weight500 model-button-delete font-size-heading"
                            onClick={handleFormSubmit}
                            disabled={loading}
                        >
                            {loading ? 'Deleting...' : 'Delete'}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export {
    PayrollSalaryStructureFormatBackup,
    PayrollSalaryStructureFormat,
    EmployeePayrollSalaryStructure,

    // UploadSalaryDataBulk,
    // UpdateSalaryDataBulk,

    BulkUpdateSalaryDataWithLog,
    RunPayRollWithLog,
    AddSalaryStructurePolicyFormat,
    DeleteSalaryStructurePolicyFormat,
    ViewSalaryPolicyFormatDeductions,
    PayrunOperationResultModal,

    // needs testing
    BulkApiResultSummaryModal,
    // testing in progress
    MultipleBulkApiResultSummaryModal,
};
